import React from "react"

export var AC = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#012169" d="M0 0h513v342H0z" />
    <path
      fill="#FFF"
      d="M440.1 181.1c-.1 39.2-6.4 81.4-57.4 101.5-51.1-20.1-57.3-62.3-57.4-101.5h114.8z"
    />
    <path
      fill="#1B81B6"
      d="M439.6 197.7c-2.8 34.9-12.4 67.4-57 85-44.4-17.6-54.5-51.2-56.9-84.9"
    />
    <path
      fill="#FFF"
      d="M437.8 214.1c-3.2 24.3-16.7 53.5-55.1 68.6-38.4-15.1-50.5-42.5-55.1-68.4"
    />
    <path
      fill="#1B81B6"
      d="M434.2 230.3c-5.7 17.7-19.3 39.4-51.3 52.8-32-12.6-45.2-33.8-51.4-53"
    />
    <path
      fill="#FFF"
      d="M426.7 246.9c-6.5 11.3-17.7 25.4-44 35.9-27.5-11.5-37.4-25.3-44-36.1"
    />
    <path
      fill="#1B81B6"
      d="M412.4 265.1c-8.1 7.2-12 11.2-29.6 17.9-20.1-7.9-22.6-11.6-29.2-17.5"
    />
    <path
      fill="#288549"
      d="M383.3 231.6c-.2-.2-27.9 35.7-27.9 35.7-1.8-1.3-10-9.5-13.3-15l41.3-50.1 40.2 49.7c-3.9 6.5-11.4 13.6-13.2 15M382.6 85.3l-26.5 45h53z"
    />
    <path
      d="M275.9 223.6c3.6-26.7 13.5-47.3 22.1-46.2s12.6 23.7 9 50.4-13.5 47.3-22.1 46.2c-8.6-1.2-12.6-23.7-9-50.4zm191.2-45.9c8.6-1.2 18.5 19.5 22.1 46.2s-.4 49.2-9 50.4-18.5-19.6-22.2-46.3c-3.6-26.6.5-49.2 9.1-50.3z"
      fill="#F0955D"
    />
    <path
      d="M296.4 162c2.4-6 7.4-9.7 11-8.2 3.7 1.5 4.7 7.5 2.3 13.5s-7.4 9.7-11 8.2c-3.6-1.5-4.7-7.5-2.3-13.5zm-8 109.2c.9-6.2 3.1-11.1 4.9-10.8s2.5 5.5 1.6 11.8c-.9 6.2-3.1 11.1-4.9 10.8s-2.5-5.5-1.6-11.8zm10.6-12.8c1.8-.1 3.6 4.7 3.9 10.8s-.9 11.1-2.7 11.2c-1.8.1-3.6-4.7-3.9-10.8-.3-6.1.9-11.1 2.7-11.2zm10.5-70c2.1-.8 6.1 4.2 8.8 11.2 2.8 7 3.3 13.4 1.2 14.2-2.1.8-6.1-4.2-8.8-11.2-2.8-7-3.3-13.4-1.2-14.2zm6.5-14.1c7-2.8 13.4-3.3 14.2-1.2.8 2.1-4.2 6.1-11.2 8.8-7 2.8-13.4 3.3-14.2 1.2-.9-2.1 4.2-6 11.2-8.8zm141.6-20.2c3.7-1.5 8.6 2.2 11 8.2 2.4 6 1.4 12.1-2.3 13.5-3.7 1.5-8.6-2.2-11-8.2-2.4-6-1.3-12.1 2.3-13.5zm14.2 106.5c1.8-.3 4 4.6 4.9 10.8.9 6.2.2 11.5-1.6 11.8-1.8.3-4-4.6-4.9-10.8-1-6.3-.2-11.5 1.6-11.8zm-9.6 8.8c.3-6.1 2.1-10.9 3.9-10.8 1.8.1 3 5.1 2.7 11.2-.3 6.1-2.1 10.9-3.9 10.8-1.8-.1-3-5.1-2.7-11.2zm-15.5-69.7c2.8-7 6.7-12.1 8.8-11.2 2.1.8 1.6 7.2-1.2 14.2-2.8 7-6.7 12.1-8.8 11.2s-1.6-7.2 1.2-14.2zm-11.8-26.5c.8-2.1 7.2-1.6 14.2 1.2 7 2.8 12.1 6.7 11.2 8.8-.8 2.1-7.2 1.6-14.2-1.2-7-2.7-12.1-6.7-11.2-8.8z"
      fill="#EADFD5"
    />
    <path
      fill="#B0C6CC"
      d="M373.3 130.3 356.1 155l17.8 26.1H396l4.7-25.4-5.4-25.4z"
    />
    <path fill="#012169" d="M0 0h256.5v171H0z" />
    <g fill="#FFF">
      <path d="M256.5 0v30.6l-45.3 25.2h45.3v59.4h-59.2l59.2 32.9V171h-26.7l-73.7-40.9V171h-55.7v-48.7L12.8 171H0v-30.6l45.3-25.2H0V55.8h59.2L0 22.9V0h26.7l73.7 40.9V0h55.7v48.7L243.7 0z" />
      <path d="M156.1 115.2 256.5 171v-15.8l-72-40zm-55.7-59.4L0 0v15.8l72 40z" />
    </g>
    <g fill="#D80027">
      <path d="M144.3 0h-32.1v69.5H0v32h112.2V171h32.1v-69.5h112.2v-32H144.3z" />
      <path d="M156.1 115.2 256.5 171v-15.8l-72-40zm-84.1 0-72 40V171l100.4-55.8zm28.4-59.4L0 0v15.8l72 40zm84.1 0 72-40V0L156.1 55.8z" />
    </g>
  </svg>
)

export var AD = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#FFDA44" d="M0 0h513v342H0z" />
    <path fill="#0052B4" d="M0 0h171v342H0z" />
    <path fill="#D80027" d="M342 0h171v342H342zM198.9 113.6H256v64.8h-57.1z" />
    <path
      d="M267.6 113.6v64.7m16.6-64.7v64.7m16.6-64.7v64.7"
      stroke="#D80027"
      strokeWidth={7}
    />
    <path
      d="M247.4 178.4v64.7m-13.3-64.7v64.7m-13.3-64.6v53.9m-13.7-53.9v47.1"
      stroke="#D80027"
      strokeWidth={5}
    />
    <path fill="#FFDA44" d="m199.9 146 27.6-32.4 28.5 32.3-28.1 32.4z" />
    <path
      fill="#BC8B00"
      d="M182.2 95.9v92.2c0 34.3 27.3 54.2 48.6 64.5-.8 1.4 25.1 8.3 25.1 8.3s25.9-6.9 25.1-8.3c21.4-10.3 48.6-30.1 48.6-64.5V95.9H182.2zm129.9 92.2c0 16.9-10 29.4-32.8 43.9-8.6 5.5-17.5 9-23.3 11-5.8-2-14.7-5.5-23.3-11-22.8-14.5-32.8-28-32.8-43.9v-74.5h112.2v74.5z"
    />
    <path
      fill="#D80027"
      d="M264.4 188.9h29.5v8.6h-29.5zm0 17.6h29.5v8.6h-29.5z"
    />
  </svg>
)

export var AE = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#FFF" d="M0 0h513v342H0z" />
    <path fill="#009e49" d="M0 0h513v114H0z" />
    <path d="M0 228h513v114H0z" />
    <path fill="#ce1126" d="M0 0h171v342H0z" />
  </svg>
)

export var AF = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#DB3E00" d="M0 0h513v342H0z" />
    <path fill="#479900" d="M331 0h182v342H331z" />
    <path d="M0 0h181.8v342H0z" />
    <path
      fill="#FFF"
      d="M256 126.7c-19.4 0-35.2 15.8-35.2 35.2v52.8h70.4v-52.8c0-19.5-15.8-35.2-35.2-35.2z"
    />
    <path
      fill="#FFF"
      d="M256 84.3c-47.7 0-86.4 38.7-86.4 86.4S208.3 257 256 257s86.4-38.7 86.4-86.4-38.7-86.3-86.4-86.3zm0 157.7c-39.4 0-71.4-32-71.4-71.4 0-39.4 32-71.4 71.4-71.4 39.4 0 71.4 32 71.4 71.4 0 39.5-32 71.4-71.4 71.4z"
    />
  </svg>
)

export var AG = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path d="M0 0h513v342H0z" />
    <path
      fill="#0072c6"
      d="M88.8 136.5c-2.2 12.9-3.4 26.2-3.4 39.8 0 13.6 1.2 27 3.4 39.8L256 228.3l167.2-12.1c2.2-12.9 3.4-26.2 3.4-39.8s-1.2-27-3.4-39.8"
    />
    <path
      fill="#FFF"
      d="M423.2 219H88.8c15.8 69.8 84.7 122.3 167.2 122.3S407.4 288.8 423.2 219z"
    />
    <path
      fill="#FFDA44"
      d="M365.9 136.5H146.1l44.9-21.1-23.9-43.5 48.8 9.4L222 32l34 36.2L290 32l6.1 49.3 48.8-9.4-23.9 43.5z"
    />
    <g fill="#ce1126">
      <path d="M256.5 342 0 0v342z" />
      <path d="M513 342V0L256 342z" />
    </g>
  </svg>
)

export var AI = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#012169" d="M0 0h513v342H0z" />
    <path
      fill="#FFF"
      d="M454.8 265.38c7.94-10.93 13.24-24.27 13.24-40.42V104.89a59.754 59.754 0 0 1-36.02 12.01c-19.64 0-37.07-9.43-48.03-24.01-10.95 14.58-28.39 24.01-48.03 24.01-13.52 0-25.99-4.47-36.02-12v120.06c0 16.16 5.3 29.5 13.24 40.42H454.8z"
    />
    <path
      fill="#9cf"
      d="M310.23 260.98C332.65 296.96 384 309 384 309s51.35-12.04 73.77-48.02H310.23z"
    />
    <g fill="#f90">
      <path d="M396.66 172.21c.32 1.42 8.72 10.17 17.56 20.15 1.39 1.57-8.74 12.63-6.91 12.59 4.75-.12 19.27-17.26 19.34 6.65.05 15.94-30 27.51-30 27.51h17.47l.65 14.96s4.97-13.34 7.59-16.57c8.1-9.97 20.18-30.07 34.59-27.1 14.41 2.97-13.66-13.92-13.66-13.92s-5.2-15.19-16.63-16.97c-10.06-1.57-14.29-2.51-26.64-7.3-1.68-.65-3.88-2.32-3.36 0z" />
      <path d="M359.69 198.69c1.07-.99 4.46-12.63 8.69-25.28.67-1.99 15.31 1.27 14.35-.3-2.47-4.06-24.58-8.08-3.9-20.08 13.79-8 38.82 12.27 38.82 12.27l-8.72-15.14 12.64-8.03s-14.05 2.35-18.14 1.69c-12.68-2.04-36.13-2.48-40.75-16.45-4.62-13.97-5.25 18.79-5.25 18.79s-10.56 12.08-6.4 22.88c3.66 9.5 4.96 13.64 6.97 26.73.29 1.79-.06 4.53 1.69 2.92z" />
      <path d="M395.67 219.87c-1.39-.43-13.16 2.49-26.22 5.18-2.06.42-6.59-13.88-7.47-12.26-2.27 4.17 5.36 25.31-15.41 13.45-13.84-7.91-8.89-39.73-8.89-39.73l-8.71 15.14-13.29-6.9s9.09 10.96 10.57 14.84c4.6 11.99 16 32.49 6.24 43.49-9.76 11.01 18.88-4.9 18.88-4.9s15.76 3.07 23-5.96c6.38-7.94 9.3-11.14 19.61-19.45 1.43-1.12 3.97-2.19 1.69-2.9z" />
    </g>
    <path fill="#012169" d="M0 0h256.5v171H0z" />
    <g fill="#FFF">
      <path d="M256.5 0v30.6l-45.3 25.2h45.3v59.4h-59.2l59.2 32.9V171h-26.7l-73.7-40.9V171h-55.7v-48.7L12.8 171H0v-30.6l45.3-25.2H0V55.8h59.2L0 22.9V0h26.7l73.7 40.9V0h55.7v48.7L243.7 0z" />
      <path d="M156.1 115.2 256.5 171v-15.8l-72-40zm-55.7-59.4L0 0v15.8l72 40z" />
    </g>
    <g fill="#D80027">
      <path d="M144.3 0h-32.1v69.5H0v32h112.2V171h32.1v-69.5h112.2v-32H144.3z" />
      <path d="M156.1 115.2 256.5 171v-15.8l-72-40zm-84.1 0-72 40V171l100.4-55.8zm28.4-59.4L0 0v15.8l72 40zm84.1 0 72-40V0L156.1 55.8z" />
    </g>
  </svg>
)

export var AL = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90 60" {...rest}>
    {title && <title>{title}</title>}
<path fill="#ED2024" d="M0 0h90v60H0z" />
    <path
      fill="#212121"
      d="M32.5 12.2v16l7.1 2.5-5 4.9 2.4 3 5.3-5.5 1.2 2.3-3 4.9 3.6 5.6-1.8 2.6 2.8 3.6 2.7-3.7-1.5-2.6 3-5.8-2.7-4.6 1.2-2.3 5.2 5.5 2.5-2.9-5.2-5.1 7.2-2.6V12.2l-5.2 1.9-.1 3.8-3.3.3v-2.6l1.7-2.3 5.6-2.2-2.3-.4 1.4-1.2.9.4-.8-1.4L54 9l-1-1.1L47.5 9l1.4 1.1-3.8 4.9-3.8-4.8 1.3-1.1-5-1.2L36.2 9l-1.5-.4-.8 1.4.9-.6 1.6 1.1-2.3.5 5.5 2 1.6 2.3v2.9l-3.3-.3v-3.6z"
    />
    <path
      d="M26.2 25h6.4v2.5h-6.4zm0-4.1h6.4v2.7h-6.4zm0-4.2h6.4v2.6h-6.4zm0-4h6.4v2.5h-6.4zM57.4 25h6.4v2.5h-6.4zm0-4.1h6.4v2.7h-6.4zm0-4.2h6.4v2.6h-6.4zm0-4h6.4v2.5h-6.4zM53.4 36.1h6.4V38h-6.4zm-23.2 0h6.4V38h-6.4z"
      fill="#212121"
    />
  </svg>
)

export var AM = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#0052B4" d="M0 0h513v342H0z" />
    <path fill="#D80027" d="M0 0h513v114H0z" />
    <path fill="#FF9811" d="M0 228h513v114H0z" />
  </svg>
)

export var AO = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path d="M0 171h513v171H0z" />
    <path fill="#D80027" d="M0 0h513v171H0z" />
    <g fill="#FFDA44">
      <path d="m332.7 135.6 17.5-8.6-7.4-19-18.7 6.2zm-45.6-56 5.5-18.8-19.1-7.2-8 18zm29.4 23.2 12.2-15.3-14.9-13.9-14.2 13.6zm19.4 68.9 19.5-.8v-21.3l-22.9.2zm-12.6 38.1 18.8 5.5 7.3-19-18-8zm-29 32.4 14.9 12.7 14.4-14.4-13.1-14.7zm-47-147.7 9.8 19.9 21.9 3.3-15.9 15.5 3.6 21.9-19.6-10.4-19.7 10.2 3.8-21.9-15.8-15.5 22-3.1z" />
      <path d="m250.8 61.3-2.7 18.3c43.1 3.2 77 39.2 77 83.1 0 46-37.3 82.9-83.4 83.4-29.2.3-51.3-14.8-67-33.7l-13.9 12.3c15 19 40.8 39.9 80.9 39.9 56.3 0 101.9-45.6 101.9-101.9.1-53.2-40.7-96.9-92.8-101.4z" />
      <path
        fill="#000"
        d="m291.9 223.4-11.8 14s51.9 38.9 53.6 40.4c1.7 1.5 5.2 2 9.1-2.7 3.7-4.5 2.8-8.1.9-9.7-2-1.5-51.8-42-51.8-42z"
      />
      <path d="M206.1 157.2c-7.7 10.3-7.5 23.1 2.8 30.9 0 0 135.2 101.5 136.9 103 1.7 1.5 5.2 2 9.1-2.7 3.7-4.5 2.8-8.1.9-9.7-1.9-1.5-149.7-121.5-149.7-121.5zm47.7 99.1 7.3 18.2 19.5-6-4.8-19.1zm-40.4-3.7-2 19.5 20.1 3.6 4.5-19.1zm-35.7-21.2L167.4 248l16.4 12.1 12.5-15.2z" />
    </g>
  </svg>
)

export var AQ = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 744 496" {...rest}>
    {title && <title>{title}</title>}
<path fill="#3A7DCE" d="M0 0h744v496H0V0z" />
    <path
      fill="#fff"
      d="m120 125 90 63 54-14 23-81 61-36 92 14 105 55 6 90 34 12v92l-65 115-78 24-72-17 18-30-8-32-10 9-162-25-49-85 20-46-49-62z"
    />
  </svg>
)

export var AR = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#FFF" d="M0 0h512v342H0z" />
    <path fill="#338AF3" d="M0 0h512v114H0zm0 228h512v114H0z" />
    <circle
      fill="#FFDA44"
      stroke="#d6ab00"
      strokeWidth={5}
      cx={256.5}
      cy={171}
      r={40}
    />
  </svg>
)

export var AS = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#10338c" d="M0 0h513v342H0z" />
    <path fill="#D80027" d="M513 33 95.3 171 513 310.76V342L0 171 513 0z" />
    <path fill="#FFF" d="M513 287.18v24.58L81.72 171 513 30v24.16" />
    <path
      fill="#A2001D"
      d="m476.98 140.21-21.89 10.68-3.18-15.32 31.19-29.77s-9.42-40.65-13.75-44.98l-112.32 55.82-6.84 36.76-31.9 28.59-.4 34.2 34.29-22.76 67.23-2.66-1.51 38.11h22.23l11.9-44.64 31.55-24.61-6.6-19.42z"
    />
    <path
      fill="#EFC100"
      stroke="#231F20"
      strokeMiterlimit={10}
      d="m317.89 238.41-22.24-11.11 22.24-11.11h144.46v22.22z"
    />
  </svg>
)

export var AT = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#FFF" d="M0 114h513v114H0z" />
    <path fill="#D80027" d="M0 0h513v114H0zm0 228h513v114H0z" />
  </svg>
)

export var AU = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#00008b" d="M0 0h513v342H0z" />
    <path
      d="m188 212.6 11 22.9 24.7-5.7-11 22.8 19.9 15.8-24.8 5.6.1 25.4-19.9-15.9-19.8 15.9.1-25.4-24.8-5.6 19.9-15.8-11.1-22.8 24.8 5.7zm197.9 28.5 5.2 10.9 11.8-2.7-5.3 10.9 9.5 7.5-11.8 2.6v12.2l-9.4-7.6-9.5 7.6.1-12.2-11.8-2.6 9.5-7.5-5.3-10.9 11.8 2.7zm-48.6-116 5.2 10.9 11.8-2.7-5.3 10.9 9.5 7.5-11.8 2.7v12.1l-9.4-7.6-9.5 7.6.1-12.1-11.9-2.7 9.5-7.5-5.3-10.9L332 136zm48.6-66.2 5.2 10.9 11.8-2.7-5.3 10.9 9.5 7.5-11.8 2.7v12.1l-9.4-7.6-9.5 7.6.1-12.1-11.8-2.7 9.5-7.5-5.3-10.9 11.8 2.7zm42.5 49.7 5.2 10.9 11.8-2.7-5.3 10.9 9.5 7.5-11.8 2.6V150l-9.4-7.6-9.5 7.6v-12.2l-11.8-2.6 9.5-7.5-5.3-10.9 11.8 2.7zM398 166.5l4.1 12.7h13.3l-10.8 7.8 4.2 12.7-10.8-7.9-10.8 7.9 4.1-12.7-10.7-7.8h13.3z"
      fill="#FFF"
    />
    <path fill="#00008b" d="M0 0h256.5v171H0z" />
    <g fill="#FFF">
      <path d="M256.5 0v30.6l-45.3 25.2h45.3v59.4h-59.2l59.2 32.9V171h-26.7l-73.7-40.9V171h-55.7v-48.7L12.8 171H0v-30.6l45.3-25.2H0V55.8h59.2L0 22.9V0h26.7l73.7 40.9V0h55.7v48.7L243.7 0z" />
      <path d="M156.1 115.2 256.5 171v-15.8l-72-40zm-55.7-59.4L0 0v15.8l72 40z" />
    </g>
    <g fill="red">
      <path d="M144.3 0h-32.1v69.5H0v32h112.2V171h32.1v-69.5h112.2v-32H144.3z" />
      <path d="M156.1 115.2 256.5 171v-15.8l-72-40zm-84.1 0-72 40V171l100.4-55.8zm28.4-59.4L0 0v15.8l72 40zm84.1 0 72-40V0L156.1 55.8z" />
    </g>
  </svg>
)

export var AW = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 363 242" {...rest}>
    {title && <title>{title}</title>}
<path fill="#338AF3" d="M0 0h363v242H0z" />
    <path
      fill="#FFF"
      d="M57 96.9 14.7 78.2 57 59.6l18.6-42.2 18.6 42.2 42.3 18.6-42.3 18.7-18.6 42.2z"
    />
    <path
      fill="#f30028"
      d="m75.6 40.6 11.5 26.1 26.1 11.5-26.1 11.5-11.5 26.1-11.5-26.1L38 78.2l26.1-11.5z"
    />
    <path d="M0 152.2h363v15.7H0zm0 31.4h363v15.7H0z" fill="#FFDA44" />
  </svg>
)

export var AX = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#0052B4" d="M0 0h513v342H0z" />
    <path
      fill="#FFDA44"
      d="M513 210.9H202.2V342h-79.8V210.9H0v-79.8h122.4V0h79.8v131.1H513v61.2z"
    />
    <path
      fill="#D80027"
      d="M513 149.7v42.6H183.7V342H141V192.3H0v-42.6h141V0h42.7v149.7z"
    />
  </svg>
)

export var AZ = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#ef3340" d="M0 0h513v342H0z" />
    <path fill="#00b5e2" d="M0 0h513v114H0z" />
    <path fill="#509e2f" d="M0 228h513v114H0z" />
    <g fill="#FFF">
      <path d="M265.6 212.6c-23 0-41.6-18.6-41.6-41.6s18.6-41.6 41.6-41.6c7.2 0 13.9 1.8 19.8 5-9.2-9-21.9-14.6-35.8-14.6-28.3 0-51.2 22.9-51.2 51.2s22.9 51.2 51.2 51.2c13.9 0 26.6-5.6 35.8-14.6-5.9 3.2-12.6 5-19.8 5z" />
      <path d="m297.6 142.2 5.5 15.5 14.9-7.1-7.1 14.9 15.5 5.5-15.5 5.5 7.1 14.9-14.9-7.1-5.5 15.5-5.5-15.5-14.9 7.1 7.1-14.9-15.5-5.5 15.5-5.5-7.1-14.9 14.9 7.1z" />
    </g>
  </svg>
)

export var BA = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#10338C" d="M0 0h513v342H0z" />
    <path fill="#F6C500" d="M99.9 0h342v342" />
    <g fill="#FFF">
      <path d="M19.9 21.1 40.3 6.2 60.9 21 54 0H26.7z" />
      <path d="M92.3 25.5 84.4 1.3l-7.8 24.2H51.3l20.5 14.8-7.8 24 20.4-14.8L105 64.3l-7.9-24 20.5-14.9z" />
      <path d="m136.3 69.2-7.8-24-7.8 24H95.5l20.4 14.9-7.8 24 20.4-14.8 20.6 14.8-7.8-24 20.4-14.9z" />
      <path d="m179.4 112.3-7.8-24.1-7.8 24.1h-25.3l20.5 14.9-7.8 24 20.4-14.8 20.6 14.8-7.9-24 20.5-15z" />
      <path d="m222.5 155.3-7.8-24-7.8 24h-25.4l20.6 15-7.8 24 20.4-14.9 20.4 14.9-7.8-24 20.6-15z" />
      <path d="m265.6 198.4-7.8-24-7.8 24h-25.4l20.6 14.9-7.8 24.1 20.4-14.9 20.4 14.9-7.8-24.2 20.5-14.8z" />
      <path d="m308.7 241.5-7.9-24-7.8 24h-25.3l20.5 14.8-7.9 24.2 20.6-14.9 20.4 14.8-7.8-24.1 20.5-14.8z" />
      <path d="m351.7 284.6-7.8-24.2-7.8 24.2h-25.3l20.4 14.8-7.8 24.1 20.5-14.9 20.5 14.9-7.8-24.1 20.4-14.8z" />
      <path d="m387 303.5-7.9 24.1-25.3.1 19.8 14.3h26.6l19.9-14.4h-25.3z" />
    </g>
  </svg>
)

export var BB = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#ffc726" d="M0 0h513v342H0z" />
    <path d="M0 0h171v342H0zm342 0h171v342H342z" fill="#00267f" />
    <path d="m325.74 101.02-31.97 12.4c-.68 1.35-5.79 7.54-8.18 53.06h-17.05v-60.42L256 78.68l-12.54 27v60.8H226.4c-2.39-45.53-7.8-52.48-8.47-53.84l-31.68-11.63c.15.31 15.4 31.34 15.4 78.01v12.54h41.81v71.07h25.08v-71.07h41.81v-12.54c0-24.13 4.17-44.02 7.68-56.46 3.82-13.57 7.7-21.49 7.74-21.57l-.03.03z" />
  </svg>
)

export var BD = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#2d6e41" d="M0 85.331h513v342H0z" />
    <circle fill="#F40B32" cx={218.902} cy={256.5} r={115} />
  </svg>
)

export var BE = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#fdda25" d="M0 0h513v342H0z" />
    <path d="M0 0h171v342H0z" />
    <path fill="#ef3340" d="M342 0h171v342H342z" />
  </svg>
)

export var BF = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#3d944f" d="M0 0h513v342H0z" />
    <path fill="#ef2b2d" d="M0 0h513v171H0z" />
    <path
      fill="#FFDA44"
      d="m256 102.6 16.9 52h54.7l-44.2 32.2 16.8 52-44.2-32.1-44.2 32.1 16.8-52-44.2-32.2h54.7z"
    />
  </svg>
)

export var BG = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#00966e" d="M0 0h513v342H0z" />
    <path fill="#FFF" d="M0 0h513v114H0z" />
    <path fill="#d62612" d="M0 228h513v114H0z" />
  </svg>
)

export var BH = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#D80027" d="M0 0h513v342H0z" />
    <path
      fill="#FFF"
      d="m222.8 34.3-85.2 34.2 85.2 34.1-85.2 34.1 85.2 34.1-85.2 34.1 85.2 34.1-85.2 34.1 85.2 34.1-85.2 34.8H0V0h137.6z"
    />
  </svg>
)

export var BI = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#D80027" d="M0 0h513v342H0z" />
    <path
      d="M215.9 170.7 0 314.6V26.8zM513 26.8v287.8L297.1 170.7z"
      fill="#47a644"
    />
    <path
      fill="#0052B4"
      d="M513 26.8 296.1 170.7 513 314.6V342h-41.1L256 197.4 40.1 342H0v-27.4l215.9-143.9L0 26.8V0h40.1L256 143.9 471.9 0H513z"
    />
    <path
      fill="#FFF"
      d="M513 26.8 297.1 170.7 513 314.6V342h-40L256 197.4 39 342H0v-27.4l215.9-143.9L0 26.8V0h40.1L256 143.9 471.9 0H513z"
    />
    <circle fill="#FFF" cx={251.6} cy={170.7} r={100.2} />
    <path
      d="m251.4 103.6 7.4 12.9h14.8l-7.4 12.8 7.4 12.8h-14.8l-7.4 12.9-7.4-12.9h-14.8l7.4-12.8-7.4-12.8H244zm38.8 66.7 7.4 12.9h14.8L305 196l7.4 12.8h-14.8l-7.4 12.9-7.4-12.9h-14.9l7.4-12.8-7.4-12.8h14.9zm-77.2 0 7.4 12.9h14.9l-7.4 12.8 7.4 12.8h-14.9l-7.4 12.9-7.4-12.9h-14.8l7.4-12.8-7.4-12.8h14.8z"
      fill="#D80027"
      stroke="#47a644"
      strokeWidth={3}
    />
  </svg>
)

export var BJ = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#008751" d="M0 0h513v342H0z" />
    <path fill="#fcd116" d="M197 0h316v171H197z" />
    <path fill="#e8112d" d="M197 171h316v171H197z" />
  </svg>
)

export var BL = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#FFF" d="M0 0h513v342H0z" />
    <path
      d="M157.3 199.8s-9 43.9-19.3 40.4c-10.6-3.5-17.5-18.8-17.5-18.8L106 242.6s38.2 8.5 41 5.5c1.2-1.1 8.2-15.1 10.3-26.1v-22.2zm-56.1 60.5s-2.5 20.2-1.1 22.7c1.2 2.3 39.5 11.3 39.5 11.3s-25 16.5-29.7 20.5l-18.1-29.9-.7-24.6h10.1zm11.3-165.7s39.7 41.6 40.4 45.5c.7 3.7-4.2 3.2-4.2 3.2s-44.8-37.5-49.9-41.1c-5.4-3.5 13.7-7.6 13.7-7.6zm246.7 106.7s9 42.4 19.2 38.9c10.6-3.5 17.5-18.8 17.5-18.8l14.5 21.2s-37 8.5-39.8 5.5c-1.2-1.1-9.3-13.8-11.5-24.7l.1-22.1zm56 59s2.5 20.2 1.1 22.7c-1.2 2.3-39.5 11.3-39.5 11.3s25 16.5 29.7 20.5l18.1-29.9.7-24.6h-10.1zM403.9 94.6s-39.6 41.6-40.4 45.5c-.7 3.7 4.2 3.2 4.2 3.2s44.8-37.5 49.9-41.1c5.2-3.5-13.7-7.6-13.7-7.6z"
      fill="#E6BC00"
    />
    <path
      d="M99.4 104.7s17-.7 16.6-11.5c-.4-10.6-11.2-14.9-19.1-12.4-8 2.3-23 13.4-13.6 35.1 9.4 21.4 23.4 29.4 26.2 47.8 0 0-5.5 9.9-19.1.4-16.9-11.8-6.2-38.2-10.4-45-4.2-7.1-41-38.9-41-38.9s-30.2 39.4-18 74.9c17 49.2 51.7 32 64.6 36.8 0 0-42.1 62-49.6 67.1 0 0 24.1 8.3 47.8-18.8 0 0 5.8 9.7 7.1 20.2h10.3c4.8-26.2 51.5-64.3 49.9-82.3-1.8-21.3-49.2-49.5-51.7-73.4zM365.1 178c-1.6 18.1 45.1 56.1 49.9 82.3h10.3c1.2-10.4 7.1-20.2 7.1-20.2 23.7 27.1 47.8 18.8 47.8 18.8-7.4-5.1-49.6-67.1-49.6-67.1 12.9-4.8 47.7 12.4 64.6-36.8 12.2-35.6-18-74.9-18-74.9s-36.7 31.8-41 38.9c-4.2 6.7 6.5 33.2-10.4 45-13.7 9.5-19.1-.4-19.1-.4 2.8-18.4 16.8-26.4 26.2-47.8 9.4-21.6-5.7-32.8-13.6-35.1-8-2.5-18.8 1.8-19.1 12.4-.4 10.8 16.6 11.5 16.6 11.5-2.5 24-49.9 52.2-51.7 73.4z"
      fill="#ADADAD"
    />
    <path
      fill="#125ECC"
      d="M157.3 87.1h201.8v145.5c0 16.1-9.7 21.4-21.9 31.8l-45.9 39.4c-18.2 15.6-47.9 15.6-66.1 0l-46-39.4c-12.1-10.4-21.9-15.7-21.9-31.8V87.1z"
    />
    <path
      fill="#FFE600"
      d="M200.6 147.7c-8 0-14.4-6.4-14.4-14.4s6.4-14.4 14.4-14.4 14.4 6.4 14.4 14.4-6.5 14.4-14.4 14.4zm57.6-3c-8 0-14.4-6.4-14.4-14.4s6.4-14.4 14.4-14.4 14.4 6.4 14.4 14.4-6.4 14.4-14.4 14.4zm57.7 3c-8 0-14.4-6.4-14.4-14.4s6.5-14.4 14.4-14.4 14.4 6.4 14.4 14.4-6.5 14.4-14.4 14.4zM215 274.4c-8 0-14.4-6.5-14.4-14.4 0-8 6.4-14.4 14.4-14.4s14.4 6.4 14.4 14.4-6.5 14.4-14.4 14.4zm43.2 14.5c-8 0-14.4-6.5-14.4-14.4s6.4-14.4 14.4-14.4 14.4 6.5 14.4 14.4-6.4 14.4-14.4 14.4zm43.2-14.5c-8 0-14.4-6.5-14.4-14.4 0-8 6.5-14.4 14.4-14.4s14.4 6.4 14.4 14.4c.1 8-6.4 14.4-14.4 14.4z"
    />
    <path fill="#D60537" d="M157.3 175.4h201.8V233H157.3v-57.6z" />
    <path
      fill="#EACE00"
      d="M142.9 43.8s57.6-14.4 115.3-14.4 115.3 14.4 115.3 14.4l-14.4 57.7s-50.5-14.4-100.9-14.4-100.9 14.4-100.9 14.4l-14.4-57.7z"
    />
    <path
      fill="#7A6920"
      d="M258.2 72.7c-8 0-14.4-6.4-14.4-14.4s6.4-14.4 14.4-14.4 14.4 6.5 14.4 14.4-6.4 14.4-14.4 14.4zm57.7 5c-8 0-14.4-6.4-14.4-14.4s6.5-14.4 14.4-14.4 14.4 6.5 14.4 14.4-6.5 14.4-14.4 14.4zm-115.3 0c-8 0-14.4-6.4-14.4-14.4s6.4-14.4 14.4-14.4S215 55.3 215 63.2s-6.5 14.5-14.4 14.5z"
    />
    <circle fill="#FFF" cx={258.2} cy={204.2} r={16.9} />
  </svg>
)

export var BM = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#c8102e" d="M0 0h513v342H0z" />
    <path
      fill="#fff"
      stroke="#000"
      strokeWidth={2}
      d="M303.9 94.94v99.69c0 59.81 79.75 99.69 79.75 99.69s79.75-39.88 79.75-99.69V94.94H303.9z"
    />
    <path
      fill="#2F8F22"
      d="M436.37 254.44H330.93c23.13 25.08 52.72 39.88 52.72 39.88s29.59-14.8 52.72-39.88z"
    />
    <circle fill="#65B5D2" cx={383.65} cy={214.56} r={39.88} />
    <circle fill="#c8102e" cx={343.77} cy={194.63} r={19.94} />
    <circle fill="#c8102e" cx={423.52} cy={194.63} r={19.94} />
    <circle fill="#c8102e" cx={383.65} cy={154.75} r={19.94} />
    <path fill="#012169" d="M0 0h256.5v171H0z" />
    <g fill="#FFF">
      <path d="M256.5 0v30.6l-45.3 25.2h45.3v59.4h-59.2l59.2 32.9V171h-26.7l-73.7-40.9V171h-55.7v-48.7L12.8 171H0v-30.6l45.3-25.2H0V55.8h59.2L0 22.9V0h26.7l73.7 40.9V0h55.7v48.7L243.7 0z" />
      <path d="M156.1 115.2 256.5 171v-15.8l-72-40zm-55.7-59.4L0 0v15.8l72 40z" />
    </g>
    <g fill="#c8102e">
      <path d="M144.3 0h-32.1v69.5H0v32h112.2V171h32.1v-69.5h112.2v-32H144.3z" />
      <path d="M156.1 115.2 256.5 171v-15.8l-72-40zm-84.1 0-72 40V171l100.4-55.8zm28.4-59.4L0 0v15.8l72 40zm84.1 0 72-40V0L156.1 55.8z" />
    </g>
  </svg>
)

export var BN = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#FFDA44" d="M0 0h513v342H0z" />
    <path d="m0 193.74 513 127.19V214.26L0 97.08z" />
    <path fill="#FFF" d="M513 234.26v-86.67L0 20.41v86.67" />
    <g fill="#D80027" stroke="#231F20" strokeWidth={3} strokeMiterlimit={10}>
      <path d="M306.4 134.01a50.28 50.28 0 0 1 6.07 24.02c0 21.55-13.51 39.94-32.52 47.19v-59.51c5.7-1.19 10-6.37 10-12.59 6.9 0 12.5-5.75 12.5-12.85h-.42c6.9 0 12.91-5.75 12.91-12.85h-34.99V76.58l-14.99-27.71-15 27.71v30.84h-34.99c0 7.1 6.01 12.85 12.91 12.85h-.42c0 7.1 5.6 12.85 12.5 12.85 0 6.22 4.29 11.4 9.99 12.59v61.37c-22.09-5.39-38.48-25.3-38.48-49.05 0-8.7 2.2-16.88 6.07-24.02-10.96 11.21-17.72 26.53-17.72 43.44 0 34.32 27.82 62.15 62.15 62.15s62.15-27.83 62.15-62.15c0-16.91-6.77-32.24-17.72-43.44z" />
      <path d="M198.46 226.81s20.69 27.71 66.5 27.71 66.5-27.71 66.5-27.71l13.47 28.37s-21.03 27.71-79.97 27.71-79.97-27.71-79.97-27.71l13.47-28.37zm-69.22-93.63h20.88l24.93 27.26v73.45h-26.28v-68.37zm270.76 0h-20.88l-24.93 27.26v73.45h26.27v-68.37z" />
    </g>
  </svg>
)

export var BO = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#d52b1e" d="M0 0h513v114H0z" />
    <path fill="#f9e300" d="M0 114h513v114H0z" />
    <path fill="#007934" d="M0 228h513v114H0z" />
  </svg>
)

export var BQ_BO = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#FFF" d="M0 0h513v342H0z" />
    <path fill="#012a87" d="M0 342h513V0z" />
    <path fill="#f9d90f" d="M250.4 0H0v166.9z" />
    <path
      fill="#dc171d"
      d="m140.4 118.3 12.2 21.2h24.5l-12.3 21.1 12.3 21.2h-24.5L140.4 203l-12.2-21.2h-24.5l12.3-21.2-12.3-21.1h24.5z"
    />
    <circle
      fill="none"
      stroke="#000"
      strokeWidth={9}
      strokeMiterlimit={10}
      cx={140.4}
      cy={160.6}
      r={57.7}
    />
  </svg>
)

export var BQ_SA = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#DC171D" d="M512 342H0V.7h512V342z" />
    <path fill="#012A87" d="M512 342H0V171.3h512V342z" />
    <path fill="#FFF" d="M256 342 0 171.3 256 .7l256 170.7L256 342z" />
    <path
      fill="#F9D90F"
      d="m199.2 249.5 21.7-66.8-56.8-41.2h70.5L256 74.7l21.7 66.8h70.2l-56.8 41.2 21.7 66.8-56.8-41.3z"
    />
  </svg>
)

export var BQ_SE = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 900 600" {...rest}>
    {title && <title>{title}</title>}
<path d="M0 0h900v600H0z" fill="#dc171d" />
    <path d="M450 168.787 215.691 300 450 431.213 684.309 300z" fill="#fff" />
    <path
      d="M281.477 336.852V376h69.961l290.727-52.4V376h-93.668z"
      fill="#dc171f"
    />
    <path
      d="M188 288H20V20h418v128zm524 0h168V20H462v128zm-524 24H20v268h418V452zm524 0h168v268H462V452z"
      fill="#012a87"
    />
    <path
      d="m450 199.5 8.068 24.827h26.105l-21.12 15.346 8.067 24.827L450 249.157 428.88 264.5l8.066-24.827-21.119-15.345 26.105-.001z"
      fill="#f9d90f"
    />
    <path
      d="M281.477 336.852c2.712-8.848 8.614-12.77 16.594-10.995 4.94-18.73 27.739-22.07 36.786-12.857l22.273 22.37c4.837 2.251 12.207 3.095 17.326 3.095 6.33.1 5.621 3.005 10.91 3.106 14.096.27 51.143.458 57.857 0 2.75-.187 64.134-67.857 64.134-67.857 5.12-6.31 18.453-8.333 25.714-3.214 6.786 6.429 13.929 7.143 18.929 2.857 4.405-6.547 14.392-7.309 20.714-3.571l69.45 53.815L548.497 376H351.438l-69.96-39.148z"
      fill="#008830"
    />
  </svg>
)

export var BQ = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#FFF" d="M0 0h513v342H0z" />
    <path fill="#012a87" d="M0 342h513V0z" />
    <path fill="#f9d90f" d="M250.4 0H0v166.9z" />
    <path
      fill="#dc171d"
      d="m140.4 118.3 12.2 21.2h24.5l-12.3 21.1 12.3 21.2h-24.5L140.4 203l-12.2-21.2h-24.5l12.3-21.2-12.3-21.1h24.5z"
    />
    <circle
      fill="none"
      stroke="#000"
      strokeWidth={9}
      strokeMiterlimit={10}
      cx={140.4}
      cy={160.6}
      r={57.7}
    />
  </svg>
)

export var BR = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#009b3a" d="M0 0h513v342H0z" />
    <path fill="#fedf00" d="m256.5 19.3 204.9 151.4L256.5 322 50.6 170.7z" />
    <circle fill="#FFF" cx={256.5} cy={171} r={80.4} />
    <path
      fill="#002776"
      d="M215.9 165.7c-13.9 0-27.4 2.1-40.1 6 .6 43.9 36.3 79.3 80.3 79.3 27.2 0 51.3-13.6 65.8-34.3-24.9-31-63.2-51-106-51zm119 20.3c.9-5 1.5-10.1 1.5-15.4 0-44.4-36-80.4-80.4-80.4-33.1 0-61.5 20.1-73.9 48.6 10.9-2.2 22.1-3.4 33.6-3.4 46.8.1 89 19.5 119.2 50.6z"
    />
  </svg>
)

export var BS = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#ffc72c" d="M0 0h513v342H0z" />
    <path d="M0 0h513v114H0zm0 228h513v114H0z" fill="#00778b" />
    <path d="M256 171 0 342V0z" />
  </svg>
)

export var BT = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#FF7415" d="M0 0h513v342H0z" />
    <path fill="#FFDA44" d="M513 0H0v342" />
    <path
      fill="none"
      stroke="#FFF"
      strokeWidth={42}
      strokeMiterlimit={10}
      d="M128.7 255.5s35 54 67.3 32.4c56.9-37.9-68.9-108.6-2.9-152.6 58.3-38.8 76.6 103.5 137.6 62.8 59-39.3-64.7-111.4-9.2-148.4 33.4-22.2 67.1 32.6 67.1 32.6"
    />
  </svg>
)

export var BV = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#EF2B2D" d="M0 0h513v342H0z" />
    <path fill="#FFF" className="prefix__st1" d="M139.9 0h93.3v342h-93.3z" />
    <path fill="#FFF" className="prefix__st1" d="M0 119h513v104.1H0z" />
    <path fill="#002868" d="M163.2 0h46.6v342h-46.6z" />
    <path fill="#002868" d="M0 145h513v52H0z" />
  </svg>
)

export var BW = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#FFF" d="M0 0h513v342H0z" />
    <path d="M0 238h513v104H0zM0 0h513v104H0z" fill="#6da9d2" />
    <path d="M0 125.5h513v89.656H0z" />
  </svg>
)

export var BY = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#007C30" d="M0 0h513v342H0z" />
    <path fill="#CE1720" d="M0 230h513V0H0" />
    <path fill="#FFF" d="M100 230V0H0v342h513-413z" />
    <path
      d="M28 159.6 8.6 128.2 28 97.4l19.3 30.8zm44.6 0-19.3-31.4 19.3-30.8L92 128.2zM28 241.2 8.6 209.8 28 179l19.3 30.8zm44.6 0-19.3-31.4L72.6 179 92 209.8z"
      fill="#CE1720"
    />
    <path
      d="m28 73.8-16.1-26L28 22.2l16 25.6zm44.6 0-16-26 16-25.6 16.1 25.6zM28 318l-16.1-26.1L28 266.3l16 25.6zm44.6 0-16-26.1 16-25.6 16.1 25.6z"
      fill="none"
      stroke="#CE1720"
      strokeWidth={7}
    />
  </svg>
)

export var BZ = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#003e87" d="M0 0h513v342H0z" />
    <circle fill="#FFF" cx={260.9} cy={170.9} r={118.9} />
    <circle
      fill="none"
      stroke="#6DA544"
      strokeWidth={18}
      strokeMiterlimit={10}
      cx={261.9}
      cy={173.1}
      r={94.5}
    />
    <g stroke="#000">
      <path
        fill="#003e87"
        d="m261.9 151.5-50.6 23.4v20c0 11.8 6.1 22.8 16.2 28.9L262 239l34.5-15.2c10-6.2 16.2-17.1 16.2-28.9v-20l-50.8-23.4z"
      />
      <path fill="#FFDA44" d="M211.3 128.1h101.3v46.7H211.3z" />
    </g>
    <path d="M0 0h513v35H0zm0 306h513v35H0z" fill="#ce1127" />
  </svg>
)

export var CA = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#FFF" d="M0 0h513v342H0z" />
    <path
      d="M0 0h142v342H0zm371 0h142v342H371zm-64.5 206 50.4-25.2-25.2-12.6V143l-50.4 25.2 25.2-50.4h-25.2L256.1 80l-25.2 37.8h-25.2l25.2 50.4-50.4-25.2v25.2l-25.2 12.6 50.4 25.2-12.6 25.2h50.4V269h25.2v-37.8h50.4z"
      fill="red"
    />
  </svg>
)

export var CC = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="green" d="M0 0h513v342H0z" />
    <path
      d="m422.7 252.4 6.2 12.8 13.8-3.2-6.2 12.8 11.2 8.8-13.9 3.2V301l-11.1-8.9-11.1 8.9v-14.2l-13.8-3.2 11.1-8.8-6.2-12.8 13.9 3.2zm-46.6-136.3 6.2 12.9 13.8-3.2-6.2 12.8 11.2 8.8-13.9 3.1v14.3l-11.1-8.9-11.1 8.9.1-14.3-13.9-3.1 11.1-8.8-6.2-12.8L370 129zm37-77.8 6.2 12.8 13.8-3.2-6.2 12.8 11.2 8.9-13.9 3.1v14.2L413.1 78 402 86.9l.1-14.2-13.9-3.1 11.1-8.9-6.2-12.8 13.9 3.2zm51.8 58.4 6.2 12.8 13.9-3.2-6.3 12.8 11.2 8.9-13.9 3.1.1 14.2-11.2-8.9-11.1 8.9.1-14.2L440 128l11.2-8.9-6.3-12.8 13.9 3.2zm-28 68.1 4.9 14.8h15.6l-12.6 9.2 4.8 14.9-12.7-9.2-12.6 9.2 4.8-14.9-12.6-9.2h15.6zM306.8 254.7c-49.2 0-89.1-39.9-89.1-89.1s39.9-89.1 89.1-89.1c15.3 0 29.8 3.9 42.4 10.7C329.4 67.9 302.3 56 272.5 56c-60.5 0-109.6 49.1-109.6 109.6S212 275.3 272.5 275.3c29.8 0 56.9-11.9 76.6-31.3-12.6 6.8-27 10.7-42.3 10.7zM140.4 59.5C129.7 41 109.7 28.6 86.8 28.6S44 41 33.3 59.5h107.1zm.2.4-53.8 53.8-53.7-53.8C28 68.9 25 79.3 25 90.5c0 34.2 27.7 61.9 61.9 61.9s61.9-27.7 61.9-61.9c-.1-11.2-3.1-21.6-8.2-30.6z"
      fill="#FFDA44"
    />
    <path
      fill="#A2001D"
      d="M71.4 98.2v52.2c4.9 1.3 10.1 1.9 15.5 1.9s10.5-.7 15.5-1.9V98.2h-31z"
    />
  </svg>
)

export var CD = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#338AF3" d="M0 0h513v342H0z" />
    <path fill="#FFDA44" d="M513 66.9V0H411.7L0 274.4V342h100.3z" />
    <path fill="#D80027" d="M513 0v40.1L60.2 342H0v-40.8L451.8 0z" />
    <path
      fill="#FFDA44"
      d="m93.6 31.2 16.3 50.4H163l-42.9 31.2 16.4 50.5-42.9-31.2-43 31.2L67 112.8 24.1 81.6h53.1z"
    />
  </svg>
)

export var CF = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#d21034" d="M0 0h513v342H0z" />
    <path d="M0 171h211.5v85.3H0zm300.5 0H512v85.3H300.5z" fill="#3a9927" />
    <path fill="#003082" d="M0 0v85.3h211.5V0h89v85.3H513V0z" />
    <path d="M300.5 85.3H512v85.3H300.5zM0 85.3h211.5v85.3H0z" fill="#FFF" />
    <path
      d="M300.5 342h-89v-86H0v86h513v-86H300.5zM105.7 8.6l8.6 26.2h27.5L119.5 51l8.6 26.2L105.7 61 83.4 77.2 91.9 51 69.6 34.8h27.6z"
      fill="#ffce00"
    />
  </svg>
)

export var CG = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 900 600" {...rest}>
    {title && <title>{title}</title>}
<path fill="#009739" d="M0 0h900v600H0z" />
    <path d="M0 600 600 0h300v600z" fill="#ffd100" />
    <path d="M900 0v600H300z" fill="#dc241f" />
  </svg>
)

export var CH = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 768 512" {...rest}>
    {title && <title>{title}</title>}
<path fill="red" d="M0 0h768v512H0V0z" />
    <path
      fill="#FFF"
      d="M336 96h96v112h112v96H432v112h-96V304H224v-96h112V96z"
    />
  </svg>
)

export var CI = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#FFF" d="M0 0h513v342H0z" />
    <path fill="#009e60" d="M342 0h171v342H342z" />
    <path fill="#f77f00" d="M0 0h171v342H0z" />
  </svg>
)

export var CK = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#012169" d="M0 0h513v342H0z" />
    <path
      d="m384 71.4 5.3 16.2h17.1l-13.9 10.1 5.3 16.2-13.8-10-13.8 10 5.3-16.2-13.9-10.1h17.1zm-70.2 29.1 15.2 7.7 12.1-12.1-2.7 16.9 15.3 7.8-16.9 2.6-2.7 16.9-7.8-15.2-16.8 2.7 12.1-12.1zm-29.1 70.2 16.3-5.3v-17.1l10 13.8 16.3-5.3-10.1 13.9 10.1 13.8-16.3-5.3-10 13.8v-17.1zm29.1 70.2 7.7-15.3-12-12 16.8 2.6 7.8-15.2 2.7 16.9 16.9 2.7-15.3 7.7 2.7 16.9-12.1-12.1zM384 270l-5.3-16.3h-17.1l13.9-10-5.3-16.3 13.8 10 13.8-10-5.3 16.3 13.9 10h-17.1zm70.2-29.1-15.2-7.8-12.1 12.1 2.7-16.9-15.3-7.7 16.9-2.7 2.7-16.9 7.8 15.2 16.8-2.6-12.1 12zm29.1-70.2-16.3 5.2V193l-10-13.8-16.3 5.3 10.1-13.8-10.1-13.9 16.3 5.3 10-13.8v17.1zm-29.1-70.2-7.7 15.2 12 12.1-16.8-2.7-7.8 15.2-2.7-16.9-16.9-2.6 15.3-7.8-2.7-16.9 12.1 12.1z"
      fill="#FFF"
    />
    <path fill="#012169" d="M0 0h256.5v171H0z" />
    <g fill="#FFF">
      <path d="M256.5 0v30.6l-45.3 25.2h45.3v59.4h-59.2l59.2 32.9V171h-26.7l-73.7-40.9V171h-55.7v-48.7L12.8 171H0v-30.6l45.3-25.2H0V55.8h59.2L0 22.9V0h26.7l73.7 40.9V0h55.7v48.7L243.7 0z" />
      <path d="M156.1 115.2 256.5 171v-15.8l-72-40zm-55.7-59.4L0 0v15.8l72 40z" />
    </g>
    <g fill="#D80027">
      <path d="M144.3 0h-32.1v69.5H0v32h112.2V171h32.1v-69.5h112.2v-32H144.3z" />
      <path d="M156.1 115.2 256.5 171v-15.8l-72-40zm-84.1 0-72 40V171l100.4-55.8zm28.4-59.4L0 0v15.8l72 40zm84.1 0 72-40V0L156.1 55.8z" />
    </g>
  </svg>
)

export var CL = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#D80027" d="M0 0h513v342H0z" />
    <path fill="#FFF" d="M196 0h317v171H196z" />
    <path fill="#0037A1" d="M0 0h196v171H0z" />
    <path
      fill="#FFF"
      d="M98 24.5 113.1 71H162l-39.6 28.7 15.2 46.5L98 117.5l-39.6 28.7 15.2-46.5L34 71h48.9z"
    />
  </svg>
)

export var CM = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#ce1126" d="M0 0h513v342H0z" />
    <path fill="#007a5e" d="M0 0h171v342H0z" />
    <path
      d="M342 0h171v342H342zm-86 102.2 17.2 53H329L283.9 188l17.2 53-45.1-32.7-45.1 32.7 17.2-53-45.1-32.8h55.8z"
      fill="#fcd116"
    />
  </svg>
)

export var CN = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#D80027" d="M0 0h513v342H0z" />
    <path
      d="m226.8 239.2-9.7-15.6-17.9 4.4 11.9-14.1-9.7-15.6 17.1 6.9 11.8-14.1-1.3 18.4 17.1 6.9-17.9 4.4zM290.6 82l-10.1 15.4 11.6 14.3-17.7-4.8-10.1 15.5-1-18.4-17.7-4.8 17.2-6.6-1-18.4 11.6 14.3zm-54.4-56.6-2 18.3 16.8 7.6-18 3.8-2 18.3-9.2-16-17.9 3.8 12.3-13.7-9.2-15.9 16.8 7.5zm56.6 136.4-14.9 10.9 5.8 17.5-14.9-10.8-14.9 11 5.6-17.6-14.9-10.7 18.4-.1 5.6-17.6 5.8 17.5zM115 46.3l17.3 53.5h56.2l-45.4 32.9 17.3 53.5-45.4-33-45.5 33 17.4-53.5-45.5-32.9h56.3z"
      fill="#FFDA44"
    />
  </svg>
)

export var CO = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#FFDA44" d="M0 0h513v342H0z" />
    <path fill="#D80027" d="M0 256.5h513V342H0z" />
    <path fill="#0052B4" d="M0 171h513v85.5H0z" />
  </svg>
)

export var CR = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#FFF" d="M0 0h513v342H0z" />
    <path fill="#D80027" d="M0 114h513v114H0z" />
    <path fill="#0052B4" d="M0 285h513v57H0zM0 0h513v57H0z" />
  </svg>
)

export var CU = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#FF9811" d="M0-40.8v422.9-211.4z" />
    <path fill="#FFF" d="M0 0h513v342H0z" />
    <path
      d="M0 0h513v68.3H0zm0 136.5h513v68.3H0zm0 136.6h513v68.3H0z"
      fill="#0052B4"
    />
    <path fill="#D80027" d="M256 170.7 0 342V0z" />
    <path
      fill="#FFF"
      d="m86.5 111.4 12.7 39.2h41.3l-33.4 24.2 12.8 39.3-33.4-24.2-33.4 24.2 12.8-39.3-33.4-24.2h41.2z"
    />
  </svg>
)

export var CV = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#003893" d="M0 0h513v342H0z" />
    <path fill="#cf2027" d="M0 182.2h513v41.4H0z" />
    <path fill="#FFF" d="M0 140.8h513v41.4H0zm0 82.8h513V265H0z" />
    <path
      d="m150.4 70 6.9 21.1h22.2l-18 13.1 6.9 21.1-18-13.1-17.9 13.1 6.8-21.1-17.9-13.1h22.2zm0 209.7 6.9 21.1h22.2l-18 13 6.9 21.2-18-13.1-17.9 13.1 6.8-21.2-17.9-13h22.2zm-97.6-70.9 6.9 21.1h22.2l-18 13 6.9 21.2-18-13.1-17.9 13.1 6.8-21.2-17.9-13H46zM90.1 91l6.9 21.1h22.2l-18 13 6.9 21.2-18-13.1-17.9 13.1 6.8-21.2-18-13h22.3zm-66.3 71H46l6.8-21.1 6.9 21.1h22.2l-18 13.1 6.9 21.1-18-13-17.9 13 6.8-21.1zm48.4 148.9 6.8-21.1-18-13h22.3l6.8-21.2 6.9 21.2h22.2l-18 13 6.9 21.1-18-13zM248 208.8l-6.9 21.1h-22.2l18 13-6.9 21.2 18-13.1 18 13.1-6.9-21.2 18-13h-22.2zM210.7 91l-6.8 21.1h-22.2l17.9 13-6.8 21.2 17.9-13.1 18 13.1-6.9-21.2 18-13h-22.2zm66.4 71h-22.2l-6.9-21.1-6.9 21.1h-22.2l18 13.1-6.9 21.1 18-13 18 13-6.9-21.1zm-48.4 148.9-6.9-21.1 18-13h-22.2l-6.9-21.2-6.8 21.2h-22.2l17.9 13-6.8 21.1 17.9-13z"
      fill="#f7d116"
      stroke="#000"
    />
  </svg>
)

export var CW = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#002b7f" d="M0 0h513v342H0z" />
    <path fill="#f9e814" d="M0 233.5h513v51H0z" />
    <path
      d="m168.7 86.5 12.9 39.8h41.8l-33.8 24.5 12.9 39.7-33.8-24.5-33.8 24.5 12.9-39.7-33.8-24.5h41.8zm-83.3-54 7.8 23.9h25L97.9 71.1l7.8 23.8-20.3-14.7-20.3 14.7 7.8-23.8-20.3-14.7h25.1z"
      fill="#FFF"
    />
  </svg>
)

export var CX = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#0021ad" d="M0 0h513v342H0z" />
    <path fill="#1c8a42" d="M0 0h513v342" />
    <path
      d="m77.6 272 5.7 11.9 12.8-3-5.7 11.9 10.3 8.1-12.8 2.9V317l-10.3-8.3-10.2 8.3v-13.2l-12.8-2.9 10.3-8.1-5.8-11.9 12.9 3zm-37.1-98.9 5.7 11.9 12.8-3-5.7 11.8 10.3 8.2-12.9 2.9.1 13.2-10.3-8.3-10.3 8.3.1-13.2-12.9-2.9 10.4-8.2L22 182l12.8 3zm37.1-80.9 5.7 11.8 12.8-2.9-5.7 11.8 10.3 8.2-12.8 2.9v13.1l-10.3-8.2-10.2 8.2V124l-12.8-2.9 10.3-8.2-5.8-11.8L72 104zm46.1 62.9 5.7 11.9 12.8-3-5.7 11.9 10.3 8.1-12.8 2.9v13.2l-10.3-8.2-10.2 8.2v-13.2l-12.8-2.9 10.3-8.1-5.7-11.9 12.8 3zm-32.9 54 4.4 13.7h14.5L98 231.3l4.5 13.7-11.7-8.4-11.7 8.4 4.5-13.7-11.7-8.5h14.4z"
      fill="#FFF"
    />
    <circle fill="#ffc639" cx={267.1} cy={170.7} r={74.5} />
    <path
      fill="#1c8a42"
      d="M267.1 220.3h24.8s10.8-19 0-37.2l24.8-24.8-12.4-24.8h-12.4s-6.2 18.6-31 18.6-31-18.6-31-18.6h-12.4l12.4 24.8-12.4 24.8 12.4 12.4s12.4-24.8 37.2-12.4c0 0 10.5 15.5 0 37.2z"
    />
    <path
      fill="#ffc639"
      d="M464.4 92.2c.6-2.9-.2-17.6-.2-20.7 0-21.3-13.9-39.4-33.2-45.7 5.9 12 9.2 25.4 9.2 39.7 0 4.8-.4 9.5-1.1 14.1-2.9-4.7-6.6-8.9-11.2-12.6-17.1-13.6-40.6-14-57.9-2.5 13.4 2.9 26.3 8.9 37.7 18 9 7.1 16.2 16.8 21.7 26.1 0 0-17.8 10.9-31 15.1s-42.3 7.9-42.3 7.9c72 12 132-36 132-36-6.5-13.4-15.8-4-23.7-3.4z"
    />
  </svg>
)

export var CY = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#FFF" d="M0 0h513v342H0z" />
    <path
      fill="#DB7D00"
      d="M141.7 154.7s.2 67.1 74.7 65.3l4.5 13.9h8.9s-7.4-41.1 60.1-41.5c0 0 0-27.6 27.6-27.6H359s-66-51.8 58.9-118l1.8-13.1s-129.9 71-198.9 57.2c0 0 10.7 42.5-10.8 42.5-10.8 0-9.7-8.1-32.3-8.1-18.7 0-17.3 19.7-26.3 19.5-8.9-.2-18.8-12.3-19.6-10.2-.7 2.1 9.9 20.1 9.9 20.1z"
    />
    <g fill="#006651">
      <path d="M237.2 308.1c6.9-5 13-6.6 22.4-8.3s19.4-4.4 24.6-5.8-17.7 6.6-23.5 8.3c-5.8 1.6-23.5 5.8-23.5 5.8zm37.9-14.7c-1.9-11.9 2.8-24.3 13.5-29.3 2.5 8.6-5.2 23.2-13.5 29.3zm18.2-6.2c-5.8-9.8 4-22.6 11.1-28.8 3.3 6-2.5 23.7-11.1 28.8zm16.9-7.6c-6.2-8.4 1.1-23.2 8.8-29 3.1 8.2.1 23.2-8.8 29zm16.9-10.6c-5.6-8-1.7-20.4 6.3-28.4 5.8 6.6.9 21-6.3 28.4zm13.5-10.7c-4.7-7.5 1.1-25.4 8.6-30.4 3.3 6.6.8 25.4-8.6 30.4zm10.8-2.8c-1.4-10.8 17.4-22.7 25.2-22.4-.9 8.9-8.9 18.6-25.2 22.4zm-10.5 12.2c8.8-9.1 26-9.1 32.1-7.2-1.7 5.3-21.9 16.9-32.1 7.2z" />
      <path d="M328.7 276.8c12.4-3.3 20.5-6.1 27.9 1.7-5.2 6.6-25.4 4.7-27.9-1.7zm-17.7 8c11.9-6.4 26.3 3 28.5 8.6-13.3 5.5-28.7-7.2-28.5-8.6zm-16.3 9.2c10.8-4.1 23.2 1.4 28.2 7.5-5.8 2.7-21 5.7-28.2-7.5zm-14.9 4.7c12.4-1.4 24.4 8 27 13.4-15.9 1.5-22-3.2-27-13.4zm-4 9.4c-6.9-5-13-6.6-22.4-8.3-9.4-1.7-19.4-4.4-24.6-5.8-5.3-1.4 17.7 6.6 23.5 8.3 5.8 1.6 23.5 5.8 23.5 5.8zm-37.9-14.7c1.9-11.9-2.8-24.3-13.5-29.3-2.5 8.6 5.2 23.2 13.5 29.3zm-18.2-6.2c5.8-9.8-4-22.6-11.1-28.8-3.3 6 2.5 23.7 11.1 28.8zm-16.9-7.6c6.2-8.4-1.1-23.2-8.8-29-3.1 8.2-.1 23.2 8.8 29zM185.9 269c5.6-8 1.7-20.4-6.3-28.4-5.8 6.6-.9 21 6.3 28.4zm-13.5-10.7c4.7-7.5-1.1-25.4-8.6-30.4-3.3 6.6-.8 25.4 8.6 30.4zm-10.8-2.8c1.4-10.8-17.4-22.7-25.2-22.4.9 8.9 8.9 18.6 25.2 22.4zm10.5 12.2c-8.8-9.1-26-9.1-32.1-7.2 1.7 5.3 21.9 16.9 32.1 7.2z" />
      <path d="M184.3 276.8c-12.4-3.3-20.5-6.1-27.9 1.7 5.2 6.6 25.4 4.7 27.9-1.7zm17.7 8c-11.9-6.4-26.3 3-28.5 8.6 13.3 5.5 28.7-7.2 28.5-8.6zm16.3 9.2c-10.8-4.1-23.2 1.4-28.2 7.5 5.8 2.7 21 5.7 28.2-7.5zm14.9 4.7c-12.4-1.4-24.4 8-27 13.4 15.9 1.5 22-3.2 27-13.4z" />
    </g>
  </svg>
)

export var CZ = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#11457e" d="M0 0h513v342H0z" />
    <path fill="#d7141a" d="M513 171v171H0l256.5-171z" />
    <path fill="#FFF" d="M513 0v171H256.5L0 0z" />
  </svg>
)

export var DE = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#D80027" d="M0 0h513v342H0z" />
    <path d="M0 0h513v114H0z" />
    <path fill="#FFDA44" d="M0 228h513v114H0z" />
  </svg>
)

export var DJ = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#12ad2b" d="M0 0h513v342H0z" />
    <path fill="#6ab2e7" d="M513 0v166.7L0 170.8V0z" />
    <path fill="#FFF" d="M256 170.7 0 342V0z" />
    <path
      fill="#d7141a"
      d="m89.8 92.5 17 52.4H162l-44.6 32.5 17 52.4-44.6-32.4-44.6 32.4 17-52.4-44.6-32.5h55.2z"
    />
  </svg>
)

export var DK = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#c60c30" d="M0 0h513v342H0z" />
    <path fill="#FFF" d="M190 0h-60v140H0v60h130v142h60V200h323v-60H190z" />
  </svg>
)

export var DM = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#496E2D" d="M0 0h513v342H0z" />
    <path d="M0 110.7v120h513v-120z" />
    <path fill="#FFDA44" d="M0 110.7h513v40H0z" />
    <path fill="#FFF" d="M0 190.7h513v40H0z" />
    <path d="M196 0h120v342H196z" />
    <path fill="#FFDA44" d="M196 0h40v342h-40z" />
    <path fill="#FFF" d="M274.7 0h40v342h-40z" />
    <circle fill="#D80027" cx={256} cy={170.7} r={123.1} />
    <path
      d="m256 58.6 4.6 14.2h15l-12.1 8.9 4.6 14.2-12.1-8.8-12.1 8.8 4.6-14.2-12.1-8.9h15zM190.1 80l12.2 8.8 12.1-8.8-4.6 14.3 12.1 8.8h-15l-4.6 14.2-4.7-14.2h-15l12.1-8.8zm-40.7 56h15l4.6-14.2 4.7 14.2h15l-12.2 8.8 4.7 14.3-12.2-8.8-12.1 8.8 4.6-14.3zm0 69.3 12.1-8.8-4.6-14.3L169 191l12.2-8.8-4.7 14.3 12.2 8.8h-15l-4.7 14.3-4.6-14.3zm40.7 56.1 4.6-14.3-12.1-8.8h15l4.7-14.3 4.6 14.3h15l-12.1 8.8 4.6 14.3-12.1-8.9zm65.9 21.4-4.6-14.3h-15l12.1-8.8-4.6-14.3 12.1 8.8 12.1-8.8-4.6 14.3 12.1 8.8h-15zm65.9-21.4-12.2-8.9-12.1 8.9 4.6-14.3-12.1-8.8h15l4.6-14.3 4.7 14.3h15l-12.1 8.8zm40.7-56.1h-15l-4.6 14.3-4.7-14.3h-15l12.2-8.8-4.7-14.3L343 191l12.1-8.8-4.6 14.3zm0-69.3-12.1 8.8 4.6 14.3-12.1-8.8-12.2 8.8 4.7-14.3-12.2-8.8h15l4.7-14.2 4.6 14.2zm-40.7-56-4.6 14.3 12.1 8.8h-15l-4.7 14.2-4.6-14.2h-15l12.1-8.8-4.6-14.3 12.1 8.8zM279.3 168.7c-11-21.1-14.5-25.1-14.5-25.1s.4-9.7.4-15.6c0-8.8-7.4-15.8-16.5-15.8-8.6 0-15.7 2.9-16.5 11-4.2.9-8.6 4.1-8.6 10.7 0 4.8 1 7.3 5.2 9.3 2.1-4.6 4.3-4.8 9.3-6.4.8.6 1.7 3 2.6 3.4l.3 1s-13.3 6.6-13.3 30.9c0 29.5 22 45.4 22 45.4l-1.8.3-1.9 7.1h22v-7.2l11 17.5c.3-.3 10.2-47.6.3-66.5z"
      fill="#496E2D"
    />
  </svg>
)

export var DO = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#FFF" d="M0 0h513v342H0z" />
    <path fill="#D80027" d="M0 216h211v126H0z" />
    <path fill="#0052B4" d="M0 0h211v126H0z" />
    <path fill="#D80027" d="M302 0h211v126H302z" />
    <path fill="#0052B4" d="M302 216h211v126H302z" />
    <g stroke="#FFF" strokeWidth={5} strokeMiterlimit={10}>
      <path fill="#0052B4" d="M256 130h-49.9v49.4s19.5 6 49.9 6V130z" />
      <path
        fill="#D80027"
        d="M206.1 179.4v6c0 27.5 22.3 49.9 49.9 49.9v-49.9c-30.4 0-49.9-6-49.9-6z"
      />
      <path
        fill="#0052B4"
        d="M256 235.3c27.5 0 49.9-22.3 49.9-49.9v-6s-19.5 6-49.9 6v49.9z"
      />
      <path fill="#D80027" d="M256 130v55.4c30.4 0 49.9-6 49.9-6V130H256z" />
    </g>
  </svg>
)

export var DZ = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#41662E" d="M0 0h513v342H0z" />
    <path fill="#FFF" d="M256.5 0H513v342H256.5z" />
    <g fill="#D80027">
      <path d="m341.5 105.3-29.4 40.4-47.5-15.4 29.4 40.4-29.4 40.4 47.5-15.4 29.4 40.4v-50l47.5-15.5-47.5-15.4z" />
      <path d="M309.9 276.7c-58.5 0-106-47.5-106-106s47.5-106 106-106c18.3 0 35.4 4.6 50.4 12.7-23.5-23-55.7-37.2-91.2-37.2-72 0-130.4 58.4-130.4 130.4S197.1 301 269.1 301c35.5 0 67.7-14.2 91.2-37.2-14.9 8.2-32.1 12.9-50.4 12.9z" />
    </g>
  </svg>
)

export var EC = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#FFDA44" d="M0 0h513v342H0z" />
    <path fill="#0052B4" d="M0 170.7h513V256H0z" />
    <path fill="#D80027" d="M0 256h513v85.3H0z" />
    <circle fill="#FFDA44" cx={256} cy={171} r={60} />
    <path
      fill="#4C1F00"
      d="M369.2 79.9s-27.2-13.8-33.9-16c-6.7-2.2-49.1-13.2-49.1-7 0 10.3-13.5 12-15.5 12s-2-5.3-14.8-5.3-13.7 4.8-15.8 4.8c-2.2 0-14.5-1-14.5-11.5 0-5.2-42.9 4-49.1 7-6.1 3.1-33.9 16-33.9 16s45.8 2.7 53.9 6.2 43.8 16.5 43.8 16.5l-2.8 13.3h37.8l-3.8-13.3s35.1-12.7 43.8-16.5 53.9-6.2 53.9-6.2z"
    />
    <path
      fill="#57BA17"
      d="M217.7 171.7c0 21.1 17.2 38.3 38.3 38.3 21.1 0 38.3-17.2 38.3-38.3v-11.5h-76.5v11.5z"
    />
    <path
      fill="#338AF3"
      d="M256 110.5c-21.1 0-38.3 17.2-38.3 38.3v11.5h76.5v-11.5c.1-21.1-17.1-38.3-38.2-38.3z"
    />
  </svg>
)

export var EE = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#111" d="M0 0h513v342H0z" />
    <path fill="#368FD8" d="M0 0h513v114H0z" />
    <path fill="#FFF" d="M0 228h513v114H0z" />
  </svg>
)

export var EG = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#FFF" d="M0 0h513v342H0z" />
    <path fill="#D80027" d="M0 0h513v114H0z" />
    <path d="M0 228h513v114H0z" />
    <path
      fill="#C09300"
      d="M220.3 204.4s0-58.4 4.5-64.7c3.1-4.3 16.8 5.2 22.7 4.5 0 0 4.2-7.5 4.5-12 .3-4.6-1.1-7.6-4.9-6.2 0 0-1.2-2.1.5-3.3 1.6-1.2 5.6.1 5.6.1s-.5-1 1.6-.9c2.9.2 7.2 1.4 7.4 5.6.2 3.1.3 7.7.4 8.7.7 6.8 2.7 8.7 2.7 8.7s18.4-9.2 22-5.2c3.3 3.8 4.5 64.7 4.5 64.7l-18.1-16.8 12.1 29.5s-14.4 2.4-28.9 2.4c-14.5 0-31.1-4.2-31.1-4.2l13.8-28.2-19.3 17.3z"
    />
  </svg>
)

export var EH = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#FFF" d="M0 0h513v342H0z" />
    <path d="M0 0h513v114H0z" />
    <path fill="#428823" d="M0 228h513v114H0z" />
    <g fill="#D80027">
      <path d="M256 171 0 342V0zm53.1 0c0-22.9 13.1-42.1 34.6-46.8-3.3-.7-6.7-1.1-10.3-1.1-26.4 0-47.9 21.4-47.9 47.9s21.4 47.9 47.9 47.9c3.5 0 7-.4 10.3-1.1-21.5-5.1-34.6-24.2-34.6-46.8z" />
      <path d="m365 129.2 10.3 31.7h33.3l-27 19.6 10.3 31.7-26.9-19.6-27 19.6 10.3-31.7-27-19.6h33.4z" />
    </g>
  </svg>
)

export var ER = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#338AF3" d="M0 0h513v342H0z" />
    <path fill="#56AF35" d="M0 0h513v171H0z" />
    <path fill="#D80027" d="m0 342 513-171L0 0v342z" />
    <g fill="#ffc945">
      <path d="M134.7 231.5c33.6 0 60.8-27.2 60.8-60.8s-27.2-60.8-60.8-60.8-60.8 27.2-60.8 60.8 27.2 60.8 60.8 60.8zm0 24.3c-47 0-85.2-38.1-85.2-85.2s38.1-85.2 85.2-85.2 85.2 38.1 85.2 85.2-38.2 85.2-85.2 85.2z" />
      <circle cx={119.5} cy={148.3} r={17.5} />
      <circle cx={148.9} cy={158.5} r={17.5} />
      <circle cx={134.7} cy={135.2} r={17.5} />
      <circle cx={119.5} cy={172.7} r={17.5} />
      <circle cx={149.9} cy={182.8} r={17.5} />
      <circle cx={122.5} cy={198} r={17.5} />
      <circle cx={145.9} cy={205.2} r={17.5} />
    </g>
  </svg>
)

export var ES_CT = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 810 540" {...rest}>
    {title && <title>{title}</title>}
<path fill="#FCDD09" d="M0 0h810v540H0z" />
    <path
      stroke="#DA121A"
      strokeWidth={60}
      d="M0 90h810m0 120H0m0 120h810m0 120H0"
    />
  </svg>
)

export var ES = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22.5 15" {...rest}>
    {title && <title>{title}</title>}
<path fill="#FFF" d="M0 0h22.5v15H0V0z" />
    <path fill="#D03433" d="M0 0h22.5v4H0V0zm0 11h22.5v4H0v-4z" />
    <path fill="#FBCA46" d="M0 4h22.5v7H0V4z" />
    <path fill="#FFF" d="M7.8 7h1v.5h-1V7z" />
    <path
      fill="#A41517"
      d="M7.2 8.5c0 .3.3.5.6.5s.6-.2.6-.5L8.5 7H7.1l.1 1.5zM6.6 7c0-.3.2-.5.4-.5h1.5c.3 0 .5.2.5.4V7l-.1 1.5c-.1.6-.5 1-1.1 1-.6 0-1-.4-1.1-1L6.6 7z"
    />
    <path
      fill="#A41517"
      d="M6.8 7.5h2V8h-.5l-.5 1-.5-1h-.5v-.5zM5.3 6h1v3.5h-1V6zm4 0h1v3.5h-1V6zm-2.5-.5c0-.3.2-.5.5-.5h1c.3 0 .5.2.5.5v.2c0 .2-.1.3-.3.3H7c-.1 0-.2-.1-.2-.2v-.3z"
    />
  </svg>
)

export var ET = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22.5 15" {...rest}>
    {title && <title>{title}</title>}
<path fill="#20AA46" d="M0 0h22.5v5H0V0z" />
    <path fill="#E92F3B" d="M0 10h22.5v5H0v-5z" />
    <path fill="#FADF50" d="M0 5h22.5v5H0V5z" />
    <circle fill="#205CCA" cx={11.3} cy={7.5} r={5.2} />
    <g stroke="#FFDB3D" fill="none">
      <path
        d="m11.3 8.8-2.1 1.5.8-2.4-2-1.5h2.5l.8-2.3.8 2.3h2.6l-2.1 1.5.8 2.4-2.1-1.5zm-1-2.4h1.9M9.9 7.8l1.3 1m.8-2.6.7 1.8M10 7.9l.6-1.8M11 9l1.6-1.1"
        strokeWidth={0.5}
      />
      <path
        d="m8.7 3.9 1.1 1.6m4-1.7-1 1.6m-1.5 4.7V12M8.9 8.3 7.1 9m8.4 0-1.8-.7"
        strokeWidth={0.25}
      />
    </g>
  </svg>
)

export var EU = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 810 540" {...rest}>
    {title && <title>{title}</title>}
<path fill="#039" d="M0 0h810v540H0z" />
    <path
      fill="#FC0"
      d="m404.951 59.865 6.735 20.718h21.894l-17.633 12.812 6.638 20.74-17.634-12.812-17.634 12.812 6.736-20.729-17.633-12.812h21.796zm-90 24 6.735 20.718h21.894l-17.633 12.812 6.638 20.74-17.634-12.812-17.634 12.812 6.736-20.729-17.633-12.812h21.796zm-66 66 6.735 20.718h21.894l-17.633 12.812 6.638 20.74-17.634-12.812-17.634 12.812 6.736-20.729-17.633-12.812h21.796zm-24 89.999 6.735 20.719h21.894l-17.633 12.813 6.638 20.74-17.634-12.813-17.634 12.813 6.736-20.731-17.633-12.811h21.796zm24 90.001 6.735 20.719h21.894l-17.633 12.811 6.638 20.74-17.634-12.811-17.634 12.811 6.736-20.729-17.633-12.812h21.796zm66 66 6.735 20.719h21.894l-17.633 12.811 6.638 20.74-17.634-12.811-17.634 12.811 6.736-20.729-17.633-12.812h21.796zm180-312 6.735 20.718h21.894l-17.633 12.812 6.637 20.74-17.633-12.812-17.635 12.812 6.737-20.729-17.633-12.812h21.795zm66 66 6.735 20.718h21.894l-17.633 12.812 6.637 20.74-17.633-12.812-17.635 12.812 6.737-20.729-17.633-12.812h21.795zm24 90 6.735 20.718h21.894l-17.633 12.813 6.638 20.74-17.634-12.813-17.634 12.813 6.736-20.731-17.633-12.811h21.796zm-24 90 6.735 20.719h21.894l-17.633 12.811 6.638 20.74-17.634-12.811-17.634 12.811 6.736-20.729-17.633-12.812h21.796zm-156 90 6.735 20.719h21.894l-17.633 12.811 6.638 20.74-17.634-12.811-17.634 12.811 6.736-20.729-17.633-12.812h21.796zm90-24.001 6.735 20.719h21.894l-17.633 12.812 6.639 20.74-17.635-12.812-17.633 12.812 6.735-20.73-17.633-12.811h21.797z"
    />
  </svg>
)

export var FI = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#FFF" d="M0 0h513v342H0z" />
    <path
      fill="#2E52B2"
      d="M513 129.3V212H203.7v130H121V212H0v-82.7h121V0h82.7v129.3z"
    />
  </svg>
)

export var FJ = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#62B5E5" d="M0 0h513v342H0z" />
    <path
      fill="#F3F3F3"
      d="M307.1 127.1v92c0 61.6 80.5 80.5 80.5 80.5s80.4-19 80.4-80.6v-92l-80.5-23-80.4 23.1z"
    />
    <path
      fill="#c8102e"
      d="M468 132.8V98.3H307.1v34.5h69v69h-69v23h69V296c6.9 2.5 11.5 3.5 11.5 3.5s4.6-1.1 11.5-3.5v-71.2h69v-23h-69v-69H468z"
    />
    <path fill="#012169" d="M0 0h256.5v171H0z" />
    <g fill="#FFF">
      <path d="M256.5 0v30.6l-45.3 25.2h45.3v59.4h-59.2l59.2 32.9V171h-26.7l-73.7-40.9V171h-55.7v-48.7L12.8 171H0v-30.6l45.3-25.2H0V55.8h59.2L0 22.9V0h26.7l73.7 40.9V0h55.7v48.7L243.7 0z" />
      <path d="M156.1 115.2 256.5 171v-15.8l-72-40zm-55.7-59.4L0 0v15.8l72 40z" />
    </g>
    <g fill="#D80027">
      <path d="M144.3 0h-32.1v69.5H0v32h112.2V171h32.1v-69.5h112.2v-32H144.3z" />
      <path d="M156.1 115.2 256.5 171v-15.8l-72-40zm-84.1 0-72 40V171l100.4-55.8zm28.4-59.4L0 0v15.8l72 40zm84.1 0 72-40V0L156.1 55.8z" />
    </g>
  </svg>
)

export var FK = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#012169" d="M0 0h513v342H0z" />
    <path fill="#012169" d="M0 0h256.5v171H0z" />
    <g fill="#FFF">
      <path d="M256.5 0v30.6l-45.3 25.2h45.3v59.4h-59.2l59.2 32.9V171h-26.7l-73.7-40.9V171h-55.7v-48.7L12.8 171H0v-30.6l45.3-25.2H0V55.8h59.2L0 22.9V0h26.7l73.7 40.9V0h55.7v48.7L243.7 0z" />
      <path d="M156.1 115.2 256.5 171v-15.8l-72-40zm-55.7-59.4L0 0v15.8l72 40z" />
    </g>
    <g fill="#D80027">
      <path d="M144.3 0h-32.1v69.5H0v32h112.2V171h32.1v-69.5h112.2v-32H144.3z" />
      <path d="M156.1 115.2 256.5 171v-15.8l-72-40zm-84.1 0-72 40V171l100.4-55.8zm28.4-59.4L0 0v15.8l72 40zm84.1 0 72-40V0L156.1 55.8z" />
    </g>
    <path
      fill="#2a7fff"
      d="M311.2 190.2v-90c0-8.5 6.5-15.3 15-15.3h120.5c8.3 0 15 6.8 15 15.3v90c0 75.2-75.2 105.3-75.2 105.3s-75.3-30.1-75.3-105.3z"
    />
    <path
      fill="#FFF"
      d="M311.2 190.2v-90c0-8.5 6.5-15.3 15-15.3h120.5c8.3 0 15 6.8 15 15.3v90c0 75.2-75.2 105.3-75.2 105.3s-75.3-30.1-75.3-105.3zm79.6 86.3c7.9-4.5 15.9-10 23.2-16.7 20.5-18.5 32.6-41.4 32.6-69.7v-90c0-.3-120.4-.3-120.4-.3v90.3c0 28.3 12.1 51.2 32.6 69.7 8.3 7.5 17.6 13.9 27.6 19 1.4-.6 2.8-1.4 4.4-2.3z"
    />
    <path
      fill="#3e6d1e"
      d="M346.1 189.4c-2.6-7.9 1.7-14.3 10.1-14.3h60.5c8.2 0 12.8 6.3 10.1 14.3l-5.5 16.5c-2.6 7.9-8.9 9.2-15.8 4 0 0 2.6-4.8-19.1-4.8s-19.1 4.8-19.1 4.8c-6.1 5.7-13.1 4-15.8-4 .1.1-5.4-16.5-5.4-16.5z"
    />
    <path
      fill="#e5e5e5"
      d="M356.4 175.1c8.1 1.6 17.8-15 30.1-15 13.1 0 21.8 17.1 30.1 15 7.4-1.8 15-22.2 15-30.1 0-16.6-20.2-30.1-45.1-30.1s-45.1 13.5-45.1 30.1c-.1 8.5 6.6 28.5 15 30.1z"
    />
    <path
      fill="#FFF"
      d="M355 266.7c6.2.4 12.5-1.8 17.2-6.5l9-9c2.9-2.9 7.5-2.9 10.4 0l9 9c4.7 4.7 11 6.9 17.1 6.5 5.3-.3 32.5-33.5 25.7-32.6-4.6.6-9.1 2.8-12.7 6.3l-.1.1-9 9c-2.9 2.9-7.5 2.9-10.4 0l-9-9c-8.7-8.8-22.9-8.8-31.7-.1l-.1.1-9 9c-2.9 2.9-7.5 2.9-10.4 0l-9-9c-3.5-3.5-7.8-5.6-12.3-6.3-6.7-1.1 20.1 32.2 25.3 32.5zM321.1 206c2.9-2.9 7.5-2.9 10.4 0l9 9c8.8 8.7 22.9 8.7 31.7 0l9-9c2.9-2.9 7.5-2.9 10.4 0l9 9c8.8 8.7 22.9 8.7 31.7 0l9-9c2.9-2.9 7.5-2.9 10.4 0 0 0 5.5-14.8 2.5-15.9-7.9-2.9-17.2-1.2-23.5 5.2l-.1.1-9 9c-2.9 2.9-7.5 2.9-10.4 0l-9-9c-8.7-8.8-22.9-8.8-31.7-.1l-.1.1-9 9c-2.9 2.9-7.5 2.9-10.4 0l-9-9c-6.2-6.2-15.1-8-22.8-5.5-3.1 1.1 1.9 16.1 1.9 16.1z"
    />
  </svg>
)

export var FM = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#338AF3" d="M0 0h513v342H0z" />
    <path
      d="m256 37.9 10.1 31.2H299l-26.6 19.3 10.2 31.2-26.6-19.3-26.6 19.3 10.2-31.2L213 69.1h32.9zM123.2 170.7l31.2-10.2v-32.8l19.3 26.6 31.2-10.2-19.3 26.6 19.3 26.5-31.2-10.1-19.3 26.5v-32.8zM256 303.5l-10.1-31.2H213l26.6-19.3-10.2-31.3L256 241l26.6-19.3-10.2 31.3 26.6 19.3h-32.9zm132.8-132.8-31.2 10.1v32.8l-19.3-26.5-31.2 10.1 19.3-26.5-19.3-26.6 31.2 10.2 19.3-26.6v32.8z"
      fill="#FFF"
    />
  </svg>
)

export var FO = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#FFF" d="M0 0h513v342H0z" />
    <path
      fill="#0F61A5"
      d="M513 214.5H206.2V342h-87.8V214.5H0v-87.7h118.4V0h87.8v126.8H513V192z"
    />
    <path
      fill="#E50E3D"
      d="M513 149.3V192H183.7v150H141V192H0v-42.7h141V0h42.7v149.3z"
    />
  </svg>
)

export var FR = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#FFF" d="M0 0h513v342H0z" />
    <path fill="#00318A" d="M0 0h171v342H0z" />
    <path fill="#D80027" d="M342 0h171v342H342z" />
  </svg>
)

export var GA = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#FFDA44" d="M0 0h513v342H0z" />
    <path fill="#6DA544" d="M0 0h513v114H0z" />
    <path fill="#0052B4" d="M0 228h513v114H0z" />
  </svg>
)

export var GB_ENG = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#FFF" d="M0 0h513v342H0z" />
    <path fill="#D80027" d="M0 136h513v70H0z" />
    <path fill="#D80027" d="M221.5 0h70v342h-70z" />
  </svg>
)

export var GB_NIR = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#FFF" d="M0 0h513v342H0z" />
    <path fill="#D80027" d="M0 136h513v70H0z" />
    <path fill="#D80027" d="M221.5 0h70v342h-70z" />
    <path
      fill="#FFF"
      stroke="#231F20"
      strokeMiterlimit={10}
      d="m256.5 87.8-24 41.4h-48.8l24.7 42.1-24.7 42.1h48.8l24 42.1 24-42.1h48.8l-24.7-42.1 24.7-42.1h-48.8l-24-41.4z"
    />
    <path
      fill="#D80027"
      d="M258.6 130.6c-3.3 0-3.3 3.3-3.3 3.3V160h-2v-22s0-4-3.3-4c-4 0-4 4-4 4v23.4l-2 .7v-16.7s0-4-3.3-4c-4 0-4 4-4 4V174c0 6.7 3.3 13.4 8 17.4v14h24V194c6-3.3 10.7-9.4 12-16.7 0-4 1.3-7.3 2.7-10.7l2.7-9.4s.7-3.3-2.7-4.7-4.7 2-4.7 2l-5.3 12.7h-2v-31.4s0-3.3-3.3-3.3c-4 0-4 3.3-4 3.3v24h-1.3v-26.1c-.2.2-.2-3.1-4.2-3.1z"
    />
    <path
      fill="#FFDA44"
      stroke="#231F20"
      strokeMiterlimit={10}
      d="M249.2 25.7V33h-7.3v14.7h7.3v14c-4-4-9.4-6-14.7-6-12.2-.1-22.1 9.6-22.3 21.8-.1 6.1 2.4 12 6.9 16.3v13.4h74.8V93.8c4-4.7 6.7-10 6.7-16-.2-12.2-10.3-21.9-22.4-21.6-5.3.1-10.4 2.1-14.3 5.6v-14h7.3V33.1h-7.3v-7.3l-14.7-.1z"
    />
  </svg>
)

export var GB_SCT = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#005EB8" d="M0 0h513v342H0z" />
    <path
      fill="#FFF"
      d="M0 302.1V342h59.9l196.6-131.1L453.1 342H513v-39.9L316.4 171 513 39.9V0h-59.9L256.5 131.1 59.9 0H0v39.9L196.7 171z"
    />
  </svg>
)

export var GB_WLS = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#FFF" d="M0 0h513v171H0z" />
    <path fill="#529E3C" d="M0 171h513v171H0z" />
    <path
      fill="#D11C1C"
      d="m201 259.8 28.2-4.8-21.8-10.3 14.9-8.4s25.2 21.2 25.2 14.4c0-7.3 23.7-4.1 22.7-14.4-1.3-14.1-26.2-1-30.6-18.7-2.5-9.9-10.3-8.6-10.3-8.6l-25.1 8.6-12.5 18.7-6.2-18.7s-14.6 11.9-19.5 18.7c-5.2 7.3-10.7 23.5-10.7 23.5l25.6 10.7-37.3-6.6-27.2 6.6-16.7 4.6 7.3-7.7-15-7.6 15-9-7.3-6.1 32.3 6.1s11.8-1.2 16.3-6.1c5.6-6.2 10.1-27.1 10.1-27.1l-14.8-8.6-11.6 21s-8-19.9-15.6-31c-5.7-8.3-24.3-27.3-24.3-27.3l-24 12.6 13.4-26.7s10.6-9.3 3.9-18.8c-6.8-9.5-12.4-30.9-12.4-30.9s14.1 24.4 19.2 22.5c7.2-2.7-9-25 0-28.9 6.5-2.9 7.6 25.5 7.6 25.5l7.3-13.9v17.3s-4.3 20.7 3 33c7.2 12.3 28.7 20.9 28.7 20.9s-5.6-12.3 0-36c3.8-16 17.2-43.4 23.6-52.1 3.3-4.6-26.7 17-26.7 17v-17l-28.6-2.9-7.3 8.3-18.3-30L104 83.1h34.6l-6.7-8.3H104s5.9-12.1 34.6-12.1l13.6-9.2s18.6.5 29 .9c9.3.4 26.1-11.5 26.1-11.5l4.7 11.5-11 17.3 11.1 11.4-4.7 7 8.1 11.5H201l11.1 17.9-11.1-6.3 6.4 17.3-6.4 17.8 28.2-9.5s0-25.6 10.3-37.2C271.1 69.2 322.6 43 322.6 43s-2.7 23.5 4.9 25.4c11.1 2.7 59.4-19.4 59.4-19.4s-29 31.3-23.1 34.1c3.2 1.5 8.5 7 8.5 7s-25.1 20.5-29.3 29.3c-4.2 8.8 6.1 19.4 6.1 19.4s-21.7 0-32.5 9.5c32.5 0 59.1 15.4 74.8 4 10.5-7.6-37.7-2.9-31.4-21.9 2.4-7.1 8.5-15.2 22.6-17.3s19.1 6.3 19.1 6.3l7.6-11.5h-22.4l40.6-39.6 5.3 51.1-13.7-11.4-6.2 19.2c14.6 44.6-52.8 54.1-52.8 54.1l41.6 27.8-14.8 4.2-4.2 41.7 19.1 15.5-25-6.6-49.2 11.2 9.8-15.3-20.6 4.1 13.7-13.1-13.7-6.1 17.6-4.9 22.1 15.2s11-14.2 12.2-21.7c1.3-7.8-4.8-24.2-4.8-24.2s-32.6-.7-44.1-3.5-18.2-11.9-18.2-11.9l-13.1 15.4s45.5 17.1 34.1 24.2c-2.6 1.7-15.7-3.2-15.7-3.2s-22.4 26.2-36.8 29.7c-6.5 1.6 18.3 10.7 18.3 10.7s-21.2-3.4-32-6.6c-11.3-3.4-44.4 6.6-44.4 6.6l-11-10.7zM383.9 138c3.1 0 5.7-2.6 5.7-5.7s-2.6-5.7-5.7-5.7-5.7 2.6-5.7 5.7 2.5 5.7 5.7 5.7z"
    />
  </svg>
)

export var GB = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<g fill="#FFF">
      <path d="M0 0h513v341.3H0V0z" />
      <path d="M311.7 230 513 341.3v-31.5L369.3 230h-57.6zM200.3 111.3 0 0v31.5l143.7 79.8h56.6z" />
    </g>
    <path
      d="M393.8 230 513 295.7V230H393.8zm-82.1 0L513 341.3v-31.5L369.3 230h-57.6zm146.9 111.3-147-81.7v81.7h147zM90.3 230 0 280.2V230h90.3zm110 14.2v97.2H25.5l174.8-97.2zm-82.1-132.9L0 45.6v65.7h118.2zm82.1 0L0 0v31.5l143.7 79.8h56.6zM53.4 0l147 81.7V0h-147zm368.3 111.3L513 61.1v50.2h-91.3zm-110-14.2V0h174.9L311.7 97.1z"
      fill="#012169"
    />
    <g fill="#c8102e">
      <path d="M288 0h-64v138.7H0v64h224v138.7h64V202.7h224v-64H288V0z" />
      <path d="M311.7 230 513 341.3v-31.5L369.3 230h-57.6zm-168 0L0 309.9v31.5L200.3 230h-56.6zm56.6-118.7L0 0v31.5l143.7 79.8h56.6zm168 0L513 31.5V0L311.7 111.3h56.6z" />
    </g>
  </svg>
)

export var GD = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#c60a0a" d="M0 0h513v342H0z" />
    <path fill="#3E8446" d="m256.5 170.7-212 126.1V44.5z" />
    <path
      d="m256.5 170.7 211 126.1h-423zm211-126.2-211 126.2-212-126.2z"
      fill="#FFDA44"
    />
    <path fill="#3E8446" d="M467.5 44.5v252.3l-211-126.1z" />
    <path
      d="m256.5 10.4 2.8 10.2H270l-8.6 6.3 3.3 10.2-8.2-6.3-9.2 6.3 3.3-10.2-8.6-6.3h10.7zm-86.4 0 3.3 10.2h10.7l-8.6 6.3 3.3 10.2-8.7-6.3-8.7 6.3 3.3-10.2-8.6-6.3h10.7zm171.8 0 3.3 10.2H356l-8.7 6.3 3.3 10.2-8.7-6.3-8.7 6.3 3.3-10.2-8.6-6.3h10.7zm-85.4 293.8 2.8 10.2H270l-8.6 6.3 3.3 10.2-8.2-6.3-9.2 6.3 3.3-10.2-8.6-6.3h10.7zm-86.4 0 3.3 10.2h10.7l-8.6 6.3 3.3 10.2-8.7-6.3-8.7 6.3 3.3-10.2-8.6-6.3h10.7zm171.8 0 3.3 10.2H356l-8.7 6.3 3.3 10.2-8.7-6.3-8.7 6.3 3.3-10.2-8.6-6.3h10.7z"
      fill="#FFDA44"
    />
    <circle fill="#c60a0a" cx={244.5} cy={170.7} r={76.2} />
    <path
      fill="#FFDA44"
      d="m244.5 110.1 13.6 41.8h44l-35.6 25.8 13.6 41.8-35.6-25.8-35.5 25.8 13.6-41.8-35.6-25.8h44zm-136.8 57.7c4.4 6.9 2.3 16.1-4.6 20.5s-16.1 2.3-20.5-4.6c-7.9-12.5-3.3-33-3.3-33s20.4 4.6 28.4 17.1z"
    />
    <circle fill="#A2001D" cx={99.1} cy={182.1} r={7.4} />
  </svg>
)

export var GE = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22.5 15" {...rest}>
    {title && <title>{title}</title>}
<path fill="#fff" d="M0 0h22.5v15H0z" />
    <path fill="#eb000e" d="M9.8 6H0v3h9.8v6h3V9h9.8V6h-9.8V0h-3v6z" />
    <path
      fill="#eb000e"
      d="m17.3 2.7-.2-1.2h1l-.2 1.2 1.2-.2v1l-1.2-.2.2 1.2h-1l.2-1.2-1.2.2v-1l1.2.2zm-12.7 0-.2-1.2h1l-.2 1.2 1.2-.2v1l-1.2-.2.2 1.2h-1l.2-1.2-1.2.2v-1l1.2.2zm0 9-.2-1.2h1l-.2 1.2 1.2-.2v1l-1.2-.2.2 1.2h-1l.2-1.2-1.2.2v-1l1.2.2zm12.7 0-.2-1.2h1l-.2 1.2 1.2-.2v1l-1.2-.2.2 1.2h-1l.2-1.2-1.2.2v-1l1.2.2z"
    />
  </svg>
)

export var GF = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90 60" {...rest}>
    {title && <title>{title}</title>}
<path fill="#FDEB01" d="m0 0 90 60H0z" />
    <path fill="#58A846" d="M90 0v60L0 0z" />
    <path
      fill="#ED3D24"
      d="m50.7 33.3 9.3-6.7H48.5L45 15.7l-3.5 10.9H30l9.3 6.7-3.6 11 9.3-6.7 9.3 6.7z"
    />
  </svg>
)

export var GG = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#FFF" d="M0 0h513v342H0z" />
    <path
      fill="#D80027"
      d="M308 0H204v118.7H0v104h204V342h104V222.7h205v-104H308z"
    />
    <path
      fill="#FFDA44"
      d="m368.6 188 26 17.3V136l-26 17.3h-95.3V58.1l17.3-26h-69.2l17.3 26v95.2h-95.3l-26-17.3v69.3l26-17.3h95.3v95.2l-17.3 26h69.2l-17.3-26V188z"
    />
  </svg>
)

export var GH = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#FFDA44" d="M0 0h513v342H0z" />
    <path fill="#D80027" d="M0 0h513v114H0z" />
    <path fill="#496E2D" d="M0 228h513v114H0z" />
    <path d="m255.9 113.8 14.1 43.4 40.4 3.2-37 26.9 19.5 40.3-37-26.9-37 26.9 14.1-43.5-36.9-26.9h45.7z" />
  </svg>
)

export var GI = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#FFF" d="M0 0h513v342H0z" />
    <path fill="#D80027" d="M0 230h513v112H0z" />
    <path
      fill="#D80027"
      stroke="#000"
      strokeMiterlimit={10}
      d="M363.1 131.8V99.1H374V77.3h-21.9v10.9h-21.8V77.3h-21.8v21.8h10.9v32.7h-21.8V55.5h10.9V33.7h-21.8v10.9h-10.9V33.7H254v10.9h-10.9V33.7h-21.8v21.8h10.9v76.3h-21.8V99.1h10.9V77.3h-21.8v10.9h-21.8V77.3h-21.8v21.8h10.9v32.7H145V219h239.9v-87.2z"
    />
    <path
      fill="#FFDA44"
      stroke="#000"
      strokeMiterlimit={10}
      d="m264.9 235.5-24.2 18.2 19.1 14.3v31.3h-23.2v9h23v7.9h-23v9.3H270V268l19.1-14.3-24.2-18.2zm0 25.3-10.1-7.1 10.1-7.1 10.1 7.1-10.1 7.1z"
    />
    <path d="M239.6 209.7v-27.9s.1-22.3 25-22.3c24.8 0 25.7 22 25.7 22v28.2h-50.7zm-69.1 0v-24.3s.1-18.7 19.6-18.7 20.2 18.4 20.2 18.4v24.5h-39.8z" />
    <path d="M169.1 209.7v-24.3s.1-18.7 19.6-18.7 20.2 18.4 20.2 18.4v24.5h-39.8zm151.8 0v-24.3s.1-18.7 19.6-18.7 20.2 18.4 20.2 18.4v24.5h-39.8zm8.4-77.7v-15.7s.1-12.1 11.3-12.1c11.3 0 11.7 11.9 11.7 11.9V132h-23zm-78.8 0v-23.7s.1-18.3 14.3-18.3c14.2 0 14.7 18 14.7 18v24h-29zm-73 0v-15.7s.1-12.1 11.3-12.1 11.7 11.9 11.7 11.9V132h-23z" />
  </svg>
)

export var GL = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#D80027" d="M0 0h513v342H0z" />
    <path fill="#FFF" d="M513 0v171H0V0z" />
    <circle fill="#FFF" cx={185.8} cy={171.2} r={117.8} />
    <path
      fill="#D80027"
      d="M68 171c0-65.1 52.8-117.8 117.8-117.8 65.1 0 117.8 52.8 117.8 117.8"
    />
  </svg>
)

export var GM = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#FFF" d="M0 0h513v342H0z" />
    <path fill="#cf0d19" d="M0 0h513v100H0z" />
    <path fill="#0052B4" d="M0 121h513v100H0z" />
    <path fill="#1a7e25" d="M0 242h513v100H0z" />
  </svg>
)

export var GN = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#FFDA44" d="M0 0h512v342H0z" />
    <path fill="#6DA544" d="M342 0h171v342H342z" />
    <path fill="#D80027" d="M0 0h171v342H0z" />
  </svg>
)

export var GP = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#FFF" d="M0 0h513v342H0z" />
    <path fill="#00318A" d="M0 0h171v342H0z" />
    <path fill="#D80027" d="M342 0h171v342H342z" />
  </svg>
)

export var GQ = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#FFF" d="M0 0h513v342H0z" />
    <path fill="#6DA544" d="M0 0h513v113.8H0z" />
    <path fill="#D80027" d="M0 227.6h513V342H0z" />
    <path fill="#0070C8" d="M126 171 0 342V0z" />
    <path
      fill="none"
      stroke="#000"
      strokeMiterlimit={10}
      d="M233.8 139.4v40.4c0 35.6 35.6 35.6 35.6 35.6s35.6 0 35.6-35.6v-40.4h-71.2z"
    />
    <path fill="#786145" d="M264.5 179.8h9.8l4 25.8h-17.8z" />
    <path
      fill="#6DA544"
      d="M287.2 162c0-9.8-8-14.8-17.8-14.8s-17.8 5-17.8 14.8c-4.9 0-8.9 4-8.9 8.9s4 8.9 8.9 8.9h35.6c4.9 0 8.9-4 8.9-8.9s-4-8.9-8.9-8.9z"
    />
    <path
      d="m230.7 120 1.9 3.3h3.8l-1.9 3.3 1.9 3.2h-3.8l-1.9 3.3-1.9-3.3H225l1.9-3.2-1.9-3.3h3.8zm15.3 0 1.9 3.3h3.7l-1.9 3.3 1.9 3.2h-3.7l-1.9 3.3-1.9-3.3h-3.8l1.9-3.2-1.9-3.3h3.8zm15.3 0 1.9 3.3h3.7l-1.9 3.3 1.9 3.2h-3.7l-1.9 3.3-1.9-3.3h-3.8l1.9-3.2-1.9-3.3h3.8zm15.8 0 1.9 3.3h3.8l-1.9 3.3 1.9 3.2H279l-1.9 3.3-1.9-3.3h-3.7l1.8-3.2-1.8-3.3h3.7zm16 0 1.9 3.3h3.8l-1.9 3.3 1.9 3.2H295l-1.9 3.3-1.9-3.3h-3.7l1.8-3.2-1.8-3.3h3.7zm15 0 1.9 3.3h3.7l-1.9 3.3 1.9 3.2H310l-1.9 3.3-1.9-3.3h-3.8l1.9-3.2-1.9-3.3h3.8z"
      fill="#FFDA00"
      stroke="#000"
      strokeMiterlimit={10}
    />
  </svg>
)

export var GR = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#FFF" d="M0 0h513v342H0z" />
    <g fill="#0d5eaf">
      <path d="M0 0h513v38H0zm0 76h513v38H0zm0 76h513v38H0zm0 76h513v38H0zm0 76h513v38H0z" />
      <path d="M0 0h190v190H0z" />
    </g>
    <g fill="#FFF">
      <path d="M0 76h190v38H0z" />
      <path d="M76 0h38v190H76z" />
    </g>
  </svg>
)

export var GS = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#012169" d="M0 0h513v342H0z" />
    <path fill="#012169" d="M0 0h256.5v171H0z" />
    <g fill="#FFF">
      <path d="M256.5 0v30.6l-45.3 25.2h45.3v59.4h-59.2l59.2 32.9V171h-26.7l-73.7-40.9V171h-55.7v-48.7L12.8 171H0v-30.6l45.3-25.2H0V55.8h59.2L0 22.9V0h26.7l73.7 40.9V0h55.7v48.7L243.7 0z" />
      <path d="M156.1 115.2 256.5 171v-15.8l-72-40zm-55.7-59.4L0 0v15.8l72 40z" />
    </g>
    <g fill="#D80027">
      <path d="M144.3 0h-32.1v69.5H0v32h112.2V171h32.1v-69.5h112.2v-32H144.3z" />
      <path d="M156.1 115.2 256.5 171v-15.8l-72-40zm-84.1 0-72 40V171l100.4-55.8zm28.4-59.4L0 0v15.8l72 40zm84.1 0 72-40V0L156.1 55.8z" />
    </g>
    <ellipse fill="#FFF" cx={443.4} cy={233.6} rx={29} ry={43.5} />
    <ellipse fill="#FFCE00" cx={406.9} cy={317.7} rx={22} ry={9.3} />
    <ellipse fill="#FFCE00" cx={364} cy={317.7} rx={22} ry={9.3} />
    <path fill="#39B200" d="m342 190.1 43.4 86.9 43.5-86.9z" />
    <ellipse fill="#9B9B9B" cx={327.5} cy={233.6} rx={29} ry={43.5} />
    <path
      fill="#757575"
      d="m371 175.6-14.5 14.5h57.9l-14.5-14.5 14.5-43.5s-13-29-29-29-29 29-29 29l14.6 43.5z"
    />
    <circle fill="#C6B56F" cx={385.4} cy={67} r={29} />
    <circle fill="#923f00" cx={386} cy={88.7} r={29} />
    <circle fill="#FFF" cx={443.4} cy={117.7} r={29} />
    <circle fill="#0049FF" cx={342.2} cy={146.7} r={29} />
    <circle fill="#0041F9" cx={429.8} cy={146.7} r={29} />
    <circle fill="#F7D71E" cx={386} cy={233.6} r={29} />
    <circle fill="#CEC851" cx={457.9} cy={190.1} r={29} />
    <circle fill="#FFF" cx={385.4} cy={289.5} r={29} />
    <path
      fill="#7C0B29"
      d="m371 135.7 14.5-3.5 14.5 3.5c0 7.5-14.5 11-14.5 11s-14.5-3.5-14.5-11z"
    />
    <circle fill="#FFF" cx={327.5} cy={117.4} r={29} />
  </svg>
)

export var GT = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#FFF" d="M0 0h513v342H0z" />
    <path d="M0 0h171v342H0zm342 0h171v342H342z" fill="#338AF3" />
    <circle fill="#DCC26D" cx={256} cy={155.8} r={25.5} />
    <path
      fill="#628A40"
      d="M194.2 155.9c0 22.1 11.8 42.5 30.8 53.5 5.9 3.4 13.5 1.4 16.9-4.5 3.4-5.9 1.4-13.5-4.5-16.9-11.5-6.6-18.5-18.9-18.5-32.1 0-6.8-5.5-12.4-12.4-12.4s-12.3 5.5-12.3 12.4zm95.1 52.1c17.8-11.4 28.6-31 28.5-52.1 0-6.8-5.5-12.4-12.4-12.4-6.8 0-12.4 5.5-12.4 12.4 0 12.7-6.5 24.5-17.1 31.3-5.8 3.6-7.7 11.2-4.1 17 3.6 5.8 11.2 7.7 17 4.1.2-.1.3-.2.5-.3z"
    />
  </svg>
)

export var GU = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#D80027" d="M0 0h513v342H0z" />
    <path fill="#0052B4" d="M11.1 11.1h489.7v319.1H11.1z" />
    <path
      fill="#7DBEF1"
      d="M256 285.3s76.4-51.3 76.4-114.6S256 56 256 56s-76.4 51.3-76.4 114.6S256 285.3 256 285.3z"
    />
    <path fill="#1C8AE6" d="M179.8 180.7h152.6l-29.3 64.9h-95.2z" />
    <path
      fill="#FFF042"
      d="M192.3 205.9s40.5 38.2 51 38.2c12.4 0 12.6-18.4 25.5-25.5 20.2-11.1 51-12.7 51-12.7L297 248.7l-41 36.6-46.8-39.7-16.9-39.7z"
    />
    <path
      fill="#259C7B"
      d="m256 157.5-22.5 15.6 7.9-26.2-21.8-16.5 27.4-.5 9-25.9 9 25.9 27.4.5-21.8 16.6 7.9 26.2-22.5-15.7z"
    />
    <path
      fill="#8E5715"
      d="M249.7 144.6c-.9 9.2-1.5 18.4-1.7 27.6-.3 11.9.3 20.7 2 26 2.2 6.6 7.2 12.9 14.2 18.9 5.3 4.6 10.6 8.1 14.2 10.1 3.1 1.7 7 .6 8.7-2.4 1.7-3.1.6-7-2.4-8.7-4.3-2.5-8.4-5.4-12.2-8.7-5.4-4.6-9.1-9.2-10.4-13.3-1.1-3.4-1.6-11.3-1.4-21.7.2-8.9.8-17.8 1.7-26.6.4-3.5-2.2-6.6-5.7-7-3.6-.3-6.7 2.3-7 5.8z"
    />
    <path fill="#FFF" d="m217.8 170.7 25.5 38.2h-25.5v-38.2z" />
    <path
      fill="none"
      stroke="#D80027"
      strokeWidth={12}
      strokeMiterlimit={10}
      d="M256 285.3s76.4-51.3 76.4-114.6S256 56 256 56s-76.4 51.3-76.4 114.6S256 285.3 256 285.3z"
    />
  </svg>
)

export var GW = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#6DA544" d="M0 0h512v342H0z" />
    <path fill="#FFDA44" d="M0 0h512v171H0z" />
    <path fill="#D80027" d="M0 0h182v342H0z" />
    <path d="m98.3 109.8 15.1 46.5h48.9L122.8 185l15.1 46.5-39.6-28.7-39.5 28.7L73.9 185l-39.6-28.7h48.9z" />
  </svg>
)

export var GY = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 900 600" {...rest}>
    {title && <title>{title}</title>}
<path fill="#009E49" d="M0 0h900v600H0V0z" />
    <path fill="#FFF" d="m0 0 947 300L0 600V0z" />
    <path fill="#FFD00D" d="M0 26.1 870 300 0 573.9V26.1z" />
    <path fill="#2D2D2D" d="m0 0 450 300L0 600V0z" />
    <path fill="#D3132F" d="m0 35 397.5 265L0 565V35z" />
  </svg>
)

export var HK = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 14" {...rest}>
    {title && <title>{title}</title>}
<path fill="#FFF" d="M0 0h21v14H0V0z" />
    <path fill="#EE1C25" d="M0 0h21v14H0V0z" />
    <path
      fill="#FFF"
      d="M12 6.7c-.8-.5-1 .4-1 0 0-.8.9-1.5 2-1.5s2 .7 2 1.5c-.9 0-1 .5-1.5.5-.6 0-.7 0-1.5-.5zm1.2-.2c.1 0 .2-.1.2-.2s0-.3-.2-.3-.2.1-.2.2.1.3.2.3zm-1.8 2c.2-.9-.7-.8-.3-.9.8-.3 1.7.4 2 1.4.3 1.1 0 2.1-.8 2.4-.3-.9-.8-.8-.9-1.3-.1-.6-.2-.7 0-1.6zm.6 1.1c0 .1.2.2.3.2.1 0 .2-.2.2-.3s-.2-.2-.3-.2c-.2 0-.2.2-.2.3zM9.6 8.5c.9-.1.6-.9.8-.6.5.7.2 1.7-.7 2.4-.9.6-2 .6-2.5 0 .8-.6.6-1 .9-1.3.4-.4.5-.5 1.5-.5zm-.9.9c-.1 0-.2.2-.1.3s.3.2.4.1.1-.3 0-.4-.2-.1-.3 0zM9 6.7c.3.9 1 .3.8.6-.5.7-1.6.7-2.5 0-.9-.6-1.2-1.7-.7-2.4.8.6 1.1.2 1.5.5.4.4.5.4.9 1.3zm-1.1-.6c-.1-.1-.3 0-.4.1s-.1.3 0 .4c.1.1.3 0 .3-.1.2-.1.2-.3.1-.4zm2.6-.5c-.7.6.1 1.1-.3 1-.8-.3-1.2-1.4-.8-2.4.3-1 1.3-1.7 2-1.4-.3.9.2 1.1 0 1.6-.1.5-.2.6-.9 1.2zm.2-1.2c0-.1 0-.3-.1-.3s-.3 0-.3.1 0 .3.2.3c0 .1.1 0 .2-.1z"
    />
  </svg>
)

export var HM = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#012169" d="M0 0h513v342H0z" />
    <path fill="#012169" d="M0 0h256.5v171H0z" />
    <g fill="#FFF">
      <path d="M256.5 0v30.6l-45.3 25.2h45.3v59.4h-59.2l59.2 32.9V171h-26.7l-73.7-40.9V171h-55.7v-48.7L12.8 171H0v-30.6l45.3-25.2H0V55.8h59.2L0 22.9V0h26.7l73.7 40.9V0h55.7v48.7L243.7 0z" />
      <path d="M156.1 115.2 256.5 171v-15.8l-72-40zm-55.7-59.4L0 0v15.8l72 40z" />
    </g>
    <g fill="#D80027">
      <path d="M144.3 0h-32.1v69.5H0v32h112.2V171h32.1v-69.5h112.2v-32H144.3z" />
      <path d="M156.1 115.2 256.5 171v-15.8l-72-40zm-84.1 0-72 40V171l100.4-55.8zm28.4-59.4L0 0v15.8l72 40zm84.1 0 72-40V0L156.1 55.8z" />
    </g>
    <path
      d="m189.2 212.6 11 22.9 24.7-5.7-11.1 22.8 19.9 15.8L209 274v25.4l-19.8-15.9-19.8 15.9.1-25.4-24.8-5.6 19.9-15.8-11.1-22.8 24.8 5.7zm197.9 28.5 5.2 10.9 11.8-2.7-5.3 10.9 9.5 7.5-11.8 2.6v12.2l-9.4-7.6-9.5 7.6.1-12.2-11.9-2.6 9.5-7.5-5.3-10.9 11.9 2.7zm-48.6-116 5.2 10.9 11.8-2.7-5.3 10.9 9.5 7.5-11.8 2.7v12.1l-9.4-7.6-9.5 7.6v-12.1l-11.8-2.7 9.5-7.5-5.3-10.9 11.8 2.7zm48.6-66.2 5.2 10.9 11.8-2.7-5.3 10.9 9.5 7.5-11.8 2.7v12.1l-9.4-7.6-9.5 7.6.1-12.1-11.9-2.7 9.5-7.5-5.3-10.9 11.9 2.7zm42.4 49.7 5.3 10.9 11.8-2.7-5.3 10.9 9.5 7.5-11.8 2.6V150l-9.5-7.6-9.4 7.6v-12.2l-11.8-2.6 9.5-7.5-5.3-10.9 11.8 2.7zm-30.3 57.9 4.1 12.7h13.3l-10.8 7.8 4.1 12.6-10.7-7.8-10.8 7.8 4.1-12.6-10.7-7.8h13.3z"
      fill="#FFF"
    />
  </svg>
)

export var HN = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#FFF" d="M0 0h513v342H0z" />
    <path
      d="M0 0h513v114H0zm0 228h513v114H0zm203.5-110.1 6.7 16.6 17.6 1-14 10.9 4.7 17.7-15-9.9-15 9.9 4.7-17.7-14-10.9 17.6-1zm105 0 6.7 16.6 17.6 1-14 10.9 4.7 17.7-15-9.9-15 9.9 4.7-17.7-14-10.9 17.6-1zM256 147.6l6.7 16.6 17.6 1-14 10.9 4.7 17.7-15-9.9-15 9.9 4.7-17.7-14-10.9 17.6-1zm-52.5 29.7 6.7 16.6 17.6 1-14 10.9 4.7 17.6-15-9.9-15 9.9 4.7-17.6-14-10.9 17.6-1zm105 0 6.7 16.6 17.6 1-14 10.9 4.7 17.6-15-9.9-15 9.9 4.7-17.6-14-10.9 17.6-1z"
      fill="#338AF3"
    />
  </svg>
)

export var HR = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#FFF" d="M0 0h513v342H0z" />
    <path fill="#D80027" d="M0 0h513v114H0z" />
    <path fill="#0052B4" d="M0 228h513v114H0z" />
    <path
      d="M309.3 113.2v-44l17.5-14.4 17.7 14.4v44zm-105.6 0v-44l-17.3-14.4-17.9 14.4v44zm35.2 0v-44l17.6-14.4 17.6 14.4v44z"
      fill="#338AF3"
    />
    <path
      d="M309.3 113.2h-35.2v-44l17.5-14.4 17.7 14.4zm-70.4 0h-35.2v-44l17.5-14.4 17.7 14.4z"
      fill="#0052B4"
    />
    <path
      stroke="#D80027"
      fill="#FFF"
      d="M168.5 113.2v101.9c0 24.3 14.4 46.2 35.4 59.4 21.3 13.4 42.1 14.7 52.6 14.7s31.4-1.7 52.6-14.8c21-13 35.4-35.1 35.4-59.3V113.2h-176z"
    />
    <path
      d="M168.5 113.2h35.2v35.2h-35.2zm70.4 0h35.2v35.2h-35.2zm70.4 0h35.2v35.2h-35.2zm-105.6 35.2h35.2v35.2h-35.2zm70.4 0h35.2v35.2h-35.2zm-105.6 35.2h35.2v35.2h-35.2zm35.2 35.2h35.2V254h-35.2zm35.2-35.2h35.2v35.2h-35.2zm70.4 0h35.2v35.2h-35.2zm-35.2 35.2h35.2V254h-35.2zm35.2 55.5c8.6-5.4 16.2-12.3 22-20.3h-22v20.3zM181.7 254c5.8 8 13.3 14.9 22 20.4V254h-22zm57.2 0v33.7c7.2 1.2 13.3 1.5 17.6 1.5 4.3 0 10.4-.3 17.6-1.6V254h-35.2z"
      fill="#D80027"
    />
  </svg>
)

export var HT = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#A2001D" d="M0 0h513v172H0z" />
    <path fill="#0052B4" d="M0 172h513v172H0z" />
    <path fill="#FFF" d="m381.4 251.5-110.7-13.8-110.8 13.8V85.4h221.5z" />
    <circle fill="#0052B4" cx={270.7} cy={182.3} r={55.4} />
    <circle fill="#A2001D" cx={270.7} cy={182.3} r={27.7} />
    <path fill="#6DA544" d="M229.1 113.1h83.1l-41.5 41.5z" />
    <path fill="#FFDA44" d="M256.8 140.8h27.7v83h-27.7z" />
    <path fill="#6DA544" d="M314.9 215.5h-88.5l-66.5 36h221.5z" />
  </svg>
)

export var HU = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#FFF" d="M0 0h513v342H0z" />
    <path fill="#D80027" d="M0 0h513v114H0z" />
    <path fill="#6DA544" d="M0 228h513v114H0z" />
  </svg>
)

export var IC = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 200" {...rest}>
    {title && <title>{title}</title>}
<path fill="#fc0" d="M0 0h300v200H0z" />
    <path fill="#0768a9" d="M0 0h200v200H0z" />
    <path fill="#fff" d="M0 0h100v200H0z" />
  </svg>
)

export var ID = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#FFF" d="M0 0h513v342H0z" />
    <path fill="#E00" d="M0 0h513v171H0z" />
  </svg>
)

export var IE = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#FFF" d="M0 0h513v342H0z" />
    <path fill="#6DA544" d="M0 0h171v342H0z" />
    <path fill="#FF9811" d="M342 0h171v342H342z" />
  </svg>
)

export var IL = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#FFF" d="M0 0h513v342H0z" />
    <path
      d="M340.6 122.4h-56.1l-28-48.6-28 48.6h-56.1l28 48.6-28 48.6h56.1l28 48.6 28-48.6h56.1l-28-48.6 28-48.6zM293.2 171 276 204.2h-38.9L219.8 171l17.2-33.2h38.9l17.3 33.2zm-36.7-71.8 11.9 23.3h-23.9l12-23.3zm-58.3 38.6h23.9l-10.8 21-13.1-21zm0 66.4 13-22.1 11.9 22.1h-24.9zm58.3 37.5-11.9-22.1h23.9l-12 22.1zm59.4-37.5h-25l11.9-22.1 13.1 22.1zm-26.1-66.4h26.1l-13 22.1-13.1-22.1zM0 21.3h512V64H0zm0 256h512V320H0z"
      fill="#2E52B2"
    />
  </svg>
)

export var IM = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#E52D42" d="M0 0h513v342H0z" />
    <path
      fill="#FFF"
      d="M393.3 68.2h-45.8l-33.8 80.2-34.4-22.9s-24.7-59.1-34.4-68.2c-9.7-9.7-18.7-.6-48.9 7.8-29.6 8.4-30.8 18.7-42.2 18.7-4.8 0-19.9-17.5-27.7-22.3-12.1-7.8-16.9-4.2-13.9 7.2 1.2 4.8 10.9 10.9 16.9 19.9 7.8 11.5 12.7 25.9 12.7 25.9s10.9-10.3 16.9-12.1c9-2.4 19.3 1.8 31.4 0 15.1-2.4 31.4-10.9 31.4-10.9l4.2 43.4s-54.3 50.7-49.5 70.6 56.1 44.6 68.2 62.7c12.1 17.5-7.2 24.1-7.2 32.6s-1.8 19.9 7.2 16.3c9-3.6 10.3-18.1 18.7-31.4 6-9 10.3-13.9 11.5-17.5 1.8-9-23.5-32-37.4-48.9-6.6-7.8-19.9-18.7-19.9-18.7l39.2-29.6s67.6 27.7 82.6 18.7c15.1-9 19.3-98.3 19.3-98.3l47-11.5-12.1-11.7z"
    />
    <path
      fill="#F8DD4E"
      d="M279.3 262.4c-6 0-11.5-4.8-11.5-11.5s4.8-11.5 11.5-11.5c6 0 11.5 4.8 11.5 11.5s-5.5 11.5-11.5 11.5zm45.8-182.8c-6 0-11.5-4.8-11.5-11.5s4.8-11.5 11.5-11.5c6 0 11.5 4.8 11.5 11.5s-5.5 11.5-11.5 11.5zm0 91.1c-6 0-11.5-4.8-11.5-11.5 0-6 4.8-11.5 11.5-11.5 6 0 11.5 4.8 11.5 11.5-.6 6.7-5.5 11.5-11.5 11.5zm-136.9 45.8c-6 0-11.5-4.8-11.5-11.5 0-6 4.8-11.5 11.5-11.5 6.6 0 11.5 4.8 11.5 11.5s-5.5 11.5-11.5 11.5zm45.2-136.9c-6 0-11.5-4.8-11.5-11.5s4.8-11.5 11.5-11.5c6 0 11.5 4.8 11.5 11.5s-4.8 11.5-11.5 11.5zm22.9 91.1c-6 0-11.5-10.3-11.5-22.9s4.8-22.9 11.5-22.9c6 0 11.5 10.3 11.5 22.9s-4.8 22.9-11.5 22.9zm-114-45.2c-6 0-11.5-4.8-11.5-11.5 0-6.6 4.8-11.5 11.5-11.5 6.6 0 11.5 4.8 11.5 11.5 0 6.6-4.8 11.5-11.5 11.5z"
    />
  </svg>
)

export var IN = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#ff6820" d="M0 0h513v114H0V0z" />
    <path fill="#FFF" d="M0 114h513v114H0V114z" />
    <path fill="#046a38" d="M0 228h513v114H0V228z" />
    <path
      fill="none"
      stroke="#07038d"
      strokeWidth={4}
      d="M256.5 136.8c18.9 0 34.2 15.3 34.2 34.2s-15.3 34.2-34.2 34.2-34.2-15.3-34.2-34.2 15.3-34.2 34.2-34.2z"
    />
    <path
      d="m265.3 138.2-17.6 65.7m17.6-65.7-17.6 65.7m25.8-62.3-34 58.9m41-53.5-48 48m53.4-41L227 188m62.3-25.8-65.7 17.6m66.9-8.8h-68m66.8 8.8-65.7-17.6m62.3 25.8L227 154m53.5 41-48-48m41 53.4-34-58.9m25.8 62.3-17.6-65.7m8.8 66.9v-68m-8.8 66.8 17.6-65.7m-25.8 62.3 34-58.9m-41 53.5 48.1-48.1M227.1 188l58.9-34m-62.3 25.8 65.7-17.6m-66.9 8.8h68m-66.8-8.8 65.7 17.6M227.1 154l58.9 34m-53.5-41 48.1 48.1m-41.1-53.5 34 58.9m-25.8-62.3 17.6 65.7"
      stroke="#07038d"
      strokeWidth={2}
    />
  </svg>
)

export var IO = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#FFF" d="M0-.3h513V342H0V-.3z" />
    <path
      fill="#012169"
      d="M462.9 198.1c-4 0-14-5-21-9-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-16 9-20 9s-14-5-20-9c-11-6-22-12-32.1-12-9 0-20 6-31.1 12-7 4-16 9-20 9s-13-5-20-9c-11-6-22-12-31.1-12-10 0-21 6-32.1 12-6 4-16 9-20 9s-13-5-20-9c-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-17 9-21 9s-13-5-20-9c-10-6-20-12-30.1-12v22l19 10c11 6 21 12 31.1 12s21-6 32.1-12c6-4 16-10 20-10s13 6 20 10c11 6 21 12 31.1 12s20-6 31.1-12c7-4 17-10 21-10s13 6 20 10c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-10 20-10s14 6 21 10c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-10 20-10s14 6 20 10c11 6 22 12 32.1 12s20-6 31.1-12l19-10v-22c-10 0-20 6-30.1 12-7 4-16 9-20 9zM0 31.7l19 10c11 6 21 12 31.1 12s21-6 32.1-12c6-4 16-10 20-10s13 6 20 10c11 6 21 12 31.1 12s20-6 31.1-12c7-4 17-10 21-10s13 6 20 10c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-10 20-10s14 6 21 10c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-10 20-10s14 6 20 10c11 6 22 12 32.1 12s20-6 31.1-12l19-10v-22c-10 1-20 6-30.1 12-7 4-16 9-20 9s-14-5-21-9c-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-16 9-20 9s-14-5-20-9c-11-6-22-12-32.1-12s-20 6-31.1 12c-7 4-16 9-20 9s-13-5-20-9c-11-6-22-12-31.1-12s-21 6-32.1 12c-6 4-16 9-20 9s-13-5-20-9c-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-17 9-21 9s-13-5-20-9c-10-6-20-11-30.1-12v22zm462.9 55.2c-4 0-14-5-21-9-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-16 9-20 9s-14-5-20-9c-11-6-22-12-32.1-12-9 0-20 6-31.1 12-7 4-16 9-20 9s-13-5-20-9c-11-6-22-12-31.1-12-10 0-21 6-32.1 12-6 4-16 9-20 9s-13-5-20-9c-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-17 9-21 9s-13-5-20-9c-10-6-20-12-30.1-12v22l19 9c11 6 21 12 31.1 12s21-6 32.1-12c6-4 16-9 20-9s13 5 20 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 17-9 21-9s13 5 20 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-9 20-9s14 5 21 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-9 20-9s14 5 20 9c11 6 22 12 32.1 12s20-6 31.1-12l19-9v-22c-10 0-20 6-30.1 12-7 3.9-16 9-20 9zm50.1 34c-10 1-20 6-30.1 12-7 4-16 10-20 10s-14-6-21-10c-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-16 10-20 10s-14-6-20-10c-11-6-22-12-32.1-12s-20 6-31.1 12c-7 4-16 10-20 10s-13-6-20-10c-11-6-22-12-31.1-12s-21 6-32.1 12c-6 4-16 10-20 10s-13-6-20-10c-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-17 10-21 10s-13-6-20-10c-10-6-20-11-30.1-12v23c4 1 13 5 19 9 11 6 21 12 31.1 12s21-6 32.1-12c6-4 16-9 20-9s13 5 20 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 17-9 21-9s13 5 20 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-9 20-9s14 5 21 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-9 20-9s14 5 20 9c11 6 22 12 32.1 12s20-6 31.1-12c6-4 15-8 19-9v-23zm-50.1 133.3c-4 0-14-5-21-9-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-16 9-20 9s-14-5-20-9c-11-6-22-12-32.1-12-9 0-20 6-31.1 12-7 4-16 9-20 9s-13-5-20-9c-11-6-22-12-31.1-12-10 0-21 6-32.1 12-6 4-16 9-20 9s-13-5-20-9c-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-17 9-21 9s-13-5-20-9c-10-6-20-12-30.1-12v22l19 9c11 6 21 12 31.1 12s21-6 32.1-12c6-4 16-9 20-9s13 5 20 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 17-9 21-9s13 5 20 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-9 20-9s14 5 21 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-9 20-9s14 5 20 9c11 6 22 12 32.1 12s20-6 31.1-12l19-9v-22c-10 0-20 6-30.1 12-7 4-16 9-20 9zm50.1 34c-10 1-20 6-30.1 12-7 4-16 10-20 10s-14-6-21-10c-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-16 10-20 10s-14-6-20-10c-11-6-22-12-32.1-12s-20 6-31.1 12c-7 4-16 10-20 10s-13-6-20-10c-11-6-22-12-31.1-12s-21 6-32.1 12c-6 4-16 10-20 10s-13-6-20-10c-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-17 10-21 10s-13-6-20-10c-10-6-20-11-30.1-12v23c4 0 13 5 19 9 11 6 21 12 31.1 12s21-6 32.1-12c6-4 16-9 20-9s13 5 20 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 17-9 21-9s13 5 20 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-9 20-9s14 5 21 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-9 20-9s14 5 20 9c11 6 22 12 32.1 12s20-6 31.1-12c6-4 15-9 19-9v-23z"
    />
    <g strokeWidth={2} strokeMiterlimit={10}>
      <path
        d="M389.8 119.9H408v78.8h-18.3l.1-78.8zm0 117.8H408v75.1h-18.3l.1-75.1z"
        fill="#a24300"
        stroke="#000"
      />
      <path
        fill="#006d00"
        stroke="#004100"
        d="M462.8 91.5h-29.1l25.7-25.7c4.5-4.4 4.5-11.4 0-15.8l-3.4-3.4c-4.4-4.4-11.4-4.4-15.8 0l-25.9 25.9V37.4c0-6.2-5.1-11.3-11.3-11.3h-4.7c-6.2 0-11.3 5.1-11.3 11.3v31.7l-23.5-23.8c-4.7-4.7-12.2-4.7-16.9 0l-3.6 3.6c-4.7 4.7-4.7 12.4 0 17.2l25 25.4h-30.6c-6 0-10.9 4.9-10.9 10.9v4.6c0 6 4.9 10.9 10.9 10.9H369l-20.7 20.7c-4.4 4.4-4.4 11.4 0 15.8l3.4 3.4c4.4 4.4 11.4 4.4 15.8 0l19.6-19.6V167c0 6.1 5.1 11.1 11.3 11.3h4.7c6.2 0 11.3-5.1 11.3-11.3v-28.3l22.2 22.6c4.7 4.7 12.4 4.7 17.1 0l3.6-3.6c4.7-4.7 4.7-12.4 0-17.2L435.2 118h27.6c5.9 0 10.7-4.9 10.9-10.9v-4.6c0-6.1-4.9-11-10.9-11z"
      />
      <path
        fill="#fed100"
        stroke="#525625"
        d="M439.2 249.1h-79.8s-.9-13.4-6-21.8c-6.2-10.4-13.9-28.1-1.4-36.7 15.9-10.9 33.7.8 48.2.8 11.8.1 26.9-14 45-.8 12.2 8.9 3.9 28.2-1.3 36.7-7 11.5-4.7 21.8-4.7 21.8z"
      />
    </g>
    <path fill="#012169" d="M0 0h256.5v171H0z" />
    <g fill="#FFF">
      <path d="M256.5 0v30.6l-45.3 25.2h45.3v59.4h-59.2l59.2 32.9V171h-26.7l-73.7-40.9V171h-55.7v-48.7L12.8 171H0v-30.6l45.3-25.2H0V55.8h59.2L0 22.9V0h26.7l73.7 40.9V0h55.7v48.7L243.7 0z" />
      <path d="M156.1 115.2 256.5 171v-15.8l-72-40zm-55.7-59.4L0 0v15.8l72 40z" />
    </g>
    <g fill="#D80027">
      <path d="M144.3 0h-32.1v69.5H0v32h112.2V171h32.1v-69.5h112.2v-32H144.3z" />
      <path d="M156.1 115.2 256.5 171v-15.8l-72-40zm-84.1 0-72 40V171l100.4-55.8zm28.4-59.4L0 0v15.8l72 40zm84.1 0 72-40V0L156.1 55.8z" />
    </g>
  </svg>
)

export var IQ = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#FFF" d="M0 0h513v342H0z" />
    <path fill="#CE1126" d="M0 0h513v114H0z" />
    <path d="M0 228h513v114H0z" />
    <path
      d="M219.2 160.7h-29.3c1.5-5.7 6.6-9.9 12.8-9.9v-19.9c-18.3 0-33.1 14.9-33.1 33.1v16.5h49.6c1.8 0 3.3 1.5 3.3 3.3v6.6h-66.2v19.9h86.1v-26.5c0-12.7-10.4-23.1-23.2-23.1zm49.6 29.8v-59.6H249v79.5h33.1v-19.9zm66.2 0v-59.6h-19.8v59.6h-6.6v-19.8h-19.9v39.7h59.6v-19.9z"
      fill="#547C31"
    />
  </svg>
)

export var IR = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#FFF" d="M0 0h512v342H0z" />
    <path fill="#6DA544" d="M0 0h513v114H0z" />
    <path
      d="M0 227.9h513v114H0zm278.8-93.1c.1 2 8.7 26.2 4.4 39.4-6.6 20.3-15.8 21.8-19.8 24.5V134l-6.9-4.2-6.9 4.2v64.7c-4-2.7-12.4-2.4-19.8-24.5-4.3-12.7 5.7-37.3 5.8-39.2 0 0-9.5 8.1-15.8 24-5.9 14.8 1.9 49.6 29.5 54.8 2.3.4 4.7 5.6 7.2 5.6 2.1 0 4.1-5.2 6-5.5 28.4-4.6 35-41.7 29.9-55.6-5.4-14.6-13.6-23.5-13.6-23.5z"
      fill="#D80027"
    />
    <path
      d="M44.6 98.9h22.3v24.4H44.6zM0 98.9h22.3v24.4H0zm89.2 0h22.3v24.4H89.2zm44.6 0h22.3v24.4h-22.3zm44.6 0h22.3v24.4h-22.3zm44.6 0h22.3v24.4H223zm44.7 0H290v24.4h-22.3zm44.6 0h22.3v24.4h-22.3zm44.6 0h22.3v24.4h-22.3zm44.6 0h22.3v24.4h-22.3zm44.6 0h22.3v24.4h-22.3zm44.6 0H513v24.4h-22.3zm-446.1 118h22.3v25.5H44.6zm-44.6 0h22.3v25.5H0zm89.2 0h22.3v25.5H89.2zm44.6 0h22.3v25.5h-22.3zm44.6 0h22.3v25.5h-22.3zm44.6 0h22.3v25.5H223zm44.7 0H290v25.5h-22.3zm44.6 0h22.3v25.5h-22.3zm44.6 0h22.3v25.5h-22.3zm44.6 0h22.3v25.5h-22.3zm44.6 0h22.3v25.5h-22.3zm44.6 0H513v25.5h-22.3z"
      fill="#FFF"
      opacity={0.5}
    />
  </svg>
)

export var IS = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#0052B4" d="M0 0h513v342H0z" />
    <path
      fill="#FFF"
      d="M513 210.6H202.2v130.7h-79.8V210.6H0v-79.8h122.4V0h79.8v130.8H513v18.5l-1 42.7z"
    />
    <path
      fill="#D80027"
      d="M513 149.3V192H183.7v149.3H141V192H0v-42.7h141V0h42.7v149.3z"
    />
  </svg>
)

export var IT = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#F4F5F0" d="M342 0H0v341.3h512V0z" />
    <path fill="#008C45" d="M0 0h171v342H0z" />
    <path fill="#CD212A" d="M342 0h171v342H342z" />
  </svg>
)

export var JE = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#FFF" d="M0 0h513v342H0z" />
    <path
      fill="#D80027"
      d="M301.8 171 513 30.2V0h-45.3L256.5 140.8 45.3 0H0v30.2L211.2 171 0 311.8V342h45.3l211.2-140.8L467.7 342H513v-30.2z"
    />
    <path
      fill="#FFDA44"
      d="m233.7 44.6 22.3 5.6 22.3-5.6 4-20.9-14.9 6.5L256 14.8l-11.4 15.4-14.9-6.5z"
    />
    <path
      fill="#D80027"
      d="M233.7 44.6s-4 12.9-4 29.9c0 27.9 26.3 41.3 26.3 41.3s26.3-15.5 26.3-41.3c0-15.4-4-29.9-4-29.9s-8.1-5-22.3-5-22.3 5-22.3 5z"
    />
  </svg>
)

export var JM = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#6DA544" d="M0 0h513v342H0z" />
    <path d="M215.9 171 0 314.6V26.8zM513 26.8v287.8L296.1 171z" />
    <path
      fill="#0052B4"
      d="M513 26.8 296.1 171 513 314.6V342h-41.1L256 197.4 40.1 342H0v-27.4L215.9 171 0 26.8V0h40.1L256 143.9 471.9 0H513z"
    />
    <path
      fill="#FFDA44"
      d="M513 26.8 296.1 171 513 314.6V342h-41.1L256 197.4 40.1 342H0v-27.4L215.9 171 0 26.8V0h40.1L256 143.9 471.9 0H513z"
    />
  </svg>
)

export var JO = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#FFF" d="M0 0h513v342H0z" />
    <path d="M0 0h513v114H0z" />
    <path fill="#6DA544" d="M0 228h513v114H0z" />
    <path fill="#D80027" d="M256.5 170.7 0 341.3V0z" />
    <path
      fill="#FFF"
      d="m77.9 139.5 7.9 16.4 17.8-4.1-8 16.5 14.3 11.3-17.8 4 .1 18.3-14.3-11.5-14.2 11.5v-18.3l-17.8-4 14.3-11.3-7.9-16.5 17.7 4.1z"
    />
  </svg>
)

export var JP = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#FFF" d="M0 0h512v342H0z" />
    <circle fill="#D80027" cx={256.5} cy={171} r={96} />
  </svg>
)

export var KE = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#FFF" d="M0 0h513v342H0z" />
    <path d="M0 0h512v90.579H0z" />
    <path fill="#496E2D" d="M0 251h513v91H0z" />
    <path fill="#A2001D" d="M0 114h513v114H0z" />
    <g fill="#FFF">
      <path d="m323.3 54.5-25.6-11.8L256 137l-41.7-94.3-25.6 11.8 51.8 116.2-51.8 116.2 25.6 11.8 41.7-94.4 41.7 94.4 25.6-11.8-51.8-116.2z" />
      <path d="M273.4 65.6c-9.9-10.8-17.4-17-17.4-17s-7.5 6.2-17.4 17v210.1c9.9 10.8 17.4 17 17.4 17s7.5-6.2 17.4-17V65.6z" />
    </g>
    <path
      d="M209 105.9v129.5c10.5 18.5 23.3 33.7 32.9 43.8V62.1c-9.6 10.1-22.4 25.3-32.9 43.8zm94 0c-10.5-18.5-23.3-33.7-32.9-43.8v217.2c9.6-10.1 22.4-25.3 32.9-43.8V105.9z"
      fill="#A2001D"
    />
    <path d="M303 105.9v129.5c10.6-18.8 18.8-41 18.8-64.8s-8.2-45.9-18.8-64.7zm-94 0v129.5c-10.6-18.8-18.8-41-18.8-64.8s8.2-45.9 18.8-64.7z" />
  </svg>
)

export var KG = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<g fill="#D80027">
      <path d="M0 0h513v342H0z" />
      <circle cx={256} cy={171} r={171} />
    </g>
    <path
      fill="#FFDA44"
      d="M382.4 170.7 330.8 195l27.5 50-56.1-10.7-7.1 56.6-39.1-41.7-39.1 41.7-7.1-56.6-56.1 10.7 27.5-50-51.6-24.3 51.6-24.3-27.5-50.1 56.1 10.8 7.1-56.7L256 92.1l39.1-41.7 7.1 56.7 56.1-10.8-27.5 50.1z"
    />
    <circle fill="#D80027" cx={257.4} cy={170.7} r={71.6} />
    <path
      d="M214.2 170.7c-2.1 0-4.1.1-6.2.3.1 12 4.4 22.9 11.6 31.5 3.8-10.3 9.5-19.6 16.7-27.7-6.9-2.7-14.3-4.1-22.1-4.1zm26.6 46.5c5.2 1.9 10.8 2.9 16.6 2.9 5.8 0 11.4-1 16.6-2.9-2.8-11.1-8.7-21-16.6-28.8-7.9 7.8-13.8 17.7-16.6 28.8zm59.4-71.2c-8.5-14.8-24.5-24.7-42.8-24.7-18.3 0-34.2 9.9-42.8 24.7 15.6.1 30.2 4.3 42.8 11.6 12.6-7.3 27.2-11.6 42.8-11.6zm-21.7 28.8c7.2 8 12.9 17.4 16.7 27.7 7.2-8.5 11.5-19.5 11.6-31.5-2-.2-4.1-.3-6.2-.3-7.7 0-15.2 1.4-22.1 4.1z"
      fill="#FFDA44"
    />
  </svg>
)

export var KH = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#D80027" d="M0 0h513v342H0z" />
    <path d="M0 0h513v114H0zm0 228h513v114H0z" fill="#0052B4" />
    <path
      fill="#FFF"
      d="M303.5 196.6v-17.8h-11.9v-23.7l-11.9-11.9-11.8 11.9v-23.8L256 119.5l-11.9 11.8v23.8l-11.8-11.9-11.9 11.9v23.7h-11.9v17.8h-11.9v17.8h118.8v-17.8z"
    />
  </svg>
)

export var KI = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 450 300" {...rest}>
    {title && <title>{title}</title>}
<path fill="#CE1126" d="M0 0h450v300H0V0z" />
    <g fill="#FCD116">
      <circle cx={227.6} cy={161.2} r={56.2} />
      <path d="m254.1 73.4-23.7 26 28.6 6.5zm-51.5.2-4.8 33.1 28.5-8zm94.3 26.7-34.7 8.5 20.1 23.7zm-138.3-1.8 15.5 32.7 20.2-22.7zm159 45.3-34.4-9.9 5.6 29.5zm-182-2.6 31.9 19.8 5.2-27.7z" />
    </g>
    <path fill="#003F87" d="M0 175h450v125H0V175z" />
    <path
      fill="#FFF"
      d="M0 267c15 0 30 13 45 13s30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13v-21c-15 0-30 13-45 13s-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13v21zm0-43c15 0 30 13 45 13s30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13v-21c-15 0-30 13-45 13s-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13v21zm0-43c15 0 30 13 45 13s30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13v-21c-15 0-30 13-45 13s-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13v21z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      fill="#FCD116"
      d="m183.2 48.3-1.1-5.3 22.4-3.7s-30.1-7.1-40-10.7c-14.3-5.1-16.3-12.1-16.3-12.1s44.7 11 64.8 11c4.3 0 12.8 10.7 12.8 10.7s14.8-14.9 21.9-15.4c32.1-2.3 66.6-6.4 66.6-6.4s-10 6.7-16 8.5c-16.2 4.9-50.6 11.7-50.6 11.7l-4.8 7.5H277l-14.4 4.3 7.4 6.9s-7.8-4.1-18.1-2.1c-7.1 1.3-15.4 6-22.9 8-18.7 4.8-29.9-12.8-29.9-12.8l-15.9-.1z"
    />
  </svg>
)

export var KM = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#0052B4" d="M0 0h513v342H0z" />
    <path fill="#FFDA44" d="M0 0h513v85.5H0z" />
    <path fill="#FFF" d="M0 85.5h513V171H0z" />
    <path fill="#D80027" d="M0 171h513v85.5H0z" />
    <path fill="#6DA544" d="M256.5 171 0 342V0z" />
    <g fill="#FFF">
      <path d="M68.6 170.7c0-24.9 17.5-45.6 40.8-50.7-3.6-.8-7.3-1.2-11.1-1.2-28.7 0-51.9 23.3-51.9 51.9s23.3 51.9 51.9 51.9c3.8 0 7.5-.4 11.1-1.2-23.3-5.1-40.8-25.9-40.8-50.7z" />
      <path d="m108.9 126.1 2.7 8.5h9l-7.3 5.3 2.8 8.5-7.2-5.2-7.3 5.2 2.8-8.5-7.2-5.3h8.9zm0 22.3 2.7 8.5h9l-7.3 5.3 2.8 8.5-7.2-5.3-7.3 5.3 2.8-8.5-7.2-5.3h8.9z" />
      <path d="m108.9 170.7 2.7 8.5h9l-7.3 5.2 2.8 8.5-7.2-5.2-7.3 5.2 2.8-8.5-7.2-5.2h8.9zm0 22.2 2.7 8.5h9l-7.3 5.3 2.8 8.5-7.2-5.3-7.3 5.3 2.8-8.5-7.2-5.3h8.9z" />
    </g>
  </svg>
)

export var KN = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#D80027" d="M0 0h513v342H0z" />
    <path fill="#6DA544" d="M512 0H0v342" />
    <path fill="#FFDA44" d="M307.7 0 0 194.5V342h206.9L513 148.5V0z" />
    <path d="M513 0H385.2L0 249.4V341l126.2 1L513 91.6z" />
    <path
      d="m141.1 187 31.2 24 32.3-22.2-13.1 37 31.1 23.9-39.2-1.1-13.2 37-11.1-37.6-39.2-1.1 32.3-22.2zM310.6 70.8l31.2 23.9 32.3-22.2-13.1 37 31.1 23.9-39.2-1.1-13.2 37-11.1-37.6-39.2-1.1 32.4-22.2z"
      fill="#FFF"
    />
  </svg>
)

export var KP = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#91DC5A" d="M0 0h513v342H0z" />
    <path fill="#FFF" d="M0 0h513v342H0z" />
    <path d="M0 0h513v57.188H0zm0 284.1h513v57.177H0z" fill="#0052B4" />
    <path fill="#D80027" d="M0 79.9h513v181.582H0z" />
    <circle fill="#FFF" cx={190.33} cy={171} r={65.668} />
    <path
      fill="#D80027"
      d="m190.3 105 14.8 45.3h47.7l-38.6 28.1 14.8 45.5-38.7-28.2-38.6 28.1 14.8-45.4-38.6-28.1h47.7z"
    />
  </svg>
)

export var KR = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#FFF" d="M0 0h513v342H0z" />
    <path
      d="M84.6 107.8 132 36.6m-29.7 83 47.4-71.1m-29.6 83 47.4-71.1m177.9 221.3 47.4-71.1m-29.6 82.9 47.4-71.1m-29.6 83 47.4-71.1M132 305.4l-47.4-71.1m65.2 59.2-47.4-71.1m65.2 59.3-47.4-71.1m272.6-79.1-47.4-71.1m65.2 59.2-47.4-71.1m65.2 59.3L381 36.6"
      stroke="#000"
      strokeWidth={14.25}
    />
    <path
      d="m357.3 238.2 59.3 39.5m-299.4-13.8L135 252m222.3-148.2L378 90m17.8-11.9 17.8-11.9"
      stroke="#FFF"
      strokeWidth={12.5}
    />
    <circle fill="#CA163A" cx={256.5} cy={171} r={85.5} />
    <path
      fill="#0E4896"
      d="M185.3 123.6c-13.1 19.6-7.8 46.2 11.9 59.3s46.2 7.8 59.3-11.9 39.6-24.9 59.3-11.9c19.6 13.1 24.9 39.6 11.9 59.3-26.2 39.3-79.3 49.9-118.6 23.7s-49.9-79.3-23.8-118.5z"
    />
  </svg>
)

export var KW = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#FFF" d="M0 0h513v342H0z" />
    <path fill="#6DA544" d="M0 0h513v114H0z" />
    <path fill="#D80027" d="M0 228h513v114H0z" />
    <path d="M167 227.6 0 341.3V0l167 113.8z" />
  </svg>
)

export var KY = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#012169" d="M0 0h513v342H0z" />
    <g stroke="#fff">
      <circle fill="#059334" cx={384} cy={96.5} r={29.7} />
      <path fill="#c8102e" d="M332.1 89H436v44.5H332.1z" />
      <path
        fill="#fcea83"
        d="M332.1 200.3V230h15.6c9.4 9.2 22.2 14.8 36.3 14.8 14.1 0 27-5.7 36.3-14.8h15.6v-29.7H332.1z"
      />
      <path
        fill="#004b9e"
        d="M332.1 126.1v44.5c0 39.8 51.9 51.9 51.9 51.9s51.9-12.2 51.9-51.9v-44.5H332.1z"
      />
      <path
        d="M384 149.9c-13 0-13 11.9-26 11.9s-13-11.9-26-11.9v20.8c13 0 13 11.9 26 11.9s13-11.9 26-11.9 13 11.9 26 11.9 13-11.9 26-11.9v-20.8c-13 0-13 11.9-26 11.9s-13-11.9-26-11.9zm0-41.6c-13 0-13 11.9-26 11.9s-13-11.9-26-11.9v20.8c13 0 13 11.9 26 11.9s13-11.9 26-11.9 13 11.9 26 11.9 13-11.9 26-11.9v-20.8c-13 0-13 11.9-26 11.9s-13-11.9-26-11.9z"
        fill="#F3F3F3"
      />
    </g>
    <path fill="#012169" d="M0 0h256.5v171H0z" />
    <g fill="#FFF">
      <path d="M256.5 0v30.6l-45.3 25.2h45.3v59.4h-59.2l59.2 32.9V171h-26.7l-73.7-40.9V171h-55.7v-48.7L12.8 171H0v-30.6l45.3-25.2H0V55.8h59.2L0 22.9V0h26.7l73.7 40.9V0h55.7v48.7L243.7 0z" />
      <path d="M156.1 115.2 256.5 171v-15.8l-72-40zm-55.7-59.4L0 0v15.8l72 40z" />
    </g>
    <g fill="#D80027">
      <path d="M144.3 0h-32.1v69.5H0v32h112.2V171h32.1v-69.5h112.2v-32H144.3z" />
      <path d="M156.1 115.2 256.5 171v-15.8l-72-40zm-84.1 0-72 40V171l100.4-55.8zm28.4-59.4L0 0v15.8l72 40zm84.1 0 72-40V0L156.1 55.8z" />
    </g>
  </svg>
)

export var KZ = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#36B6CC" d="M0 0h513v342H0V0z" />
    <circle fill="#FFD400" cx={256.5} cy={170.9} r={68.4} />
    <path
      fill="#FFD400"
      d="m256.5 251.5-27.9 41.7-7.1-49.7-43.2 25.5 15.2-47.8-50 4.2 34.4-36.5-46.9-18 46.8-18-34.4-36.5 50 4.2-15.2-47.8 43.2 25.4 7.1-49.7 27.9 41.7 27.9-41.7 7.1 49.7 43.2-25.4-15.2 47.8 50-4.2-34.3 36.6 46.8 17.9-46.8 18 34.4 36.5-50-4.2 15.2 47.8-43.2-25.4-7.1 49.7c0-.1-27.9-41.8-27.9-41.8zm0-.8c44.1 0 79.9-35.8 79.9-79.9S300.6 91 256.5 91s-79.9 35.8-79.9 79.9 35.8 79.8 79.9 79.8zM22.8 28.3c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H28.5c-3.1 0-5.7-2.5-5.7-5.6V28.3zm0 45.7c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H28.5c-3.1 0-5.7-2.5-5.7-5.6V74zm0 45.6c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H28.5c-3.1 0-5.7-2.5-5.7-5.6v-11.4zm0 45.6c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H28.5c-3.1 0-5.7-2.5-5.7-5.6v-11.4zm0 45.7c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H28.5c-3.1 0-5.7-2.5-5.7-5.6v-11.4zm0 45.6c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H28.5c-3.1 0-5.7-2.5-5.7-5.6v-11.4zm0 45.6c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H28.5c-3.1 0-5.7-2.5-5.7-5.6v-11.4zm22.8-22.8c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H51.3c-3.1 0-5.7-2.5-5.7-5.6v-11.4zm0-45.6c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7V245c.1 3.1-2.4 5.7-5.6 5.7H51.3c-3.1 0-5.7-2.5-5.7-5.6v-11.4zm0-45.7c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H51.3c-3.1 0-5.7-2.5-5.7-5.6V188zm0-45.6c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H51.3c-3.1 0-5.7-2.5-5.7-5.6v-11.4zm0-45.6c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H51.3c-3.1 0-5.7-2.5-5.7-5.6V96.8zm0-45.6c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H51.3c-3.1 0-5.7-2.5-5.7-5.6V51.2z"
    />
  </svg>
)

export var LA = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#0052B4" d="M0 0h513v342H0z" />
    <path d="M0 .1h513v90.7H0zm0 251.2h513V342H0z" fill="#D80027" />
    <circle fill="#FFF" cx={256.5} cy={171} r={65.9} />
  </svg>
)

export var LB = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#FFF" d="M0 0h513v342H0z" />
    <path d="M0 .2h513v90.7H0zm.5 251.1H513V342H.5z" fill="#D80027" />
    <path
      fill="#6DA544"
      d="M290.3 193.5 256 130.7l-34.3 62.8h25.7v17.2h17.2v-17.2z"
    />
    <path
      fill="#14AF5A"
      d="M241.3 213.1c4.4-4.4 4.4-11.6-.1-16l4.7 4.7c-5.2-4.7-12.2-6.6-19.1-5.3l-23.5 5.9c-6.1 1.5-6.8-.4-1.8-4.2l27.1-20.3c5.1-3.8 4.2-6.9-2.3-6.9h-11c-6.4 0-7-2.3-1.5-5.1l25.3-12.7c5.6-2.8 5.1-5.1-1.5-5.1h-11c-6.4 0-7.4-3.1-2.3-6.9l27.1-20.3c5.6-3.8 12.9-3.8 18.5 0l27.1 20.3c5.1 3.8 4.2 6.9-2.3 6.9h-11c-6.4 0-7 2.3-1.5 5.1l25.3 12.7c5.6 2.8 5.1 5.1-1.5 5.1h-11c-6.4 0-7.4 3.1-2.3 6.9l27.1 20.3c5.1 3.8 4.4 5.7-1.8 4.2l-23.5-5.9c-6.8-1.3-13.9.6-19.1 5.3l4.7-4.7c-4.4 4.4-4.5 11.5-.1 16l6.8 6.8c4.4 4.4 3.1 8-3.3 8h-45.8c-6.2 0-7.7-3.6-3.3-8 .1.1 6.9-6.8 6.9-6.8z"
    />
  </svg>
)

export var LC = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#55B2FF" d="M0 0h513v342H0z" />
    <path fill="#F3F3F3" d="M148.5 298.1h216l-108-254.2z" />
    <path fill="#333" d="m186 272.7 70.5-160.3L327 272.7z" />
    <path fill="#FFDA44" d="M148.5 298.1h216l-108-101.7z" />
  </svg>
)

export var LI = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#D80027" d="M0 0h513v342H0z" />
    <path fill="#0052B4" d="M0 0h513v171H0z" />
    <path
      fill="#FFDA44"
      d="M149.3 98.1c0-14-11.3-25.3-25.3-25.3-6.5 0-12.4 2.4-16.9 6.4V64.4h8.4V47.5h-8.4v-8.4H90.3v8.4h-8.4v16.9h8.4v14.9c-4.5-4-10.4-6.4-16.9-6.4-14 0-25.3 11.3-25.3 25.3 0 7.5 3.3 14.2 8.4 18.8v14.9h84.3V117c5.3-4.7 8.5-11.5 8.5-18.9z"
    />
  </svg>
)

export var LK = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#FFDA44" d="M0 0h513v342H0z" />
    <path fill="#A2001D" d="M222.6 22.3h267.1v296.8H222.6z" />
    <path fill="#D80027" d="M22.3 22.3h200.3v296.8H22.3z" />
    <path fill="#FFDA44" d="M200.3 0h22.3v342h-22.3z" />
    <path fill="#6DA544" d="M22.3 22.3h89v296.8h-89z" />
    <path fill="#FF9811" d="M111.3 22.3h89v296.8h-89z" />
    <path
      fill="#FFDA44"
      d="M368.2 156.8c-1.4-2 0-37.9 0-37.9.9-7.4.1-8.4 1-11.4.9-2.9 5.4-11.6 5.4-11.6s-6-2.3-10.3-.6c-4.3 1.7-24.7-7.5-31.2 3.4-4.4 7-23.6 16.2-24.6 14-1-2.2-5.9-5-6.9-2.9s-.7 13.9 0 16c.8 2.6 9.8 2 12.3 3.1 3.7 1.8 12.2 8.2 11.9 10.7-.3 2.5-22.5-6-24.2-4.5-1.4 1.2-1.9 13.2-.4 15 1.8 2.1 23.4 5.6 25 7.5 1.6 1.9-13.1 7.4-12.3 25 .7 14.7 8 17.4 8 17.4s-2.4 3.6-7.8 3.1c-6.2-.6-27.4-17.7-27.4-17.7s-3.5-109 3.6-121.4c4.9-8.5-22.7 10.1-22.7 50.8V151c0 6.6-1.4 22.4 2.6 34 0 0-.4 46.9 1.5 49.6s12.7 2.2 14.8 0 0-30 0-30c7.7.2 18.3 17.5 32.5 16.4 20.6-1.6 28.7-9.9 34.3-5 8.1 7.1 5.5 23.2.4 31.5-2.2 3.5-14.3 4.7-15.7 7.6-1.4 2.9.5 5.4.5 5.4h29.7s1.4-20.5 2.7-26.1c1.3-5.7-.6-10.7 5.9-10.4 23.5 1.1 39.8-15.3 45.5-8 3.2 4.1 5.6 29.9 3.3 33.3-2.2 3.4-13.8 2.8-15.2 6.7-1.4 4 .8 4.4.8 4.4h29.7s-.4-21.2 2.5-27.7 4.9-10.4 9.3-17.2c4.4-6.8 11.3-15.7 11.3-36.2 0-14.2-8.1-22.8-8.1-22.8H417c-14.1.2-47.4 2.3-48.8.3zm-136-124.5c10.7-10.6 20.2-2.7 22.2 2.1 1.9 4.8 2.1 8.2 2.8 13.6.9 6.9 4.9 14 4.9 14s-7.1-3.8-14.7-4.2c-4.7-.3-9-.6-13.6-2.5-5.7-2.3-11.7-12.9-1.6-23zm248.4-.1c10.7 10.6 2.8 20.2-2 22.2s-8.2 2.1-13.6 2.8c-6.9.9-14 5-14 5s3.7-7.1 4.2-14.7c.3-4.7.6-9.1 2.4-13.6 2.2-5.7 12.8-11.8 23-1.7zm.1 276.9c-10.7 10.6-20.2 2.6-22.2-2.2-1.9-4.8-2.1-8.2-2.7-13.6-.8-6.9-4.9-14.1-4.9-14.1s7 3.8 14.7 4.3c4.7.3 9 .6 13.6 2.5 5.7 2.4 11.7 13.1 1.5 23.1zm-248.2-.1c-10.6-10.7-2.7-20.2 2.1-22.2 4.8-1.9 8.2-2.1 13.6-2.8 6.9-.9 14-4.9 14-4.9s-3.8 7.1-4.2 14.7c-.3 4.7-.6 9-2.5 13.6-2.3 5.7-12.9 11.8-23 1.6z"
    />
    <path
      fill="none"
      stroke="#FFDA44"
      strokeWidth={6}
      strokeMiterlimit={10}
      d="M446.9 162.4s7.5-2.6 8.4-16.1c.6-8.6-19.8-16-39-11.5-19.7 4.6-34-3.1-34-14.6 0-22.9 29.7-16.2 38.9-11.3 9.1 4.9 29.7 23.5 35.1 9.4"
    />
  </svg>
)

export var LR = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#FFF" d="M0 0h513v342H0z" />
    <path
      d="M0 0h513v31.1H0zm0 62.2h513v31.1H0zm0 62.3h513v31.1H0zm0 62.3h513v31.1H0zm0 62.5h513v31.1H0zm0 61.6h513V342H0z"
      fill="#bf0a30"
    />
    <path fill="#002868" d="M0 0h155.6v155.6H0z" />
    <path
      fill="#FFF"
      d="m77.8 30.2 10.7 32.9h34.6l-28 20.4 10.7 32.9-28-20.3-28 20.3 10.7-32.9-28-20.4h34.6z"
    />
  </svg>
)

export var LS = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#FFF" d="M0 0h513v342H0z" />
    <path fill="#0052B4" d="M0 0h513v114H0z" />
    <path fill="#6DA544" d="M0 227.6h513v114H0z" />
    <path d="m245.2 171 7.7-23.1c2-5.9 5.1-6 7.1 0l7.7 23.1 19.4 29.1c1.7 2.6 1.3 6.3-1.2 8 0 0-6.9 8-29.5 8s-29.5-8-29.5-8c-2.4-2-2.9-5.4-1.2-8l19.5-29.1z" />
    <path d="M256.5 171c-12.5 0-22.6-10.1-22.6-22.6 0-12.5 10.1-22.6 22.6-22.6s22.6 10.1 22.6 22.6c0 12.5-10.2 22.6-22.6 22.6zm0 0c6.2 0 11.3-16.3 11.3-22.6 0-6.2-5.1-11.3-11.3-11.3-6.2 0-11.3 5.1-11.3 11.3 0 6.3 5 22.6 11.3 22.6z" />
  </svg>
)

export var LT = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#6DA544" d="M0 0h513v342H0z" />
    <path fill="#FFDA44" d="M0 0h513v114H0z" />
    <path fill="#D80027" d="M0 228h513v114H0z" />
  </svg>
)

export var LU = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#FFF" d="M0 0h513v342H0z" />
    <path fill="#D80027" d="M0 0h513v114H0z" />
    <path fill="#338AF3" d="M0 228h513v114H0z" />
  </svg>
)

export var LV = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#FFF" d="M0 0h513v342H0z" />
    <path
      className="prefix__st1"
      d="M0 0h513v127.6H0zm0 214.4h513V342H0z"
      fill="#A2001D"
    />
  </svg>
)

export var LY = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path d="M0 0h513v342H0z" />
    <path fill="#D80027" d="M0 0h513v114H0z" />
    <path fill="#496E2D" d="M0 228h513v114H0z" />
    <g fill="#FFF">
      <path d="m281.4 150.7 9 12.3 14.5-4.7-9 12.4 9 12.3-14.5-4.7-9 12.3v-15.2l-14.5-4.7 14.5-4.7z" />
      <path d="M257 201.5c-17 0-30.9-13.8-30.9-30.9s13.8-30.9 30.9-30.9c5.3 0 10.3 1.3 14.7 3.7-6.9-6.7-16.2-10.8-26.6-10.8-21 0-38 17-38 38s17 38 38 38c10.3 0 19.7-4.1 26.6-10.8-4.4 2.4-9.4 3.7-14.7 3.7z" />
    </g>
  </svg>
)

export var MA = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#d12a46" d="M0 .3V342h513V.3z" />
    <path
      fill="#316525"
      d="M359.8 148.9h-73.3l-22.7-69.7-22.7 69.7h-73.3l59.3 43.1-22.7 69.7 59.3-43.1 59.3 43.1-22.5-69.7 59.3-43.1zm-116.1 37.7 7.7-23.6h24.8l7.7 23.6-20.1 14.6-20.1-14.6zm27.9-37.7H256l7.8-24 7.8 24zm24.3 29-4.8-14.9h25.3l-20.5 14.9zM236.6 163l-4.8 14.9-20.5-14.9h25.3zm-5.3 61.8 7.8-24 12.6 9.2-20.4 14.8zm44.5-14.9 12.6-9.2 7.8 24-20.4-14.8z"
    />
  </svg>
)

export var MC = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#FFF" d="M0 171h513v171H0z" />
    <path fill="#ce1126" d="M0 0h513v171H0z" />
  </svg>
)

export var MD = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#FFDA44" d="M0 0h513v342H0z" />
    <path fill="#D80027" d="M342 0h171v342H342z" />
    <path fill="#0052B4" d="M0 0h171v342H0z" />
    <path
      fill="#AF7F59"
      stroke="#231F20"
      strokeWidth={3}
      strokeMiterlimit={10}
      d="m240.4 105.7 9.7 11.6-7.5 17.4-26.1-24.3-12.7 13.2v106.1l24.6-36 20.6 12.4-18 27.8 25.2 15.8 26.5-15.8-19.7-27.8 22.3-12.4 23.9 33.8v-106l-12.4-12-26.8 24.7-6.5-16.5 3.5-12.3-11.7-7.5z"
    />
  </svg>
)

export var ME = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#ffc000" d="M0 0h513v342H0z" />
    <path fill="#e30000" d="M20 20h473v302H20z" />
    <path
      fill="#ffc000"
      d="M248.5 112.9c4.4 4.4 11.6 4.4 16 0l-4.7 4.7 22.7-22.7c4.9-4.5 12.1-5.6 18.2-2.8l2.1 1c5.7 2.9 6.7 8.7 2.3 13.1l4.7-4.7-22.8 22.8c-4.5 4.9-5.6 12.1-2.8 18.2l1 2.1c2.9 5.7 5.1 15.4 5.1 21.6v-11.3c0 6.2 4.4 9.1 10.2 6.2l2.1-1c5.7-2.9 6.7-8.7 2.3-13.1l4.7 4.7c-4.4-4.4-4.4-11.6 0-16l-4.7 4.7c5.2-5.5 9.6-11.6 13.1-18.2l1-2.1c2.9-5.7 6.3-15.1 7.9-21.2l5.8-23.3c1.5-6 5.9-6.8 9.6-1.8l20.2 26.9c3.8 5.1 6.9 14 6.9 20.6v22.4c0 6.3-2.2 15.8-5.1 21.7l-1 2.1c-3.5 6.6-7.9 12.7-13.1 18.2l-6.8 6.8c-5.4 5.2-11.5 9.6-18.2 13.1l-2.1 1c-5.7 2.9-15.5 5.1-21.6 5.1-6.2 0-6.9 2.2-1.1 5.1l2.1 1c5.7 2.9 13.8 8.7 18.2 13.1l-4.7-4.7c4.4 4.4 11.6 4.4 16 0l-4.7 4.7c4.4-4.4 11.6-4.4 16 0L339 226c4.6 4.9 5.7 12.1 2.9 18.2l-1 2.1c-2.9 5.7-10.4 10.2-16.4 10.2-7.5-.3-14.8-2-21.6-5.1l-2.1-1c-6.5-3.6-11.8-8.9-15.4-15.4l-1-2.1c-2.9-5.7-8.7-6.7-13.1-2.3l4.7-4.7c-4.4 4.7-5.2 11.8-1.8 17.3l10.3 15.4c3.4 5.1 2 12.1-3.1 15.5L266 284.4c-5.7 3.4-12.8 3.4-18.6 0L232 274.1c-5.1-3.4-6.5-10.3-3.1-15.5l10.3-15.4c3.4-5.5 2.6-12.6-1.8-17.3l4.7 4.7c-4.4-4.4-10.2-3.6-13.1 2.3l-1 2.1c-2.9 5.7-9.5 12.4-15.4 15.4l-2.1 1c-5.7 2.9-15.5 5.1-21.6 5.1-6.9-.3-13.1-4.2-16.4-10.2l-1-2.1c-2.8-6.1-1.6-13.3 2.9-18.2l-4.7 4.7c4.4-4.4 11.6-4.4 16 0L181 226c4.4 4.4 11.6 4.4 16 0l-4.7 4.7c5.5-5.2 11.6-9.6 18.2-13.1l2.1-1c5.7-2.9 5-5.1-1.1-5.1-7.5-.3-14.8-2-21.6-5.1l-2.1-1c-6.6-3.5-12.7-7.9-18.2-13.1l-6.8-6.8c-5.2-5.4-9.6-11.5-13.1-18.2l-1-2.1c-3.1-6.8-4.9-14.2-5.1-21.7V121c0-6.3 3.1-15.6 6.9-20.6l20.2-26.9c3.8-5.1 8.1-4.3 9.6 1.8l5.8 23.3c2 7.3 4.6 14.4 7.9 21.2l1 2.1c2.9 5.7 8.7 13.8 13.1 18.2l-4.7-4.7c4.4 4.4 4.4 11.6 0 16l4.7-4.7c-4.4 4.4-3.6 10.2 2.3 13.1l2.1 1c5.7 2.9 10.2 0 10.2-6.2v11.3c0-6.2 2.2-15.7 5.1-21.6l1-2.1c2.8-6.1 1.7-13.2-2.8-18.2l-22.7-22.7 4.7 4.7c-4.4-4.4-3.6-10.2 2.3-13.1l2.1-1c6.1-2.8 13.2-1.7 18.2 2.8l22.7 22.7-4.8-4.5zm-18-40.7c-4.4-4.4-3.2-9.5 2.8-11.5l12.4-4.2c3-1 6.9-7.5 10.8-7.5 3.9 0 7.8 6.5 10.8 7.5l12.4 4.2c6 2 7.2 7.1 2.8 11.5l-6.8 6.8c-5.3 4.7-12.1 7.5-19.2 7.9-6.2 0-14.8-3.5-19.2-7.9l-6.8-6.8z"
    />
    <path
      fill="#0371ba"
      d="M275 201.3h-37c-4.9 0-8.8-3.9-8.8-8.8v-34.2c0-4.9 3.9-8.8 8.8-8.8h37c4.9 0 8.8 3.9 8.8 8.8v34.2c0 4.8-3.9 8.8-8.8 8.8z"
    />
    <path
      fill="#39B54A"
      d="m230.8 212.8 24.4 17.9c.8.6 1.8.6 2.6 0l24.4-17.9c2.1-1.6 1.2-5.4-1.3-5.4h-48.8c-2.5 0-3.4 3.9-1.3 5.4z"
    />
    <path
      fill="#ffc000"
      d="M262.8 186.5h-12.5c-3.3 0-5.9-2.6-5.9-5.9V170c0-3.3 2.6-5.9 5.9-5.9h12.5c3.3 0 5.9 2.6 5.9 5.9v10.6c-.1 3.3-2.7 5.9-5.9 5.9z"
    />
  </svg>
)

export var MF = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 108 72" {...rest}>
    {title && <title>{title}</title>}
<path d="M0 0h108v72H0z" fill="#003787" />
    <path d="M0 0h108L60 48v24H48V48z" fill="#fff" />
    <circle cx={54} cy={30} r={8} fill="#f9d90f" />
    <path d="M44 30h20L54 48z" fill="#fff" />
    <path d="M54 48 38 33h32z" fill="#cf142b" />
  </svg>
)

export var MG = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#f9423a" d="M0 0h513v171H0z" />
    <path fill="#00843d" d="M0 171h513v171H0z" />
    <path fill="#FFF" d="M0 0h171v342H0z" />
  </svg>
)

export var MH = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#1E509C" d="M0 0h513v342H0z" />
    <path fill="#FFF" d="M513 176.1V81.3L0 342l513-165.9z" />
    <path fill="#F18D36" d="M513 0v81.3L0 342 513 0z" />
    <path
      fill="#FFF"
      d="m126.7 99.3-7.8-54.1-7.7 54.1-20.8-23.7 10.7 31.6-31.5-10.7 23.6 20.8-54.1 7.7 54.1 7.7-23.6 20.8 31.5-10.7-10.7 31.6 20.8-23.7 7.7 54.1 7.8-54.1 20.7 23.7-10.6-31.6 31.5 10.7-23.6-20.8 54-7.7-54-7.7 23.6-20.8-31.5 10.7 10.6-31.6z"
    />
  </svg>
)

export var MK = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#FFDA44" d="M0 0h513v342H0z" />
    <g fill="#D80027">
      <path d="M384.6 342 256.5 167.3 283.4 342zM133.8 0l122.7 167.3L230.8 0zm95.8 342 26.9-174.7L128.4 342zM0 0v127.8l256.5 39.5L28.4 0zm0 342h18.2l238.3-174.7L0 206.7zm256.5-174.7L513 127.8V0h-28.4zM282.2 0l-25.7 167.3L379.2 0z" />
      <path d="M513 342V206.7l-256.5-39.4L494.8 342z" />
      <circle cx={256.5} cy={171} r={59.5} />
    </g>
    <circle fill="#FFDA44" cx={256.5} cy={171} r={44.5} />
  </svg>
)

export var ML = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#14b53a" d="M0 0h171v342H0z" />
    <path fill="#fcd116" d="M171 0h171v342H171z" />
    <path fill="#ce1126" d="M342 0h171v342H342z" />
  </svg>
)

export var MM = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#fecb00" d="M0 0h513v114H0z" />
    <path fill="#34b233" d="M0 114h513v114H0z" />
    <path fill="#ea2839" d="M0 228h513v114H0z" />
    <path
      fill="#FFF"
      d="M384.8 142.2h-98L256.5 49l-30.3 93.2h-98l79.3 57.6-30.3 93.2 79.3-56.9 79.3 56.9-30.3-93.2 79.3-57.6z"
    />
  </svg>
)

export var MN = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#0066b2" d="M0 0h513v342H0z" />
    <path d="M342 0h171v342H342zM0 0h171v342H0z" fill="#da2031" />
    <g fill="#ffd300">
      <path d="M108.3 166.3h14.8v74.2h-14.8zm-59.4 0h14.8v74.2H48.9z" />
      <circle cx={86} cy={203.4} r={14.8} />
      <path d="M71.2 225.7h29.7v14.8H71.2zm0-59.4h29.7v14.8H71.2z" />
      <circle cx={86} cy={144} r={14.8} />
      <path d="M76.3 123.9h19.5L86 108.3z" />
    </g>
  </svg>
)

export var MO = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#0F7562" d="M0 0h513v342H0z" />
    <path
      d="M286.2 168.5c-4.2 0-8.2.8-11.9 2.2 2-4.5 3.4-9.5 3.4-14.9 0-21.2-21.2-37.1-21.2-37.1s-21.2 15.9-21.2 37.1c0 5.4 1.4 10.4 3.4 14.9-3.7-1.3-7.7-2.2-11.9-2.2-25.6 0-37.1 11.2-37.1 11.2s15.9 31.2 37.1 31.2c12.4 0 23-7.3 29.7-13.3 6.6 6 17.3 13.3 29.7 13.3 21.2 0 37.1-31.2 37.1-31.2s-10.8-11.2-37.1-11.2zm-29.7-96.8 4.4 13.5h14.2l-11.5 8.3L268 107l-11.5-8.3L245 107l4.4-13.5-11.5-8.3h14.2zm-53.9 23.6 8.4 7.6 9.9-5.7-4.7 10.4 8.5 7.6-11.3-1.2-4.6 10.3-2.4-11.1-11.3-1.1 9.9-5.7zm-39.4 39.5 11.1 2.3 5.6-9.8 1.2 11.3 11.1 2.3-10.4 4.6 1.2 11.3-7.6-8.4-10.3 4.6 5.6-9.8zm147.2-39.5-8.4 7.6-9.9-5.7 4.7 10.4-8.5 7.6 11.3-1.2 4.6 10.3 2.4-11.1 11.3-1.1-9.9-5.7zm39.4 39.5-11.1 2.3-5.6-9.8-1.2 11.3-11.1 2.3 10.4 4.6-1.2 11.3 7.6-8.4 10.3 4.6-5.6-9.8z"
      fill="#FFDA44"
    />
    <path
      d="M256.5 270.3c16.8 0 32.4-5.6 44.8-15.1h-89.6c12.4 9.4 28 15.1 44.8 15.1zm-68-44.6c2.4 5.4 5.3 10.4 8.9 15.1H238c13.9 0 18.5-7 18.5-7s5.3 7 18.6 7h40.6c3.5-4.6 6.5-9.7 8.9-15.1h-49.5c-15.5 0-18.6-10-18.6-10s-5.3 10-18.5 10h-49.5z"
      fill="#FFF"
    />
  </svg>
)

export var MP = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 750 500" {...rest}>
    {title && <title>{title}</title>}
<path fill="#0071BC" d="M0 0h750v500H0V0z" />
    <g fill="#FFF" stroke="#000" strokeWidth={1.9}>
      <circle cx={375} cy={245} r={225} fill="#fff" />
      <circle cx={375} cy={245} r={165} fill="#0071BC" />
    </g>
    <g stroke="#000">
      <path
        fill="#8C8A8C"
        strokeWidth={1.9}
        d="M444.7 450c.7 11-7.8 20-18.8 20H323.6c-11 0-19.5-9-19-20l16.7-325c.6-11 10-20 21-20h61.4c11 0 20.5 9 21.2 20l19.8 325z"
      />
      <path
        fill="#FFF"
        strokeWidth={2}
        strokeLinejoin="round"
        d="m373 114 30 93h97l-78 56 29 92-78-56-78 57 30-93-79-57h97l30-92z"
      />
    </g>
  </svg>
)

export var MQ = ({ title, ...rest }) => (
  <svg viewBox="0 0 900 600" xmlns="http://www.w3.org/2000/svg" {...rest}>
    {title && <title>{title}</title>}
<path fill="#231f1e" d="M0 0h900v600H0z" />
    <path fill="#00a650" d="M0 0h900v300H0z" />
    <path fill="#ef1923" d="m0 0 450 300L0 600z" />
  </svg>
)

export var MR = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#00a95c" d="M0 0h513v342H0z" />
    <path fill="#d01c1f" d="M0 0h513v46H0zm0 296h513v46H0z" />
    <path
      fill="gold"
      d="M256 213.9c-46 0-84.3-32.3-93.8-75.4-1.4 6.6-2.2 13.5-2.2 20.6 0 53 43 96 96 96s96-43 96-96c0-7.1-.8-13.9-2.2-20.6-9.5 43.1-47.8 75.4-93.8 75.4z"
    />
    <path
      fill="gold"
      d="m256 87 8.9 27.5h29l-23.4 17 8.9 27.5-23.4-17-23.4 17 8.9-27.5-23.4-17h29z"
    />
  </svg>
)

export var MS = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#012169" d="M0 0h513v342H0z" />
    <path
      fill="#00A2B8"
      stroke="#FFF"
      strokeWidth={3}
      d="M318.2 106.7v106.5c0 51.9 67.8 67.8 67.8 67.8s67.8-15.9 67.8-67.8V106.7H318.2z"
    />
    <path
      fill="#A35023"
      d="M319.7 212.7c0 50.8 66.3 66.3 66.3 66.3s66.3-15.6 66.3-66.3H319.7z"
    />
    <path
      fill="#510"
      d="M415.1 155.1h-19.4v-19.4h-19.4v19.4H357v19.4h19.3v58.1h19.4v-58.1h19.4z"
    />
    <path fill="#012169" d="M0 0h256.5v171H0z" />
    <g fill="#FFF">
      <path d="M256.5 0v30.6l-45.3 25.2h45.3v59.4h-59.2l59.2 32.9V171h-26.7l-73.7-40.9V171h-55.7v-48.7L12.8 171H0v-30.6l45.3-25.2H0V55.8h59.2L0 22.9V0h26.7l73.7 40.9V0h55.7v48.7L243.7 0z" />
      <path d="M156.1 115.2 256.5 171v-15.8l-72-40zm-55.7-59.4L0 0v15.8l72 40z" />
    </g>
    <g fill="#D80027">
      <path d="M144.3 0h-32.1v69.5H0v32h112.2V171h32.1v-69.5h112.2v-32H144.3z" />
      <path d="M156.1 115.2 256.5 171v-15.8l-72-40zm-84.1 0-72 40V171l100.4-55.8zm28.4-59.4L0 0v15.8l72 40zm84.1 0 72-40V0L156.1 55.8z" />
    </g>
  </svg>
)

export var MT = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#FFF" d="M0 0h513v342H0z" />
    <path fill="#cf142b" d="M256 0h256.5v342H256z" />
    <path
      stroke="#cf142b"
      strokeWidth={10}
      d="M101.2 68.2V33H66v35.2H30.8v35.2H66v35.2h35.2v-35.2h35.2V68.2z"
    />
    <path
      fill="#fff"
      stroke="#acacac"
      strokeWidth={5}
      d="M101.2 68.2V33H66v35.2H30.8v35.2H66v35.2h35.2v-35.2h35.2V68.2z"
    />
    <circle
      cx={85}
      cy={85}
      r={26}
      fill="none"
      stroke="#acacac"
      strokeWidth={5}
    />
    <circle
      cx={85}
      cy={85}
      r={18}
      fill="#dedede"
      stroke="#acacac"
      strokeWidth={5}
    />
  </svg>
)

export var MU = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#d01c1f" d="M0 0h513v85.5H0z" />
    <path fill="#2d3359" d="M0 85.5h513V171H0z" />
    <path fill="#f7b718" d="M0 171h513v85.5H0z" />
    <path fill="#008658" d="M0 256.5h513V342H0z" />
  </svg>
)

export var MV = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 720 480" {...rest}>
    {title && <title>{title}</title>}
<path
      fill="#007E3A"
      stroke="#D21034"
      strokeWidth={120}
      d="M60 60h600v360H60z"
    />
    <circle fill="#FFF" cx={390} cy={240} r={80} />
    <circle fill="#007E3A" cx={420} cy={240} r={80} />
  </svg>
)

export var MW = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path d="M0 0h513v114H0z" />
    <path fill="#ce1126" d="M0 114h513v114H0z" />
    <path fill="#339e35" d="M0 228h513v114H0z" />
    <circle fill="#ce1126" cx={256.5} cy={125} r={95} />
    <path d="M0 100h513v14H0z" />
  </svg>
)

export var MX = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#dc2339" d="M342 0H0v341.3h513V0z" />
    <path fill="#11865d" d="M0 0h171v342H0z" />
    <path fill="#FFF" d="M171 0h171v342H171z" />
    <path
      fill="#8C9157"
      d="M195.8 171.2c0 21.6 11.5 41.7 30.3 52.5 5.8 3.4 13.2 1.4 16.6-4.4 3.4-5.8 1.4-13.2-4.4-16.6-11.3-6.5-18.2-18.5-18.2-31.5 0-6.7-5.4-12.1-12.1-12.1-6.7 0-12.2 5.4-12.2 12.1zm93.4 51.1c17.5-11.1 28-30.4 28-51.1 0-6.7-5.4-12.1-12.1-12.1s-12.1 5.4-12.1 12.1c0 12.4-6.3 24-16.8 30.7-5.7 3.5-7.5 10.9-4.1 16.7s10.9 7.5 16.7 4.1c0-.2.2-.3.4-.4z"
    />
    <ellipse fill="#C59262" cx={256.5} cy={159.1} rx={24.3} ry={36.4} />
  </svg>
)

export var MY = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#FFF" d="M0 0h513v342H0z" />
    <path
      d="M0 0h513v24.4H0zm0 48.9h513v24.4H0zm0 48.8h513v24.4H0zm0 48.9h513V171H0zm0 48.8h513v24.4H0zm0 48.9h513v24.4H0zm0 48.8h513v24.4H0z"
      fill="#c00"
    />
    <path fill="#006" d="M0 0h256.5v195.4H0z" />
    <path
      d="M153.3 42.1C122.6 30.7 88.5 46.3 77.1 77s4.2 64.8 34.9 76.2c13.3 5 28 5 41.4 0-30.7 24.5-75.4 19.6-100-11.1s-19.6-75.4 11.1-100c26-20.7 62.9-20.7 88.8 0zm26.7 75-20.6 23.3 5.4-30.6-31-1.6 27.3-14.9L143 68l28.6 12 8.4-29.9 8.4 29.9L217 68l-18 25.4 27.3 14.9-31 1.6 5.4 30.6-20.7-23.4z"
      fill="#fc0"
    />
  </svg>
)

export var MZ = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#FFF" d="M0 0h513v342H0z" />
    <path fill="#006d66" d="M0 0h513v104H0z" />
    <path d="M0 119h513v104H0z" />
    <path fill="#f4d900" d="M0 238h513v104H0z" />
    <path fill="#cb0f31" d="M256 171 0 342V0z" />
    <path
      fill="#f4d900"
      d="m83.5 109.8 15.1 46.5h48.9L107.9 185l15.1 46.5-39.5-28.7-39.6 28.7L59 185l-39.5-28.7h48.9z"
    />
  </svg>
)

export var NA = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#009a44" d="M0 0h513v342H0z" />
    <path fill="#002f6c" d="M0 342V0h513" />
    <path fill="#FFF" d="M513 67V0H412.5L0 275v67h100.5z" />
    <path fill="#c8102e" d="M513 0v40.2L60.3 342H0v-40.2L452.7 0z" />
    <path
      fill="#ffcd00"
      d="m188.1 104.1-22.8 10.7 12.2 22.1-24.8-4.8-3.1 25-17.3-18.4-17.2 18.4-3.1-25-24.8 4.8 12.2-22.1-22.8-10.7 22.8-10.7-12.2-22.1L112 76l3.1-25 17.2 18.4L149.6 51l3.1 25 24.8-4.7-12.2 22.1z"
    />
  </svg>
)

export var NC = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#009543" d="M0 234.8h513V342H0V234.8z" />
    <path fill="#ED4135" d="M0 105.8h513v129.3H0V105.8z" />
    <path fill="#0035AD" d="M0 0h513v106.8H0V0z" />
    <circle
      fill="#FAE600"
      stroke="#000"
      strokeWidth={5.3}
      cx={192.4}
      cy={171}
      r={126.1}
    />
    <path d="m246.8 284.1-25.5 9.6-28.9 3.4-30.3-1.9-28.8-12.4s22.9-23.5 32.6-26.9c6.9-2.4 18-3 18-3V97.8l-.2-52.9h13.5l-.4 54.1v153.7s12.3 1 17.7 3.3c9 3.8 32.3 28.1 32.3 28.1z" />
    <path d="m168.3 80.8 39.5-19.7 5.1 10.3-39.5 19.7-5.1-10.3z" />
    <ellipse cx={190.6} cy={224.8} rx={13.5} ry={21.2} />
    <circle cx={190.3} cy={114.9} r={16.8} />
    <ellipse cx={191.1} cy={169.2} rx={16} ry={9.7} />
    <path d="M171.4 146.7h37.7v8h-37.7zm0 36h37.7v8h-37.7z" />
    <g fill="none" stroke="#000" strokeWidth={10} strokeMiterlimit={10}>
      <path d="M163.4 112.2s.8 26.8 27.3 26.8 26.5-26.8 26.5-26.8" />
      <path
        className="prefix__st4"
        d="M163.4 224.8s1.9-26.6 27.3-26.6 26.5 26.6 26.5 26.6"
      />
    </g>
  </svg>
)

export var NE = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#FFF" d="M0 0h513v342H0z" />
    <path fill="#e05206" d="M0 0h513v114H0z" />
    <path fill="#0db02b" d="M0 228h513v114H0z" />
    <circle fill="#e05206" cx={256.5} cy={171} r={32} />
  </svg>
)

export var NF = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#FFF" d="M0 0h513v342H0z" />
    <path
      d="M0 0h171v342H0zm342 0h171v342H342zm-38 227L256 75l-48 152h41v40h14v-40z"
      fill="#007934"
    />
  </svg>
)

export var NG = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#FFF" d="M0 0h513v342H0z" />
    <path d="M0 0h171v342H0zm342 0h171v342H342z" fill="#008751" />
  </svg>
)

export var NI = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#FFF" d="M0 0h513v342H0z" />
    <path d="M0 0h513v114H0zm0 228h513v114H0z" fill="#0067c6" />
    <circle
      fill="none"
      stroke="#FFDA44"
      strokeWidth={5}
      cx={256.5}
      cy={171}
      r={50}
    />
    <path fill="#0a47a5" d="M285.7 176.7h-58.4l-9.8 16.9h78z" />
    <path fill="#6fd8f3" d="m256.5 126.1-29.2 50.6h58.4z" />
    <path fill="#97c924" d="M221.7 186.4h69.6l-8-13.9h-53.6z" />
    <circle fill="red" cx={256.5} cy={161} r={5} />
  </svg>
)

export var NL = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#FFF" d="M0 114h513v114H0z" />
    <path fill="#cd1f2a" d="M0 0h513v114H0z" />
    <path fill="#1d4185" d="M0 228h513v114H0z" />
  </svg>
)

export var NO = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#ba0c2f" d="M0 0h513v342H0z" />
    <path
      fill="#FFF"
      d="M513 211H202.6v131h-79.9V211H0v-80h122.7V0h79.9v131H513v61.4z"
    />
    <path
      fill="#00205b"
      d="M513 149.6v42.8H184V342h-42.7V192.4H0v-42.8h141.3V0H184v149.6z"
    />
  </svg>
)

export var NP = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#FFF" d="M0 0h513v342H0z" />
    <path fill="#0052B4" d="M0 342V-.2L281.1 175H87.8l184 167z" />
    <path fill="#D80027" d="M243.4 164.8 9.2 19.3v313.5h235.2l-184.1-168z" />
    <path
      fill="#FFF"
      d="m62.4 204.1 7.9 16.2 14.9-10.1-1.3 18 18-1.3-10.1 14.9 16.2 7.9-16.2 7.8 10.1 15-18-1.3 1.3 17.9L70.3 279l-7.9 16.2-7.8-16.2-14.9 10.1 1.3-17.9-18 1.3 10.1-15-16.2-7.8 16.2-7.9L23 226.9l18 1.3-1.3-18 14.9 10.1zm-5.3-103.7 5.3 7.7 5.4-7.7 2 9.1 7.9-5-1.7 9.2 9.3-1.7-5.1 7.9 9.2 2-7.8 5.4 7.8 5.3-9.2 2 5.1 7.9-9.3-1.7 1.7 9.3-7.9-5.1-2 9.2-5.4-7.7-5.3 7.7-2-9.2-7.9 5.1 1.7-9.3-9.3 1.7 5.1-7.9-9.2-2 7.7-5.3-7.7-5.4 9.2-2-5.1-7.9 9.3 1.7-1.7-9.2 7.9 5z"
    />
    <path
      fill="#FFF"
      d="M18.5 108.7s4.8 27.7 44 27.7 44-27.7 44-27.7c0 9.4-6 46.5-44 46.5s-44-38.2-44-46.5z"
    />
  </svg>
)

export var NR = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#012169" d="M0 0h513v342H0z" />
    <path fill="#ffc72c" d="M0 155h513v32H0z" />
    <path
      fill="#FFF"
      d="m164.2 189 7.9 27.7 20.7-20-7 27.9 28-7-20.1 20.7 27.8 7.9-27.8 7.9 20.1 20.7-28-7 7 28-20.7-20.1-7.9 27.8-7.9-27.8-20.7 20.1 7-28-27.9 7 20-20.7-27.7-7.9 27.7-7.9-20-20.7 27.9 7-7-27.9 20.7 20z"
    />
  </svg>
)

export var NU = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#fedd00" d="M0 0h513v342H0z" />
    <path fill="#012169" d="M0 0h256.5v171H0z" />
    <g fill="#FFF">
      <path d="M256.5 0v30.6l-45.3 25.2h45.3v59.4h-59.2l59.2 32.9V171h-26.7l-73.7-40.9V171h-55.7v-48.7L12.8 171H0v-30.6l45.3-25.2H0V55.8h59.2L0 22.9V0h26.7l73.7 40.9V0h55.7v48.7L243.7 0z" />
      <path d="M156.1 115.2 256.5 171v-15.8l-72-40zm-55.7-59.4L0 0v15.8l72 40z" />
    </g>
    <g fill="#D80027">
      <path d="M144.3 0h-32.1v69.5H0v32h112.2V171h32.1v-69.5h112.2v-32H144.3z" />
      <path d="M156.1 115.2 256.5 171v-15.8l-72-40zm-84.1 0-72 40V171l100.4-55.8zm28.4-59.4L0 0v15.8l72 40zm84.1 0 72-40V0L156.1 55.8z" />
    </g>
    <circle fill="#012169" cx={126.8} cy={85.7} r={29.9} />
    <path
      d="m128.3 128.6 3.5 10.9h11.5l-9.3 6.7 3.5 10.9-9.2-6.7-9.3 6.7 3.5-10.9-9.2-6.7h11.4zm-.1-115.4 3.6 10.9h11.4l-9.2 6.7 3.5 10.9-9.3-6.7-9.2 6.7 3.5-10.9-9.3-6.7h11.5zm76.4 58.1 3.5 10.9h11.5l-9.3 6.7 3.5 10.9-9.2-6.7-9.3 6.7 3.5-10.9-9.2-6.7H201zm-151.8.1 3.6 10.9h11.4l-9.3 6.8 3.6 10.8-9.3-6.7-9.3 6.7 3.6-10.8-9.3-6.8h11.5zm74-15.6 6.7 20.7h21.8l-17.7 12.8 6.8 20.6-17.6-12.7-17.7 12.7 6.8-20.6-17.6-12.8H120z"
      fill="#fedd00"
    />
  </svg>
)

export var NZ = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#012169" d="M0 0h513v342H0z" />
    <path
      d="m448.9 107.7 4.2 13.1h13.8l-11.1 8.1L460 142l-11.1-8.1-11.1 8.1 4.2-13.1-11.1-8.1h13.7zm-64.2 145.9 5.1 15.6h16.4l-13.2 9.7 5 15.6-13.3-9.7-13.2 9.7 5-15.6-13.3-9.7h16.5zm.1-210.2 4.7 14.6h15.3l-12.4 8.9 4.7 14.6-12.3-9-12.4 9 4.7-14.6-12.3-8.9H380zm-64.2 86 4.7 14.5h15.3l-12.3 9 4.7 14.5-12.4-8.9-12.3 8.9 4.7-14.5-12.4-9h15.3z"
      fill="#D80027"
      stroke="#FFF"
      strokeWidth={2}
      strokeMiterlimit={10}
    />
    <path fill="#012169" d="M0 0h256.5v171H0z" />
    <g fill="#FFF">
      <path d="M256.5 0v30.6l-45.3 25.2h45.3v59.4h-59.2l59.2 32.9V171h-26.7l-73.7-40.9V171h-55.7v-48.7L12.8 171H0v-30.6l45.3-25.2H0V55.8h59.2L0 22.9V0h26.7l73.7 40.9V0h55.7v48.7L243.7 0z" />
      <path d="M156.1 115.2 256.5 171v-15.8l-72-40zm-55.7-59.4L0 0v15.8l72 40z" />
    </g>
    <g fill="#D80027">
      <path d="M144.3 0h-32.1v69.5H0v32h112.2V171h32.1v-69.5h112.2v-32H144.3z" />
      <path d="M156.1 115.2 256.5 171v-15.8l-72-40zm-84.1 0-72 40V171l100.4-55.8zm28.4-59.4L0 0v15.8l72 40zm84.1 0 72-40V0L156.1 55.8z" />
    </g>
  </svg>
)

export var OM = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#D80027" d="M0 0h513v342H0z" />
    <path fill="#FFF" d="M138 0h377v114H138z" />
    <path fill="#4A7C3A" d="M138 230h377v114H138z" />
    <g fill="none" stroke="#FFF" strokeWidth={10} strokeMiterlimit={2}>
      <path d="M40.3 35.2s37.1 48 50.8 54.5c13.7 6.5 17.1 5.7 17.1 5.7" />
      <path d="M100 35.2S62.9 80.6 53.3 87.6c-9.6 7-18.7 7.8-18.7 7.8m17.1-30.1h37.9M70.7 35.2v30.1" />
    </g>
  </svg>
)

export var PA = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#FFF" d="M0 0h513v342H0z" />
    <path fill="#da121a" d="M256.5 0H513v171H256.5z" />
    <path
      fill="#072357"
      d="M0 171h256.5v171H0zM128 37.9l11.8 36.4h38.3l-31 22.4 11.9 36.4-31-22.5-31 22.5 11.9-36.4-31-22.4h38.3z"
    />
    <path
      fill="#da121a"
      d="m384 208.9 11.8 36.4h38.3l-31 22.4 11.9 36.4-31-22.5-31 22.5 11.9-36.4-31-22.4h38.3z"
    />
  </svg>
)

export var PE = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#FFF" d="M0 0h513v342H0z" />
    <path d="M0 0h171v342H0zm342 0h171v342H342z" fill="#D80027" />
    <path
      fill="#00A854"
      d="M224.3 119c4.3 7.6-17.1 71.9-6.5 87.8s21.9 22.4 38.2 22.4c16.3 0 30.7-6.8 39.6-24.7s-14.2-76.3-6.8-85.4c7.4-9.1 29.3 8.5 35.5 35.2 6.2 26.7-8.4 60.2-20.7 70-12.3 9.7-20.3 9.7-47.6 9.7s-32.4-1.4-45-10.7c-12.5-9.4-28.9-35.8-22.7-67.3 6.2-31.7 31.7-44.6 36-37z"
    />
    <path
      fill="#D91023"
      stroke="#E7CA00"
      strokeWidth={2}
      d="M272.6 218.9H240c-7.5 0-13.6-6.1-13.6-13.6v-45c0-7.5 6.1-13.6 13.6-13.6h32.6c7.5 0 13.6 6.1 13.6 13.6v45c.1 7.5-6 13.6-13.6 13.6z"
    />
    <ellipse fill="#E7CA00" cx={256.4} cy={200.9} rx={25} ry={13.2} />
    <path fill="#FFF" d="M256.4 147.6v35.1h28.9c0-38.3 3.9-35.1-28.9-35.1z" />
    <path
      fill="#007EA8"
      d="M256.4 147.6v35.1h-28.9c0-37.9-3.7-35.1 28.9-35.1z"
    />
    <path fill="#947245" d="M270.1 158.1h1.6v21.5h-1.6z" />
    <circle fill="#D18219" stroke="#FFF" cx={241.8} cy={165.2} r={8.1} />
    <ellipse
      fill="none"
      stroke="#00A854"
      strokeWidth={6}
      cx={256.4}
      cy={122.2}
      rx={20.5}
      ry={16.5}
    />
    <ellipse
      fill="none"
      stroke="#E7CA00"
      strokeWidth={3}
      cx={256.4}
      cy={122.2}
      rx={20.5}
      ry={16.5}
    />
    <circle fill="#E7CA00" cx={270.9} cy={163.1} r={8.9} />
  </svg>
)

export var PF = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#FFF" d="M0 0h513v342H0z" />
    <path d="M0 0h513v85H0zm0 257h513v85H0z" fill="#D80027" />
    <path fill="#1481DB" d="M329.5 171c0 40.3-32.7 73-73 73s-73-32.7-73-73" />
    <path
      fill="#FFAB50"
      d="M256.5 98c-40.3 0-73 32.7-73 73h146c0-40.3-32.7-73-73-73z"
    />
    <g fill="#FFF">
      <path d="M181.9 169.3h150.5v4.5H181.9z" />
      <path d="M222.4 162.9h66.5v10.9h-66.5z" />
    </g>
    <path
      d="M212.8 131.1H223s-1.6 55.5.1 57.4c11.9 13.5 25.3 0 25.3 0s-2.7 18.9-17.8 18.9-17.8-18.7-17.8-18.7v-57.6zm85.6 0h-10.2s1.6 55.5-.1 57.4c-11.9 13.5-25.3 0-25.3 0s2.7 18.9 17.8 18.9c15.1 0 17.8-18.7 17.8-18.7v-57.6zM242.6 156l25.9 6.9v-36.4s-14-3.8-14-16.8 14-9.6 14-9.6-25.9-4.6-25.9 8.1V156z"
      fill="#D80027"
      stroke="#630810"
      strokeWidth={2}
    />
  </svg>
)

export var PG = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path d="M0 0h513v342H0z" />
    <path fill="#C8102E" d="M0 0h513v342" />
    <path
      d="m153.7 225 2.7 8.5h9l-7.2 5.2 2.7 8.6-7.2-5.3-7.3 5.3 2.8-8.6-7.3-5.2h9zm-25.3-120 5.2 16h16.8l-13.6 9.9 5.2 16-13.6-9.9-13.6 9.9 5.2-16-13.6-9.9h16.8zm0 160.3 5.2 16h16.8l-13.6 9.9 5.2 16-13.6-9.9-13.6 9.9 5.2-16-13.6-9.9h16.8zm50.7-96.1 5.2 16h16.8l-13.6 9.9 5.2 16-13.6-9.9-13.6 9.9 5.2-16-13.6-9.9h16.8zm-107.3 4.1 5.2 16h16.8l-13.6 9.9 5.2 15.9-13.6-9.8-13.6 9.8 5.2-15.9-13.6-9.9h16.8z"
      fill="#FFF"
    />
    <g fill="#FFCD00">
      <path d="M288 79.9s33 13.8 30 19.7c-2.9 5.9-17.4-7.1-30-3.5-12.7 3.5-28.6 32.4-28.6 32.4s18.6 2.7 34.2 1.5c15.6-1.2 19.7-7.4 19.7-7.4s.7 15.3 12.7 24.3c18.2 13.6 56.2 22.3 56.2 22.3s.6-6.5-2.7-20.7-8-21.4-8-21.4 55.7 38.3 51.2 59.3-30.1 19.6-30.1 19.6 28.4 12.5 37.4-13.5c12.4-35.6-42.4-65.2-42.4-65.2s6.5 3.1 17.1 4.6 20.3-.3 20.3-.3-13.8-43.6-29.2-52.1c-15.3-8.5-37.1-.9-37.1-.9s9.1-5.9 10-15.9c.9-10-3.5-24.1-3.5-24.1-50.1 21.2-21.2 41.2-33 49.2-2 1.4-9.5-9.9-18.8-8.2-11.5 1.8-25.4.3-25.4.3z" />
      <path d="M404.7 131.8s15.3 17.7 8.2 35.9c-7.1 18.3-37.7 13.5-37.7 13.5s24.7 13.9 40.6-5.3-2.4-43.6-2.4-43.6l-8.7-.5z" />
    </g>
  </svg>
)

export var PH = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#FFF" d="M0 0h513v342H0z" />
    <path fill="#0038A8" d="M513 0v171H256.5L0 0z" />
    <path fill="#CE1126" d="M513 171v171H0l256.5-171z" />
    <g fill="#FCD116">
      <path d="m22.1 33.8 8.5 11.9 13.8-4.5-8.6 11.7 8.5 11.8-13.8-4.6-8.6 11.7V57.2L8.2 52.7 22 48.4zm0 236.4 8.5 11.8 13.8-4.4-8.6 11.7 8.5 11.8-13.8-4.6-8.6 11.7v-14.6l-13.7-4.5 13.8-4.3zM210.5 152l-8.5 11.8-13.8-4.4 8.6 11.7-8.4 11.8 13.7-4.6 8.6 11.7v-14.6l13.7-4.5-13.8-4.3z" />
      <circle cx={95} cy={171} r={32} />
      <path d="m95 171 11.2 56.5-3.4 3.4-3.7 3.5-4.2 4.2-4.2-4.2-3.7-3.5-3.4-3.4L95 171zm0 0-11.2-56.5 3.4-3.4 3.7-3.5 4.2-4.2 4.2 4.2 3.7 3.5 3.4 3.4L95 171zm0 0 56.5-11.2 3.4 3.4 3.5 3.7 4.2 4.2-4.2 4.2-3.5 3.7-3.4 3.4L95 171zm0 0-56.5 11.2-3.4-3.4-3.5-3.7-4.2-4.2 4.2-4.2 3.5-3.7 3.4-3.4L95 171zm0 0 32-47.9h4.8l5.1.2h5.9v5.9l.2 5.1v4.8L95 171zm0 0-32 47.9h-4.8l-5.1-.2h-5.9v-5.9l-.2-5.1v-4.8L95 171zm0 0 47.9 32v4.8l-.2 5.1v5.9h-5.9l-5.1.2h-4.8L95 171zm0 0-47.9-32v-4.8l.2-5.1v-5.9h5.9l5.1-.2h4.8L95 171z" />
    </g>
  </svg>
)

export var PK = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 900 600" {...rest}>
    {title && <title>{title}</title>}
<path fill="#FFF" d="M0 0h900v600H0z" />
    <path fill="#01411C" d="M225 0h675v600H225z" />
    <path
      fill="#FFF"
      d="M562.5 120c99.4 0 180 80.6 180 180s-80.6 180-180 180-180-80.6-180-180 80.6-180 180-180z"
    />
    <path
      fill="#01411C"
      d="M498.9 135.8c68.1-60.5 172.4-54.4 232.9 13.7s54.4 172.4-13.7 232.9-172.4 54.4-232.9-13.7-54.4-172.4 13.7-232.9z"
    />
    <path
      fill="#FFF"
      d="m628.1 165.3 75.8 85.3-111.5-24.4L697 180.4l-57.7 98.5-11.2-113.6z"
    />
  </svg>
)

export var PL = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#FFF" d="M0 0h513v342H0z" />
    <path fill="#dc143c" d="M0 171h513v171H0z" />
  </svg>
)

export var PM = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#FFF" d="M0 0h513v342H0z" />
    <path fill="#00318A" d="M0 0h171v342H0z" />
    <path fill="#D80027" d="M342 0h171v342H342z" />
  </svg>
)

export var PN = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#012169" d="M0 0h513v342H0z" />
    <g stroke="#000">
      <path
        fill="#96877d"
        d="m400.7 134.5-16.7 5.6-16.7-5.6-5.6-13.9 5.6-13.9h33.4l-5.6 13.9z"
      />
      <path
        fill="#006ec7"
        d="M345 134.5v61.2c0 29.8 39 39 39 39s39-9.1 39-39v-61.2h-78z"
      />
      <path
        fill="#337321"
        d="M348.6 210.2c9.6 18.4 35.4 24.5 35.4 24.5s25.9-6.1 35.4-24.5l-35.4-59-35.4 59z"
      />
      <path
        fill="#f7e017"
        d="m423 195.1-39-60.6-39 60.6v.6c0 5.5 1.3 10.3 3.5 14.5l35.4-55.1 35.4 55.1c2.2-4.2 3.5-9 3.5-14.5v-.6z"
      />
    </g>
    <path fill="#012169" d="M0 0h256.5v171H0z" />
    <g fill="#FFF">
      <path d="M256.5 0v30.6l-45.3 25.2h45.3v59.4h-59.2l59.2 32.9V171h-26.7l-73.7-40.9V171h-55.7v-48.7L12.8 171H0v-30.6l45.3-25.2H0V55.8h59.2L0 22.9V0h26.7l73.7 40.9V0h55.7v48.7L243.7 0z" />
      <path d="M156.1 115.2 256.5 171v-15.8l-72-40zm-55.7-59.4L0 0v15.8l72 40z" />
    </g>
    <g fill="#D80027">
      <path d="M144.3 0h-32.1v69.5H0v32h112.2V171h32.1v-69.5h112.2v-32H144.3z" />
      <path d="M156.1 115.2 256.5 171v-15.8l-72-40zm-84.1 0-72 40V171l100.4-55.8zm28.4-59.4L0 0v15.8l72 40zm84.1 0 72-40V0L156.1 55.8z" />
    </g>
    <path
      fill="#f7e017"
      d="M375 189.5h18.3l.1 5.5h-5.8v25.2l12.3-6.1 3 5-18.9 9.7-18.4-9.8 2.9-5.1 12.6 6.3V195H375z"
    />
  </svg>
)

export var PR = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#FFF" d="M0 0h513v342H0z" />
    <path
      d="M0 0h513v68.4H0zm0 136.8h513v68.4H0zm0 136.8h513V342H0z"
      fill="#E00"
    />
    <path fill="#04F" d="M256.5 171 0 342V0z" />
    <path
      fill="#FFF"
      d="m84 110.1 15.1 46.5H148l-39.6 28.8 15.1 46.5L84 203.1l-39.6 28.8 15.1-46.5L20 156.6h48.9z"
    />
  </svg>
)

export var PS = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#FFF" d="M0 0h513v342H0z" />
    <path d="M0 0h513v114H0z" />
    <path fill="#007A3D" d="M0 228h513v114H0z" />
    <path fill="#CE1126" d="M256.5 171 0 342V0z" />
  </svg>
)

export var PT = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="red" d="M0 0h513v342H0z" />
    <path fill="#060" d="M197 0v342H0V0z" />
    <circle fill="#FF0" cx={197.1} cy={171} r={64} />
    <path
      fill="red"
      d="M161.1 139v40c0 19.9 16.1 36 36 36s36-16.1 36-36v-40h-72z"
    />
    <path
      fill="#FFF"
      d="M197.1 191c-6.6 0-12-5.4-12-12v-16h24v16c0 6.6-5.3 12-12 12z"
    />
  </svg>
)

export var PW = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#09f" d="M0 0h513v342H0z" />
    <circle fill="#ff0" cx={220} cy={171} r={74} />
  </svg>
)

export var PY = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#FFF" d="M0 0h513v342H0z" />
    <path fill="#D52B1E" d="M0 0h513v114H0z" />
    <path fill="#0038A8" d="M0 228h513v114H0z" />
    <path
      fill="#009B3A"
      d="m279.7 148-8.7 8.7c3.7 3.7 6 8.8 6 14.5 0 11.3-9.2 20.5-20.5 20.5s-20.5-9.2-20.5-20.5c0-5.7 2.3-10.8 6-14.5l-8.7-8.7c-5.9 5.9-9.6 14.1-9.6 23.2 0 18.1 14.7 32.8 32.8 32.8s32.8-14.7 32.8-32.8c0-9.1-3.7-17.3-9.6-23.2z"
    />
    <path
      fill="#FEDF00"
      stroke="#000"
      d="m256.5 157.2 3.2 9.9h10.5l-8.5 6.2 3.2 9.9-8.4-6.2-8.4 6.2 3.2-9.9-8.5-6.2h10.5z"
    />
    <circle
      fill="none"
      stroke="#000"
      strokeWidth={2}
      cx={256.5}
      cy={171}
      r={45}
    />
  </svg>
)

export var QA = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#8a1538" d="M0 0h513v342H0z" />
    <path
      fill="#FFF"
      d="M0 0v342h150.3l37.7-19.6-37.7-18.9 37.7-19-37.7-18.9 37.7-19-37.7-19 37.7-18.9-37.7-19 37.7-19-37.7-18.9 37.7-19-37.7-18.9 37.7-19-37.7-19L188 57l-37.7-19L188 19.1 150.3 0z"
    />
  </svg>
)

export var RE = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#FFF" d="M0 0h513v342H0z" />
    <path fill="#00318A" d="M0 0h171v342H0z" />
    <path fill="#D80027" d="M342 0h171v342H342z" />
  </svg>
)

export var RO = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#002b7f" d="M0 0h171v342H0z" />
    <path fill="#fcd116" d="M171 0h171v342H171z" />
    <path fill="#ce1126" d="M342 0h171v342H342z" />
  </svg>
)

export var RS = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#c6363c" d="M0 0h513v114H0z" />
    <path fill="#0c4076" d="M0 114h513v114H0z" />
    <path fill="#FFF" d="M0 228h513v114H0z" />
    <path
      fill="#c6363c"
      d="M120 96.8v85.1c0 48.4 63.3 63.3 63.3 63.3s63.3-14.8 63.3-63.3V96.8H120z"
    />
    <path
      d="M146.1 111.6h74.2V82l-14.8 7.4-22.3-22.3L161 89.4 146.1 82zm85.6 82.2-48.3-48.2-48.2 48.2 15.7 15.7 32.5-32.5 32.5 32.5z"
      fill="#edb92e"
    />
    <path
      fill="#FFF"
      d="M231.7 148.7h-22.5c1.3-2.2 2-4.7 2-7.4 0-8.2-6.6-14.8-14.8-14.8-5.7 0-10.6 3.2-13.1 7.8-2.5-4.7-7.4-7.8-13.1-7.8-8.2 0-14.8 6.6-14.8 14.8 0 2.7.7 5.2 2 7.4h-22.1c0 8.2 7.1 14.8 15.3 14.8h-.6c0 8.2 6.6 14.8 14.8 14.8 0 7.3 5.2 13.3 12.1 14.6l-11.7 26.4c5.6 2.3 11.7 3.5 18.1 3.5s12.5-1.3 18.1-3.5L189.9 193c6.9-1.3 12.1-7.3 12.1-14.6 8.2 0 14.8-6.6 14.8-14.8h-.5c8.2 0 15.4-6.7 15.4-14.9z"
    />
  </svg>
)

export var RU = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#FFF" d="M0 0h513v114H0z" />
    <path fill="#0039a6" d="M0 114h513v114H0z" />
    <path fill="#d52b1e" d="M0 228h513v114H0z" />
  </svg>
)

export var RW = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#00A5E0" d="M0 0h513v171H0z" />
    <path fill="#F9D202" d="M0 171h513v85.5H0z" />
    <path fill="#1E5F3D" d="M0 256.5h513V342H0z" />
    <path
      fill="#F9D202"
      d="m420.6 36.1 2.3 35.9 11.6-34.1-7 35.3 19.9-29.9-15.8 32.2 27-23.7-23.7 27L467.1 63l-29.9 19.9 35.3-7-34.1 11.6 35.9 2.3-35.9 2.3 34.1 11.6-35.3-7 29.9 19.9-32.2-15.8 23.7 27-27-23.7 15.8 32.2-19.9-29.9 7 35.3-11.6-34.1-2.3 35.9-2.3-35.9-11.6 34.1 7-35.3-19.9 29.9 15.8-32.2-27 23.7 23.7-27-32.2 15.8L404 96.7l-35.3 7 34.1-11.6-35.9-2.3 35.9-2.3-34.1-11.6 35.3 7L374.1 63l32.2 15.8-23.7-27 27 23.7-15.8-32.2 19.9 29.9-7-35.3L418.3 72z"
    />
    <circle
      fill="#F9D202"
      stroke="#00A5E0"
      strokeWidth={2}
      cx={420.6}
      cy={89.8}
      r={15.9}
    />
  </svg>
)

export var SA = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path d="M0 0h513v342H0z" fill="#fff" />
    <g fill="#00512e">
      <path d="M0 0v342h513V0zm218 76q1 2-2 5-3 2-1 4 3 4 0 6-2 1-5-1-6-6 0-14 6-4 8 0m-102 2 1 6q0 4-2 4-5 1-5-6l2-4zm39 1 1 2q-1 4-5 4-5 0-6-4c0-4 7-6 10-2m47 2q3 4 2 9c-1 2-22 19-24 19q-3 0-4-4l6-6 6-5v-3c-5-10 7-18 14-10m35-3q3 1 0 7-2 8-6 6c-3-1-3 14 0 19q2 4 7-1c2-3 2-5 2-15 0-12 0-13 2-13q5-2 5 13 1 11 3 13 3 6 6 3 3-2-1-12-3-12 1-16h9q2-2 9 1l6 2 1-2q4-4 6-1l3 17c3 16 3 16 7 24l15 30q1 6-4 5l-8-14-6-12 1 20c1 21 1 23-4 23q-4 2-4-15l-1-27-1-16-9-13c-8-12-8-13-11-13q-6-1-2 6l2 7q0 4 3 2 6-2 6 3-1 4-8 5l-5 2-5 2q-6 0-10-3-2-3-5 1-5 5-12 2-5-1-7-10l-1-3-1 3q-3 7-9 8-7 0-9-11-3-10 2-10 4-1 5 7l2 6q1 0 4-7 6-17 13-12h1c-1-1 2-10 4-11zm-97 10 2 16 1 9h4q5 2 6-1c2-1 2-2-1-11l-3-12 3-1 11 5V82q4-2 6 1l3 23 1 20h2q5 0 5 5 1 6 3 0 3-9 8-2 1 3 2 0 3-7 4-6c5 0 6 7 1 13q-3 3-7 3l-6 1q-5 4-10 0l-2-2v5c0 21-16 42-33 42q-21-1-23-21 0-5 2-6 4-1 6 6 1 12 12 13 14 2 24-15 6-11 1-5-12 18-28 11-7-5-9-17-2-6 1-7 5-3 6 6 1 12 10 12 7 0 13-8 5-8-1-7-11-1-8-12 8-11 17-5l3 2-1-12-4-22q-3 1 0 7c2 6 2 6 0 10l-5 5q-3 3-7 1h-5l-1 16c-1 19-1 20-4 21-4 1-4-2-4-19l1-15-3 1q-3 1-6-2c-2-2-2-2-3-14l-1-12q-2-1-2 10l-1 13q-3 6-8 4c-3-2-4-4-7-15q-4-15 2-14 4-1 5 8l1 5 1-6q0-13 9-12l6 2c2 3 2 4 2 14l1 11 2-1 1-8-2-16q-3-12 2-11 3-1 5 7m163-3q4 10 1 13-4 3-7-7-3-11 2-10zm12-3 3 7q2 6 1 8v16l2 27c2 22 2 21 6 21h3l-1-5-2-23-3-33c-2-16-1-19 3-19 3 0 8 14 6 16v24c5 47 5 48 0 47q-3-2-1 4l2 6q2 1 5-9 7-18 10-16 3 0 7 5 4 7 7 7 4-1 1-33l-1-21-10-12-9-15q0-5 8-1 5 2 6 6l2 6q3 4 1-4 0-10 3-10c4 0 9 10 7 13l-1 8q1 8 4 12l3 3-2-15c-2-16-2-19 1-20q3 0 5 4l4 5h2q6-4 8 9 0 8-4 8-3 0-4-6 1-8-3-5c-1 2-1 3 1 19l2 17 5 7c6 10 12 21 11 22q-2 3-5 2l-5-8-5-8 1 8c0 11 0 11-3 11q-5 3-5-7l-1-16c0-8-1-10-4-15l-4-5v19c1 21 0 25-5 28q-6 5-13-3l-4-5-4 9q-6 14-11 15-9-1-11-16-1-8-5-1c-3 5-12 13-19 17q-8 4-8-2-1-2 6-6c9-5 17-14 17-18l-5-78q2-4 5-1m89 5 4 6q1 1-2 3l-2 2 4 24q4 25 4 35c0 10 0 11-3 17q-7 13-19 14-8 0-7-2-2-4 7-6 15-2 14-23a708 708 0 0 0-8-75c3-2 3-1 8 5m-211 19 1 4q0 3 2 2 5 0 5 4c0 4-9 6-13 2-4-5 0-17 5-12m108 1h2l4-1q4 2 0 7-7 6-11-1v-5q3-2 5 0m55 2q3 4-1 6-2 0-1 5t-1 6q-1 2-10-6-8-7-6-9 3-4 7 0l2 2 2-3q5-3 8-1m-131 13c3 2 6 14 6 17q-1 6 6 1l10-4q5-1 7-4 4-9 10-12 10 0 11 9 0 7-16 13l-2 1 13 1c16 0 16 0 13 9q-2 7-4 7l-10 2q-19 3-17 9 1 2 4 3 6 3 3 7l-7 1q-13-2-21-10l-3-3-2 3q-7 10-19 13-10 2-15-10l-5 2q-18 10-19 8l-2-3c0-2 1-2 15-11l9-6q1-3 5-4c3 1 10-5 12-9q3-6-1-15l-2-8q1-5 6-6c3 0 8 5 8 7q-1 4-4 3v1l1 10c1 9-1 13-10 21l-7 6 2 3q5 9 15-2 10-8 10-23 0-10-6-24v-4q3-4 6 1m17 2q2 3 4 0 11-3 5 5c-4 5-12 5-15-1v-4zm118 5 1 2q1 2-7 8c-8 6-9 7-11 5q-5-4 6-10c8-6 8-6 11-5m-229 3q3 2-10 10-12 8-13 3-5-3 9-10 13-8 14-3m229 10c3 2 4 9 3 11q-3 3-6 1c-2-2-3-11-1-13q1-2 4 1m-172 7q3 3 2 7 1 5-3 5-3 1-3-3l-2-4q-3-3-1-6 4-2 7 1m-79 9 1 8q0 9 3 6 4-1 4 3-1 7-7 7-7-1-7-14-1-9 2-10zm168 12q0 4 3 2t4 3q-2 6-8 8l-4-2q-3-3-4-2-4 0-5-4l5-6q7-6 7-4 3 1 2 5m102 3q4 4 1 9-7 7-7-4t6-5m-42 73c0 2 1 2 12 2q24-1 22 11 0 7-6 10c-4 1-31 2-34 0q-2-1-2-6v-4h-82l-74-1c-16 0-28-10-28-10h92c91 0 92-1 92-2q-1-3 4-5c5-2 4 4 4 5" />
      <path d="m195 86 1 1 1-1-1-1q-2 0-1 1m84 5q-2 2 1 5l3 3-1-4-1-5zm-125 45q-3 3-1 4 5-1 6-4zm110-7q-4 5 0 3 6-4 2-4zm-31 30q0 6 4 8l5 4q3 2 2-3 0-3 4-7 4-3 2-4l-13-3h-5zm104 101q-1 3 13 2c11 0 13 0 14-2l-13-1z" />
    </g>
  </svg>
)

export var SB = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#205831" d="M0 0h513v342H0z" />
    <path fill="#004EB4" d="M0 342V0h513" />
    <path fill="#F4CA15" d="M0 328v14h28L513 14V0h-28z" />
    <path
      d="M47.2 11.5 54 32.6h22.3l-18 13.2 6.9 21.1-18-13.1-18 13.1L36 45.8 18 32.6h22.3zm113.6 0 6.9 21.1H190l-18 13.2 6.8 21.1-18-13.1-18 13.1 6.9-21.1-18-13.2H154zM47.2 122.3l6.8 21.1h22.3l-18 13.2 6.9 21.1-18-13-18 13 6.8-21.1-18-13.2h22.3zm113.6 0 6.9 21.1H190l-18 13.2 6.8 21.1-18-13-18 13 6.9-21.1-18-13.2H154zM104 66.9l6.8 21.2h22.3l-18 13 6.9 21.2-18-13.1-18 13.1 6.8-21.2-18-13h22.3z"
      fill="#FFF"
    />
  </svg>
)

export var SC = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#FFF" d="M0 0h513v342H0z" />
    <path fill="#F6CA3F" d="M185.9 0 0 342 368.2 0z" />
    <path fill="#007631" d="M513 224.5 0 342h513z" />
    <path fill="#CB262E" d="M513 0H358.2L0 342l513-224.9z" />
    <path fill="#002E69" d="M0 0v342L185.9 0z" />
  </svg>
)

export var SD = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#cb0f32" d="M0 0h513v114H0z" />
    <path fill="#FFF" d="M0 114h513v114H0z" />
    <path d="M0 228h513v114H0z" />
    <path fill="#006e28" d="m0 0 200 171L0 342z" />
  </svg>
)

export var SE = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#004F8E" d="M0 0h513v342H0z" />
    <path
      fill="#F6C500"
      d="M192.4.3h-64.2v138.8H0v64.1h128.2V342h64.2V203.2H513v-64.1H192.4z"
    />
  </svg>
)

export var SG = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 900 600" {...rest}>
    {title && <title>{title}</title>}
<path fill="#FFF" d="M0 0h900v600H0V0z" />
    <path fill="#ED2939" d="M0 0h900v300H0V0z" />
    <g fill="#FFF">
      <path d="M129.7 150c0-48.8 29-90.9 70.6-109.9-3.4-.3-6.8-.5-10.2-.5-61 0-110.4 49.4-110.4 110.4s49.4 110.4 110.4 110.4c3.4 0 6.9-.2 10.2-.5-41.7-19-70.6-61.1-70.6-109.9zm131.2-59.9 16.9-12.3H257l-6.5-19.9-6.5 19.9h-20.8l16.9 12.3-6.5 19.8 16.9-12.3 16.9 12.3zm37.3 114.5 16.9-12.2h-20.9l-6.5-19.9-6.4 19.9h-20.9l16.9 12.2-6.5 19.9 16.9-12.3 16.9 12.3z" />
      <path d="m200.7 133.8 16.9-12.3h-20.9l-6.4-19.8-6.5 19.8h-20.9l16.9 12.3-6.4 19.9 16.9-12.3 16.9 12.3zm137.4-12.3h-20.9l-6.5-19.8-6.4 19.8h-20.9l16.9 12.3-6.5 19.9 16.9-12.3 16.9 12.3-6.4-19.9zm-114.4 83.1 16.9-12.2h-20.9l-6.4-19.9-6.5 19.9h-20.9l16.9 12.2-6.4 19.9 16.9-12.3 16.9 12.3z" />
    </g>
  </svg>
)

export var SH = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#012169" d="M0 0h513v342H0z" />
    <path
      fill="#5f7dbd"
      d="M449 139.7c-.1 44.4-7.2 92.1-65 114.9-57.8-22.8-64.9-70.5-65-114.9h130z"
    />
    <path
      fill="#f2d049"
      d="M449 139.7c0-16.7-.9-32.9-.5-47.1C426.9 83 398.4 81 383.9 81s-42.9 2-64.6 11.6c.4 14.2-.5 30.4-.5 47.1H449z"
    />
    <path
      fill="#b38c79"
      d="m369.5 204.5.3 10.3-12.8.2 4.9 13.2h-17.3c-18-20.2-23.4-42.4-24.9-68.1l9.1-9.7 8.3 14.3 10.8-12.8 7 7.8.8 15.7 13.8 29.1z"
    />
    <path
      fill="#5c5568"
      d="m436.6 192.5-8.6 18.3h-47l-29.2-19.5 25.7 10.5h25.1l3.7-6.5 7.2.2 2-3z"
    />
    <path fill="#012169" d="M0 0h256.5v171H0z" />
    <g fill="#FFF">
      <path d="M256.5 0v30.6l-45.3 25.2h45.3v59.4h-59.2l59.2 32.9V171h-26.7l-73.7-40.9V171h-55.7v-48.7L12.8 171H0v-30.6l45.3-25.2H0V55.8h59.2L0 22.9V0h26.7l73.7 40.9V0h55.7v48.7L243.7 0z" />
      <path d="M156.1 115.2 256.5 171v-15.8l-72-40zm-55.7-59.4L0 0v15.8l72 40z" />
    </g>
    <g fill="#D80027">
      <path d="M144.3 0h-32.1v69.5H0v32h112.2V171h32.1v-69.5h112.2v-32H144.3z" />
      <path d="M156.1 115.2 256.5 171v-15.8l-72-40zm-84.1 0-72 40V171l100.4-55.8zm28.4-59.4L0 0v15.8l72 40zm84.1 0 72-40V0L156.1 55.8z" />
    </g>
  </svg>
)

export var SI = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 160" {...rest}>
    {title && <title>{title}</title>}
<path fill="#FF0D0B" d="M0 0h240v160H0V0z" />
    <path fill="#0E55BD" d="M0 0h240v106.7H0V0z" />
    <path fill="#FFF" d="M0 0h240v53.3H0V0z" />
    <path
      fill="#0E55BD"
      d="M99.5 30.8c-12.4-5.5-26.4-5.5-38.8 0-2.2 28.7 4.4 44.8 19.3 48.7 14.9-3.9 21.5-20 19.5-48.7z"
    />
    <path
      d="m82 37.1-1.5.1-.5-1.3-.5 1.3-1.5-.1.8 1.2-.8 1.2 1.5-.2.5 1.2.5-1.2 1.5.2-.8-1.2zm-5.5-7.4-1.4.2-.6-1.4-.6 1.4-1.4-.2.8 1.2-.8 1.2 1.4-.1.6 1.3.6-1.3 1.4.1-.8-1.2zm11 0-1.4.2-.6-1.4-.6 1.4-1.4-.2.8 1.2-.8 1.2 1.4-.1.6 1.3.6-1.3 1.4.1-.8-1.2z"
      fill="#FF0"
    />
    <path
      fill="#FFF"
      d="m87.9 48.7-3.1 4.1-4.7-9.3-4.7 9.3-3.1-4.1-7.9 10.4c0 .5.1.9.3 1.5 2.1 7.6 8 13.7 15.5 16.3 7.5-2.5 13.3-8.7 15.5-16.3.1-.4.3-.9.3-1.5l-8.1-10.4z"
    />
    <path
      fill="#0E55BD"
      d="M64.5 60.5c.8 2.8 3.7 4.4 6.4 3.6.4-.1.8-.3 1.2-.5 1.6-.9 3.6-.9 5.2 0s3.6.9 5.2 0 3.6-.9 5.2 0c2.5 1.5 5.7.5 7.1-1.9.3-.4.4-.8.5-1.2l.3.1v3.9c-.9 0-1.9.3-2.7.7-1.6.9-3.6.9-5.2 0s-3.6-.9-5.2 0-3.6.9-5.2 0-3.6-.9-5.2 0-3.6.9-5.2 0c-.8-.4-1.7-.7-2.7-.7v-3.9"
    />
    <path
      fill="#0E55BD"
      d="M64.5 63.6c.8 2.8 3.7 4.4 6.4 3.6.4-.1.8-.3 1.2-.5 1.6-.9 3.6-.9 5.2 0s3.6.9 5.2 0 3.6-.9 5.2 0c2.5 1.5 5.7.5 7.1-1.9.3-.4.4-.8.5-1.2l.3.1v3.9c-.9 0-1.9.3-2.7.7-1.6.9-3.6.9-5.2 0s-3.6-.9-5.2 0-3.6.9-5.2 0-3.6-.9-5.2 0-3.6.9-5.2 0c-.8-.4-1.7-.7-2.7-.7v-3.9"
    />
    <path
      fill="#FF0D0B"
      d="m99.5 30.8-1.6 24.8c-.7 10.5-7.8 19.7-17.9 22.9-10.1-3.2-17.2-12.3-17.9-22.9l-1.6-24.8c-.5.3-.9.4-1.5.7l1.5 24.1C61.3 66.9 69.1 76.7 80 80c10.9-3.3 18.7-13.1 19.3-24.4l1.5-24.1c-.4-.3-.9-.6-1.3-.7z"
    />
  </svg>
)

export var SJ = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#ba0c2f" d="M0 0h513v342H0z" />
    <path
      fill="#FFF"
      d="M513 211H202.6v131h-79.9V211H0v-80h122.7V0h79.9v131H513v61.4z"
    />
    <path
      fill="#00205b"
      d="M513 149.6v42.8H184V342h-42.7V192.4H0v-42.8h141.3V0H184v149.6z"
    />
  </svg>
)

export var SK = ({ title, ...rest }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 85.333 512 341.333"
    {...rest}
  >
    {title && <title>{title}</title>}
<path fill="#FFF" d="M0 85.337h512v341.326H0z" />
    <path fill="#0052B4" d="M0 196.641h512v118.717H0z" />
    <path fill="#D80027" d="M0 315.359h512v111.304H0z" />
    <path
      fill="#FFF"
      d="M129.468 181.799v85.136c0 48.429 63.267 63.267 63.267 63.267S256 315.362 256 266.935v-85.136H129.468z"
    />
    <path
      fill="#D80027"
      d="M146.126 184.294v81.941c0 5.472 1.215 10.64 3.623 15.485h85.97c2.408-4.844 3.623-10.012 3.623-15.485v-81.941h-93.216z"
    />
    <path
      fill="#FFF"
      d="M221.301 241.427h-21.425v-14.283h14.284v-14.283h-14.284v-14.284h-14.283v14.284h-14.282v14.283h14.282v14.283h-21.426v14.284h21.426v14.283h14.283v-14.283h21.425z"
    />
    <path
      fill="#0052B4"
      d="M169.232 301.658c9.204 5.783 18.66 9.143 23.502 10.636 4.842-1.494 14.298-4.852 23.502-10.636 9.282-5.833 15.79-12.506 19.484-19.939a24.878 24.878 0 0 0-14.418-4.583c-1.956 0-3.856.232-5.682.657-3.871-8.796-12.658-14.94-22.884-14.94-10.227 0-19.013 6.144-22.884 14.94a25.048 25.048 0 0 0-5.682-.657 24.88 24.88 0 0 0-14.418 4.583c3.691 7.433 10.198 14.106 19.48 19.939z"
    />
  </svg>
)

export var SL = ({ title, ...rest }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 85.333 512 341.333"
    {...rest}
  >
    {title && <title>{title}</title>}
<path fill="#FFF" d="M0 85.337h512v341.326H0z" />
    <path fill="#6DA544" d="M0 85.337h512v113.775H0z" />
    <path fill="#338AF3" d="M0 312.888h512v113.775H0z" />
  </svg>
)

export var SM = ({ title, ...rest }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 85.333 512 341.333"
    {...rest}
  >
    {title && <title>{title}</title>}
<path fill="#338AF3" d="M0 85.34h512v341.326H0z" />
    <path fill="#FFF" d="M512 85.334v166.69L0 256.175V85.334z" />
    <path
      fill="#6DA544"
      d="M323.744 203.099 256 270.843l-67.744-67.744a81.156 81.156 0 0 0-13.879 45.483v22.261c0 35.744 23.097 66.193 55.148 77.213-4.277 8.385-3.556 18.848 2.712 26.671l24.258-19.439 24.258 19.439c6.342-7.915 7.011-18.534 2.564-26.968 31.614-11.261 54.308-41.485 54.308-76.916v-22.261a81.174 81.174 0 0 0-13.881-45.483z"
    />
    <path
      fill="#FFDA44"
      d="M256 330.206c-32.732 0-59.362-26.63-59.362-59.362v-22.261c0-32.733 26.63-59.363 59.362-59.363s59.362 26.63 59.362 59.362v22.261c0 32.733-26.63 59.363-59.362 59.363z"
    />
    <path
      fill="#338AF3"
      d="M293.101 270.843v-22.261c0-20.458-16.643-37.101-37.101-37.101s-37.101 16.643-37.101 37.101v22.261L256 278.264l37.101-7.421z"
    />
    <path
      fill="#6DA544"
      d="M218.899 270.843c0 20.458 16.643 37.101 37.101 37.101s37.101-16.643 37.101-37.101h-74.202z"
    />
    <path
      fill="#FFDA44"
      d="M300.522 189.22c0-12.295-9.966-22.261-22.261-22.261a22.173 22.173 0 0 0-14.84 5.672v-13.093h7.421v-14.84h-7.421v-7.421h-14.84v7.421h-7.421v14.84h7.421v13.093a22.177 22.177 0 0 0-14.841-5.672c-12.295 0-22.261 9.966-22.261 22.261 0 6.591 2.867 12.512 7.421 16.589v13.093h74.203v-13.093c4.552-4.077 7.419-9.997 7.419-16.589z"
    />
  </svg>
)

export var SN = ({ title, ...rest }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 85.333 512 341.333"
    {...rest}
  >
    {title && <title>{title}</title>}
<path fill="#FFDA44" d="M0 85.331h512v341.326H0z" />
    <path fill="#D80027" d="M330.207 85.331H512v341.337H330.207z" />
    <path
      d="M0 85.331h181.793v341.337H0zm255.999 111.301 14.733 45.347h47.685l-38.576 28.029 14.734 45.348-38.576-28.026-38.577 28.026 14.737-45.348-38.576-28.029h47.681z"
      fill="#496E2D"
    />
  </svg>
)

export var SO = ({ title, ...rest }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 85.333 512 341.333"
    {...rest}
  >
    {title && <title>{title}</title>}
<path fill="#338AF3" d="M0 85.331h512v341.337H0z" />
    <path
      fill="#FFF"
      d="m256 157.273 22.663 69.748H352l-59.332 43.106 22.664 69.749L256 296.769l-59.332 43.107 22.664-69.749L160 227.021h73.337z"
    />
  </svg>
)

export var SR = ({ title, ...rest }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 85.333 512 341.333"
    {...rest}
  >
    {title && <title>{title}</title>}
<path fill="#FFF" d="M0 85.331h512v341.337H0z" />
    <path fill="#A2001D" d="M0 196.636h512v118.728H0z" />
    <path d="M0 352.462h512v74.207H0zM0 85.331h512v74.207H0z" fill="#6DA544" />
    <path
      fill="#FFDA44"
      d="m256.742 218.003 9.43 29.021h30.518L272 264.963l9.431 29.023-24.689-17.937-24.689 17.937 9.431-29.023-24.69-17.939h30.518z"
    />
  </svg>
)

export var SS = ({ title, ...rest }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 85.333 512 341.333"
    {...rest}
  >
    {title && <title>{title}</title>}
<path fill="#FFF" d="M0 85.337h512v341.326H0z" />
    <path fill="#496E2D" d="M0 322.783h512v103.88H0z" />
    <path d="M0 85.337h512v104.515H0z" />
    <path fill="#A2001D" d="M0 210.877h512v89.656H0z" />
    <path fill="#0052B4" d="M256 256.006 0 426.668V85.331z" />
    <path
      fill="#FFDA44"
      d="m73.178 209.188 20.831 29.067 34.084-10.83-21.207 28.795 20.83 29.069-33.939-11.271-21.208 28.794.234-35.762-33.94-11.273 34.083-10.83z"
    />
  </svg>
)

export var ST = ({ title, ...rest }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 85.333 512 341.333"
    {...rest}
  >
    {title && <title>{title}</title>}
<path fill="#FFDA44" d="M0 85.337h512v341.326H0z" />
    <path
      d="M0 85.337h512v113.775H0zm0 227.551h512v113.775H0z"
      fill="#6DA544"
    />
    <path fill="#D80027" d="M256 256.006 0 426.668V85.331z" />
    <path d="m302.049 226.318 7.368 22.674h23.842l-19.288 14.016 7.366 22.674-19.288-14.015-19.287 14.015 7.366-22.674-19.288-14.016h23.842zm74.203 0 7.367 22.674h23.842l-19.288 14.016 7.367 22.674-19.288-14.015-19.288 14.015 7.367-22.674-19.288-14.016h23.842z" />
  </svg>
)

export var SV = ({ title, ...rest }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 85.333 512 341.333"
    {...rest}
  >
    {title && <title>{title}</title>}
<path fill="#FFF" d="M0 85.337h512v341.326H0z" />
    <path
      d="M0 85.337h512v113.775H0zm0 227.551h512v113.775H0z"
      fill="#0052B4"
    />
    <path fill="#FFDA44" d="M228.582 261.936 256 214.447l27.418 47.489z" />
    <path
      fill="#6DA544"
      d="M291.616 277.616 256 295.425l-35.616-17.809v-23.744h71.232z"
    />
    <path
      fill="#FFDA44"
      d="m289.579 216.485-12.592 12.592c5.37 5.372 8.693 12.791 8.693 20.988 0 16.392-13.289 29.68-29.68 29.68-16.392 0-29.68-13.289-29.68-29.68 0-8.195 3.322-15.616 8.693-20.988l-12.592-12.592c-8.594 8.594-13.91 20.466-13.91 33.579 0 26.228 21.261 47.489 47.489 47.489s47.489-21.261 47.489-47.489c0-13.114-5.316-24.987-13.91-33.579z"
    />
  </svg>
)

export var SX = ({ title, ...rest }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 85.333 512 341.333"
    {...rest}
  >
    {title && <title>{title}</title>}
<path fill="#0052B4" d="M0 85.337h512v341.326H0z" />
    <path fill="#D80027" d="M512 85.331v166.69L0 256.173V85.331z" />
    <path fill="#FFF" d="M256 256.006 0 426.668V85.331z" />
    <g fill="#FFDA44">
      <path d="M59.621 256a59.546 59.546 0 0 0-.193 4.57c0 32.821 26.607 59.429 59.429 59.429s59.429-26.607 59.429-59.429c0-1.539-.078-3.061-.193-4.57H59.621z" />
      <circle cx={118.862} cy={210.287} r={18.286} />
    </g>
    <path
      fill="#D80027"
      d="M77.715 205.714v59.429c0 31.494 41.144 41.143 41.144 41.143s41.144-9.649 41.144-41.143v-59.429H77.715z"
    />
    <path
      fill="#338AF3"
      d="M118.877 287.148c-7.632-2.746-22.876-9.767-22.876-22.006v-41.144h45.715v41.144c-.001 12.28-15.244 19.283-22.839 22.006z"
    />
    <path
      fill="#F3F3F3"
      d="M128.001 246.856v-9.142l-9.144-4.571-9.142 4.571v9.142l-4.571 4.573v18.285h27.428v-18.285z"
    />
  </svg>
)

export var SY = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 900 600" {...rest}>
    {title && <title>{title}</title>}
<path d="M0 0h900v600H0z" fill="#0f0f0f" />
    <path d="M0 0h900v400H0z" fill="#fff" />
    <path d="M0 0h900v200H0z" fill="#047a3f" />
    <path
      d="m176.26 375 48.738-150 48.738 150-127.6-92.705h157.72M626.256 375l48.738-150 48.738 150-127.6-92.705h157.72M401.252 375l48.738-150 48.738 150-127.6-92.705h157.72"
      fill="#ce1126"
    />
  </svg>
)

export var SZ = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 900 600" {...rest}>
    {title && <title>{title}</title>}
<path fill="#2B5DEA" d="M0 0h900v600H0V0z" />
    <path fill="#FFDF29" d="M0 100h900v400H0V100z" />
    <path fill="#D70000" d="M0 150h900v300H0V150z" />
    <path
      fill="#FFF"
      d="M450 171.4v257.2c114.3 0 171.4-85.7 214.3-128.6-42.9-42.9-100-128.6-214.3-128.6z"
    />
    <path d="M450 171.4c-100 0-171.4 85.7-214.3 128.6C278.6 342.9 350 428.6 450 428.6V171.4z" />
    <path fill="#FFF" d="M346.3 254.3h21v91.3h-21zm51.9 0h21v91.3h-21z" />
    <path d="M477.8 254.3h21v91.3h-21zm51.9 0h21v91.3h-21z" />
  </svg>
)

export var TA = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#012169" d="M0 0h513v342H0z" />
    <path fill="#012169" d="M0 0h256.5v171H0z" />
    <g fill="#FFF">
      <path d="M256.5 0v30.6l-45.3 25.2h45.3v59.4h-59.2l59.2 32.9V171h-26.7l-73.7-40.9V171h-55.7v-48.7L12.8 171H0v-30.6l45.3-25.2H0V55.8h59.2L0 22.9V0h26.7l73.7 40.9V0h55.7v48.7L243.7 0z" />
      <path d="M156.1 115.2 256.5 171v-15.8l-72-40zm-55.7-59.4L0 0v15.8l72 40z" />
    </g>
    <g fill="#D80027">
      <path d="M144.3 0h-32.1v69.5H0v32h112.2V171h32.1v-69.5h112.2v-32H144.3z" />
      <path d="M156.1 115.2 256.5 171v-15.8l-72-40zm-84.1 0-72 40V171l100.4-55.8zm28.4-59.4L0 0v15.8l72 40zm84.1 0 72-40V0L156.1 55.8z" />
    </g>
    <path
      fill="#1799f8"
      d="M448.9 169.5c0 9.6-.3 29.6-1.4 39.2-4.1 34.9-23.5 68.8-62.1 85.9-45.3-17.9-60.8-51-64.9-85.9-1.1-9.6-1.5-19.4-1.5-29l.3-47.1h129.2l.4 36.9z"
    />
    <path
      fill="#FFF"
      d="M447.5 208.7c-.2 1.6-.4 3.3-.6 4.9-4.8 33.1-22.9 65.4-61.5 81-43.2-17-59.4-47.9-64.2-81-.2-1.6-.4-3.2-.6-4.9"
    />
    <path fill="#1799f8" d="m385.4 251.7-22.9-43h45.8z" />
    <path fill="#FFF" d="m385.4 165.8-22.9 42.9h45.8z" />
    <ellipse fill="#dcb072" cx={474.8} cy={236.8} rx={16.8} ry={43.3} />
    <ellipse fill="#dcb072" cx={295.3} cy={236.8} rx={16.8} ry={43.3} />
    <path
      fill="#FFF"
      d="m385.4 31.5-33.4 44h68.5zM315.5 280s33.8 29.5 69.9 29.5 67.1-29.5 67.1-29.5l8.5 14.6S439.2 326 385.4 326 307 294.6 307 294.6l8.5-14.6z"
    />
    <ellipse fill="#A5A5A5" cx={386.3} cy={104.3} rx={34.3} ry={23.3} />
  </svg>
)

export var TC = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#012169" d="M0 0h513v342H0z" />
    <path
      fill="#FFDA44"
      stroke="#fff"
      strokeWidth={4}
      d="M332.1 106.7v78.2c0 38.1 51.9 49.8 51.9 49.8s51.9-11.7 51.9-49.8v-78.2H332.1z"
    />
    <path
      fill="#fcad56"
      d="M376.6 135.1c0 7.9-6.6 28.4-14.8 28.4S347 142.9 347 135.1c0-7.9 14.8-14.2 14.8-14.2s14.8 6.4 14.8 14.2z"
    />
    <path
      fill="#9e540a"
      d="M416 150.6c2.4-5.6 4.3-13.8 4.3-17.9 0-6.5-8.9-11.9-8.9-11.9s-8.9 5.3-8.9 11.9c0 4.1 1.9 12.3 4.3 17.9l-5.1 11.1c3 1.2 6.3 1.8 9.8 1.8 3.5 0 6.8-.7 9.8-1.8l-5.3-11.1z"
    />
    <path
      fill="#009e49"
      d="M372.9 184.9s-7.4 14.2-7.4 28.4h37.1c0-14.2-7.4-28.4-7.4-28.4l-11.1-7.1-11.2 7.1z"
    />
    <path
      fill="#ce1126"
      d="M395.1 184.9v-3.6c0-5.9-5-10.7-11.1-10.7s-11.1 4.8-11.1 10.7v3.6h22.2z"
    />
    <path fill="#012169" d="M0 0h256.5v171H0z" />
    <g fill="#FFF">
      <path d="M256.5 0v30.6l-45.3 25.2h45.3v59.4h-59.2l59.2 32.9V171h-26.7l-73.7-40.9V171h-55.7v-48.7L12.8 171H0v-30.6l45.3-25.2H0V55.8h59.2L0 22.9V0h26.7l73.7 40.9V0h55.7v48.7L243.7 0z" />
      <path d="M156.1 115.2 256.5 171v-15.8l-72-40zm-55.7-59.4L0 0v15.8l72 40z" />
    </g>
    <g fill="#D80027">
      <path d="M144.3 0h-32.1v69.5H0v32h112.2V171h32.1v-69.5h112.2v-32H144.3z" />
      <path d="M156.1 115.2 256.5 171v-15.8l-72-40zm-84.1 0-72 40V171l100.4-55.8zm28.4-59.4L0 0v15.8l72 40zm84.1 0 72-40V0L156.1 55.8z" />
    </g>
  </svg>
)

export var TD = ({ title, ...rest }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 85.333 512 341.333"
    {...rest}
  >
    {title && <title>{title}</title>}
<path fill="#FFDA44" d="M0 85.331h512v341.337H0z" />
    <path fill="#0052B4" d="M0 85.331h170.663v341.337H0z" />
    <path fill="#D80027" d="M341.337 85.331H512v341.337H341.337z" />
  </svg>
)

export var TF = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22.5 15" {...rest}>
    {title && <title>{title}</title>}
<path fill="#FFF" d="M0 0h21v15H0V0z" />
    <path fill="#0A388A" d="M0 0h22.5v15H0V0z" />
    <path fill="#FFF" d="M0 0h11.3v7.5H0V0z" />
    <path fill="#D80027" d="M7.1 0h3.6v7H7.1V0z" />
    <path fill="#0A388A" d="M0 0h3.6v7H0V0z" />
    <path
      fill="#FFF"
      d="M3.6 0h3.6v7H3.6V0zm10.9 6h5L19 7h-1.5v.5h1l-.5 1h-.5V10h-1V7H15l-.5-1zm4 2.5 1 1.5h-2l1-1.5zm-3 0 1 1.5h-2l1-1.5zm1.5 3L16 10h2l-1 1.5zM20 8c-.3 0-.5-.2-.5-.5s.2-.5.5-.5.5.2.5.5-.2.5-.5.5zm-6 0c-.3 0-.5-.2-.5-.5s.2-.5.5-.5.5.2.5.5-.2.5-.5.5zm1 4c-.3 0-.5-.2-.5-.5s.2-.5.5-.5.5.2.5.5-.2.5-.5.5zm4 0c-.3 0-.5-.2-.5-.5s.2-.5.5-.5.5.2.5.5-.2.5-.5.5zm-2 1c-.3 0-.5-.2-.5-.5s.2-.5.5-.5.5.2.5.5-.2.5-.5.5z"
    />
  </svg>
)

export var TG = ({ title, ...rest }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 85.333 512 341.333"
    {...rest}
  >
    {title && <title>{title}</title>}
<path fill="#FFDA44" d="M0 85.337h512v341.326H0z" />
    <path
      d="M0 85.337h512V153.6H0zM0 358.4h512v68.263H0zm0-136.537h512v68.263H0z"
      fill="#496E2D"
    />
    <path fill="#D80027" d="M0 85.337h204.054v204.054H0z" />
    <path
      fill="#FFF"
      d="m102.026 133.938 13.26 40.812h42.916l-34.718 25.226 13.26 40.814-34.718-25.224-34.719 25.224 13.263-40.814-34.718-25.226h42.913z"
    />
  </svg>
)

export var TH = ({ title, ...rest }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 85.333 512 341.333"
    {...rest}
  >
    {title && <title>{title}</title>}
<path fill="#FFF" d="M0 85.334h512V426.66H0z" />
    <path fill="#0052B4" d="M0 194.056h512v123.882H0z" />
    <path d="M0 85.334h512v54.522H0zm0 286.809h512v54.522H0z" fill="#D80027" />
  </svg>
)

export var TJ = ({ title, ...rest }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 85.333 512 341.333"
    {...rest}
  >
    {title && <title>{title}</title>}
<path fill="#FFF" d="M0 85.337h512v341.326H0z" />
    <path fill="#D80027" d="M0 85.337h512v113.775H0z" />
    <path fill="#6DA544" d="M0 312.888h512v113.775H0z" />
    <path
      d="M226.318 300.522h59.364v-25.23l-11.873 5.937L256 263.421l-17.809 17.808-11.873-5.937zm-33.963-29.682 2.763 8.504h8.94l-7.233 5.255 2.763 8.502-7.233-5.255-7.234 5.255 2.763-8.502-7.233-5.255h8.94zm8.566-29.68 2.763 8.502h8.94l-7.233 5.255 2.763 8.504-7.233-5.256-7.234 5.256 2.763-8.504-7.233-5.255h8.94zm24.488-22.261 2.763 8.502h8.94l-7.233 5.255 2.763 8.504-7.233-5.256-7.234 5.256 2.763-8.504-7.233-5.255h8.94zm94.236 51.941-2.763 8.504h-8.94l7.233 5.255-2.763 8.502 7.233-5.255 7.234 5.255-2.763-8.502 7.233-5.255h-8.94zm-8.566-29.68-2.763 8.502h-8.94l7.233 5.255-2.763 8.504 7.233-5.256 7.234 5.256-2.763-8.504 7.233-5.255h-8.94zm-24.488-22.261-2.763 8.502h-8.94l7.233 5.255-2.763 8.504 7.233-5.256 7.234 5.256-2.763-8.504 7.233-5.255h-8.94zM256 207.767l2.763 8.503h8.941l-7.234 5.256 2.763 8.502-7.233-5.254-7.233 5.254 2.763-8.502-7.234-5.256h8.941z"
      fill="#FFDA44"
    />
  </svg>
)

export var TK = ({ title, ...rest }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 85.333 512 341.333"
    {...rest}
  >
    {title && <title>{title}</title>}
<path fill="#0052B4" d="M0 85.337h512v341.326H0z" />
    <path
      d="m210.715 174.377 3.684 11.338h11.919l-9.643 7.006 3.684 11.337-9.644-7.007-9.644 7.007 3.684-11.337-9.645-7.006h11.921zm-93.899 107.594 4.605 14.172h14.9l-12.055 8.757 4.606 14.173-12.056-8.76-12.055 8.76 4.604-14.173-12.054-8.757h14.899zm27.88-162.292 4.604 14.172h14.901l-12.056 8.758 4.606 14.171-12.055-8.759-12.056 8.759 4.606-14.171-12.055-8.758h14.9zm-75.157 55.652 4.604 14.172h14.9l-12.055 8.758 4.606 14.171-12.055-8.758-12.056 8.758 4.606-14.171-12.055-8.758h14.9z"
      fill="#FFF"
    />
    <path
      d="M483.386 354.503H117.801s109.234-88.562 310.593-220.938c.001 0-88.443 128.935 54.992 220.938zm-365.585 11.586c-11.177 0-11.195 17.37 0 17.37h365.585c11.177 0 11.195-17.37 0-17.37H117.801z"
      fill="#FFDA44"
    />
  </svg>
)

export var TL = ({ title, ...rest }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 85.333 512 341.333"
    {...rest}
  >
    {title && <title>{title}</title>}
<path fill="#D80027" d="M0 85.337h512v341.326H0z" />
    <path
      fill="#FFDA44"
      d="M256 256 0 90.691v44.242L155.826 256 0 377.067v44.242z"
    />
    <path d="M0 90.691v330.618L189.217 256z" />
    <path
      fill="#FFF"
      d="m44.184 213.36 24.912 23.577 30.121-16.41-14.723 30.98 24.911 23.575-34.012-4.43L60.67 301.63l-6.296-33.716-34.012-4.43 30.119-16.408z"
    />
  </svg>
)

export var TM = ({ title, ...rest }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 85.333 512 341.333"
    {...rest}
  >
    {title && <title>{title}</title>}
<path fill="#496E2D" d="M0 85.337h512v341.326H0z" />
    <g fill="#FFF">
      <path d="M357.208 183.679c8.397-23.404-1.036-48.858-21.281-61.536a52.131 52.131 0 0 1 10.884 2.621c27.002 9.688 41.038 39.428 31.35 66.431s-39.428 41.038-66.431 31.35a52.182 52.182 0 0 1-10.069-4.895c23.686 3.084 47.15-10.566 55.547-33.971zm-46.571-67.95-7.297 9.427-11.22-4.026 6.712 9.852-7.296 9.427 11.443-3.338 6.712 9.852.361-11.914 11.444-3.339-11.221-4.025z" />
      <path d="m330.338 146.448-7.296 9.427-11.221-4.026 6.712 9.852-7.296 9.427 11.443-3.339 6.712 9.853.36-11.915 11.445-3.34-11.221-4.024zM275.9 126.916l-7.296 9.427-11.219-4.024 6.711 9.851-7.296 9.426 11.443-3.338 6.712 9.852.361-11.915 11.444-3.337-11.221-4.027zm-.799 35.189-7.296 9.427-11.221-4.026 6.712 9.852-7.296 9.427 11.444-3.338 6.711 9.852.362-11.915 11.443-3.338-11.22-4.026zm33.484 12.013-7.296 9.427-11.22-4.026 6.712 9.853-7.297 9.426 11.444-3.338 6.712 9.852.36-11.915 11.443-3.338-11.219-4.025z" />
    </g>
    <path fill="#D80027" d="M83.478 85.337h89.043v341.326H83.478z" />
    <path
      fill="#FFF"
      d="m117.458 175.191-14.908-11.105v-15.705l14.908-11.105h21.084l14.908 11.105v15.705l-14.908 11.105z"
    />
    <path
      d="M128 137.276h-10.542l-14.908 11.105v7.678H128zm0 37.915h10.542l14.908-11.105v-8.012H128z"
      fill="#FF9811"
    />
    <path
      fill="#FFF"
      d="m117.458 374.725-14.908-11.106v-15.704l14.908-11.105h21.084l14.908 11.105v15.704l-14.908 11.106z"
    />
    <path
      d="M128 336.81h-10.542l-14.908 11.105v7.678H128zm0 37.915h10.542l14.908-11.106v-8.011H128z"
      fill="#FF9811"
    />
    <path
      d="m117.458 274.957-14.908-11.105v-15.703l14.908-11.106h21.084l14.908 11.106v15.703l-14.908 11.105zm36.513 24.434h-6.493v-6.493h-11.411l-8.068-8.068-8.067 8.068h-11.41v6.493h-6.493v12.986h6.493v6.492h11.41l8.068 8.069 8.068-8.069h11.41v-6.492h6.493zm0-99.768h-6.493v-6.492h-11.411l-8.068-8.069-8.067 8.069h-11.41v6.492h-6.493v12.986h6.493v6.492h11.41l8.068 8.07 8.068-8.07h11.41v-6.492h6.493z"
      fill="#496E2D"
    />
    <g fill="#D80027">
      <path d="M120.576 248.576h14.84v14.84h-14.84z" />
      <circle cx={128} cy={206.113} r={7.421} />
      <circle cx={128} cy={305.887} r={7.421} />
    </g>
  </svg>
)

export var TN = ({ title, ...rest }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 85.333 512 341.333"
    {...rest}
  >
    {title && <title>{title}</title>}
<path fill="#D80027" d="M0 85.331h512v341.337H0z" />
    <circle fill="#FFF" cx={256} cy={255.994} r={96} />
    <g fill="#D80027">
      <path d="m267.826 219.291 16.47 22.695 26.673-8.649-16.496 22.676 16.468 22.695-26.664-8.681-16.495 22.676.017-28.04-26.664-8.682 26.674-8.648z" />
      <path d="M277.818 312.724c-31.33 0-56.727-25.397-56.727-56.727s25.397-56.727 56.727-56.727c9.769 0 18.96 2.47 26.985 6.819-12.589-12.31-29.804-19.909-48.803-19.909-38.558 0-69.818 31.259-69.818 69.818s31.26 69.818 69.818 69.818c18.999 0 36.215-7.599 48.803-19.909-8.026 4.347-17.216 6.817-26.985 6.817z" />
    </g>
  </svg>
)

export var TO = ({ title, ...rest }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 85.333 512 341.333"
    {...rest}
  >
    {title && <title>{title}</title>}
<path fill="#D80027" d="M0 85.331h512v341.337H0z" />
    <path fill="#FFF" d="M0 85.331h256v170.663H0z" />
    <path
      fill="#D80027"
      d="M141.357 157.303V130.59h-26.714v26.713H87.93v26.713h26.713v26.713h26.714v-26.713h26.713v-26.713z"
    />
  </svg>
)

export var TR = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#E30A17" d="M0 0h513v342H0z" />
    <path
      fill="#FFF"
      d="M259.7 118.6c-13.1-9.5-29-14.6-45.3-14.5-40.8 0-73.8 30.8-73.8 68.9s33.1 68.9 73.8 68.9c17.1 0 32.9-5.4 45.3-14.5-30 38.6-85.7 45.6-124.3 15.5s-45.6-85.7-15.5-124.3 85.7-45.6 124.3-15.5c5.8 4.5 11 9.8 15.5 15.5zm39.9 65.8-18.1 21.9 1.2-28.4-26.4-10.4 27.3-7.6 1.8-28.3 15.6 23.7 27.5-7.1-17.5 22 15.3 23.9-26.7-9.7z"
    />
  </svg>
)

export var TT = ({ title, ...rest }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 85.333 512 341.333"
    {...rest}
  >
    {title && <title>{title}</title>}
<path fill="#D80027" d="M0 85.337h512v341.326H0z" />
    <path
      fill="#FFF"
      d="m6.066 85.337 207.961 212.636 131.584 128.69h160.323L297.973 214.027 166.389 85.337z"
    />
    <path d="M43.364 85.337 384.69 426.663h83.946L127.31 85.337z" />
  </svg>
)

export var TV = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#00B2EE" d="M0 171h256.5V0H513v342H0V171z" />
    <path
      d="m196.8 274.1 16.8 51.6-43.9-31.9H224l-43.9 31.9 16.7-51.6zm205.8-80.3 16.8 51.6-43.9-31.9h54.3l-43.9 31.9 16.7-51.6zm60.7-44.7 16.8 51.6-43.9-31.9h54.3l-43.9 31.9 16.7-51.6zm0-127.8L480.1 73l-44-32h54.3l-43.9 32 16.8-51.7zm-53 53.7 16.8 51.6-43.9-31.9h54.3l-43.9 31.9L410.3 75zm-77.4 32 16.8 51.6-43.9-31.9H360l-43.9 31.9 16.8-51.6zM350 245.4l16.8 51.6-43.9-31.9h54.3L333.3 297l16.7-51.6zm-71.8-56.2 16.8 51.6-44-31.8h54.3l-43.9 31.9 16.8-51.7zm0 75.3 16.8 51.6-44-31.9h54.3l-43.9 31.9 16.8-51.6z"
      fill="#FFDA44"
    />
    <path fill="#012169" d="M0 0h256.5v171H0z" />
    <g fill="#FFF">
      <path d="M256.5 0v30.6l-45.3 25.2h45.3v59.4h-59.2l59.2 32.9V171h-26.7l-73.7-40.9V171h-55.7v-48.7L12.8 171H0v-30.6l45.3-25.2H0V55.8h59.2L0 22.9V0h26.7l73.7 40.9V0h55.7v48.7L243.7 0z" />
      <path d="M156.1 115.2 256.5 171v-15.8l-72-40zm-55.7-59.4L0 0v15.8l72 40z" />
    </g>
    <g fill="#D80027">
      <path d="M144.3 0h-32.1v69.5H0v32h112.2V171h32.1v-69.5h112.2v-32H144.3z" />
      <path d="M156.1 115.2 256.5 171v-15.8l-72-40zm-84.1 0-72 40V171l100.4-55.8zm28.4-59.4L0 0v15.8l72 40zm84.1 0 72-40V0L156.1 55.8z" />
    </g>
  </svg>
)

export var TW = ({ title, ...rest }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 85.333 512 341.333"
    {...rest}
  >
    {title && <title>{title}</title>}
<path fill="#D80027" d="M0 85.337h512v341.326H0z" />
    <path fill="#0052B4" d="M0 85.337h256V256H0z" />
    <path
      fill="#FFF"
      d="M186.435 170.669 162.558 181.9l12.714 23.125-25.927-4.961-3.286 26.192L128 206.993l-18.06 19.263-3.285-26.192-25.927 4.96 12.714-23.125-23.877-11.23 23.877-11.231-12.714-23.125 25.927 4.96 3.286-26.192L128 134.344l18.06-19.263 3.285 26.192 25.928-4.96-12.715 23.125z"
    />
    <circle fill="#0052B4" cx={128} cy={170.674} r={29.006} />
    <path
      fill="#FFF"
      d="M128 190.06c-10.692 0-19.391-8.7-19.391-19.391 0-10.692 8.7-19.391 19.391-19.391 10.692 0 19.391 8.7 19.391 19.391 0 10.691-8.699 19.391-19.391 19.391z"
    />
  </svg>
)

export var TZ = ({ title, ...rest }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 85.333 512 341.333"
    {...rest}
  >
    {title && <title>{title}</title>}
<path fill="#338AF3" d="M0 85.337h512v341.326H0z" />
    <path fill="#6DA544" d="M0 426.663V85.337h512" />
    <path
      fill="#FFDA44"
      d="M512 152.222V85.337H411.67L0 359.778v66.885h100.33z"
    />
    <path d="M512 85.337v40.125L60.193 426.663H0v-40.125L451.807 85.337z" />
  </svg>
)

export var UA = ({ title, ...rest }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 85.333 512 341.333"
    {...rest}
  >
    {title && <title>{title}</title>}
<path fill="#FFDA44" d="M0 85.337h512v341.326H0z" />
    <path fill="#338AF3" d="M0 85.337h512V256H0z" />
  </svg>
)

export var UG = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 341.3" {...rest}>
    {title && <title>{title}</title>}
<path fill="#232323" d="M0 0h512v341.3H0z" />
    <path fill="#FFDA44" d="M0 56.9h512v56.9H0z" />
    <path fill="#D32300" d="M0 113.8h512v56.9H0z" />
    <path fill="#FFDA44" d="M0 227.6h512v56.9H0z" />
    <path fill="#D32300" d="M0 284.4h512v56.9H0z" />
    <circle fill="#FFF" cx={256} cy={170.7} r={80.7} />
    <path d="M234.5 127.5c.9-1.4-19.6-2-19.6-2 1.7-2.5 18.4-10.5 18.4-10.5s-.9-6 2.7-9.8l-4.5-9.8s7-3.4 18.4-3.4 19.9 7 21 13.1l-6.4 3.4c-.1 4.7 1.7 11.6-4.3 17.3-5.9 5.7-8.3 6.9-8.5 18.8 0 3.9 2.3 8.2 8.8 11.7 17.4 9.3 38.6 28.2 44.6 33.9 6.1 5.7 5.1 19.2 2.6 25.2s-12.1 14.3-14.3 13.6c-2.2-.6 1.2-9.2-3.5-11.6 0 0-8.9-7.6-16.8.6s-.2 25.2 3.9 28c4.1 2.8 1.7 5-1.9 5H247c-3.8 0-5.4-2.3-1.9-5 7.6-3.8 12.4-15.3 7.4-20.3-4.9-4.9-18.3 1.5-21.5 6.3-2.8 2.8-8.8 3.6-12.9-1.4s-4.1-10.4-1.1-12.5c7-4.8 0 0 .1-.1 0 0 11.9-8.6 29.9-9 3.9 0 4.8-2.2 2.2-4.8 0 0-30.9-27.4-28.1-44.2 3-18.3 20-26.3 13.4-32.5-1.3-1.8 0 0 0 0z" />
  </svg>
)

export var UM = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#FFF" d="M0 0h513v342H0z" />
    <path
      d="M0 0h513v26.3H0zm0 52.6h513v26.3H0zm0 52.6h513v26.3H0zm0 52.6h513v26.3H0zm0 52.7h513v26.3H0zm0 52.6h513v26.3H0zm0 52.6h513V342H0z"
      fill="#D80027"
    />
    <path fill="#2E52B2" d="M0 0h256.5v184.1H0z" />
    <path
      d="m47.8 138.9-4-12.8-4.4 12.8H26.2l10.7 7.7-4 12.8 10.9-7.9 10.6 7.9-4.1-12.8 10.9-7.7zm56.3 0-4.1-12.8-4.2 12.8H82.6l10.7 7.7-4 12.8 10.7-7.9 10.8 7.9-4-12.8 10.7-7.7zm56.5 0-4.3-12.8-4 12.8h-13.5l11 7.7-4.2 12.8 10.7-7.9 11 7.9-4.2-12.8 10.7-7.7zm56.2 0-4-12.8-4.2 12.8h-13.3l10.8 7.7-4 12.8 10.7-7.9 10.8 7.9-4.3-12.8 11-7.7zM100 75.3l-4.2 12.8H82.6L93.3 96l-4 12.6 10.7-7.8 10.8 7.8-4-12.6 10.7-7.9h-13.4zm-56.2 0-4.4 12.8H26.2L36.9 96l-4 12.6 10.9-7.8 10.6 7.8L50.3 96l10.9-7.9H47.8zm112.5 0-4 12.8h-13.5l11 7.9-4.2 12.6 10.7-7.8 11 7.8-4.2-12.6 10.7-7.9h-13.2zm56.5 0-4.2 12.8h-13.3l10.8 7.9-4 12.6 10.7-7.8 10.8 7.8-4.3-12.6 11-7.9h-13.5zm-169-50.6-4.4 12.6H26.2l10.7 7.9-4 12.7L43.8 50l10.6 7.9-4.1-12.7 10.9-7.9H47.8zm56.2 0-4.2 12.6H82.6l10.7 7.9-4 12.7L100 50l10.8 7.9-4-12.7 10.7-7.9h-13.4zm56.3 0-4 12.6h-13.5l11 7.9-4.2 12.7 10.7-7.9 11 7.9-4.2-12.7 10.7-7.9h-13.2zm56.5 0-4.2 12.6h-13.3l10.8 7.9-4 12.7 10.7-7.9 10.8 7.9-4.3-12.7 11-7.9h-13.5z"
      fill="#FFF"
    />
  </svg>
)

export var US = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#FFF" d="M0 0h513v342H0z" />
    <path
      d="M0 0h513v26.3H0zm0 52.6h513v26.3H0zm0 52.6h513v26.3H0zm0 52.6h513v26.3H0zm0 52.7h513v26.3H0zm0 52.6h513v26.3H0zm0 52.6h513V342H0z"
      fill="#D80027"
    />
    <path fill="#2E52B2" d="M0 0h256.5v184.1H0z" />
    <path
      d="m47.8 138.9-4-12.8-4.4 12.8H26.2l10.7 7.7-4 12.8 10.9-7.9 10.6 7.9-4.1-12.8 10.9-7.7zm56.3 0-4.1-12.8-4.2 12.8H82.6l10.7 7.7-4 12.8 10.7-7.9 10.8 7.9-4-12.8 10.7-7.7zm56.5 0-4.3-12.8-4 12.8h-13.5l11 7.7-4.2 12.8 10.7-7.9 11 7.9-4.2-12.8 10.7-7.7zm56.2 0-4-12.8-4.2 12.8h-13.3l10.8 7.7-4 12.8 10.7-7.9 10.8 7.9-4.3-12.8 11-7.7zM100 75.3l-4.2 12.8H82.6L93.3 96l-4 12.6 10.7-7.8 10.8 7.8-4-12.6 10.7-7.9h-13.4zm-56.2 0-4.4 12.8H26.2L36.9 96l-4 12.6 10.9-7.8 10.6 7.8L50.3 96l10.9-7.9H47.8zm112.5 0-4 12.8h-13.5l11 7.9-4.2 12.6 10.7-7.8 11 7.8-4.2-12.6 10.7-7.9h-13.2zm56.5 0-4.2 12.8h-13.3l10.8 7.9-4 12.6 10.7-7.8 10.8 7.8-4.3-12.6 11-7.9h-13.5zm-169-50.6-4.4 12.6H26.2l10.7 7.9-4 12.7L43.8 50l10.6 7.9-4.1-12.7 10.9-7.9H47.8zm56.2 0-4.2 12.6H82.6l10.7 7.9-4 12.7L100 50l10.8 7.9-4-12.7 10.7-7.9h-13.4zm56.3 0-4 12.6h-13.5l11 7.9-4.2 12.7 10.7-7.9 11 7.9-4.2-12.7 10.7-7.9h-13.2zm56.5 0-4.2 12.6h-13.3l10.8 7.9-4 12.7 10.7-7.9 10.8 7.9-4.3-12.7 11-7.9h-13.5z"
      fill="#FFF"
    />
  </svg>
)

export var UY = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#FFF" d="M0 0h513v342H0z" />
    <path
      d="M0 38h513v38H0zm0 76h513v38H0zm0 76h513v38H0zm0 76h513v38H0z"
      fill="#0038a8"
    />
    <path fill="#FFF" d="M0 0h256.5v190H0z" />
    <path
      fill="#FED443"
      d="m128.3 138.7-15.1 22.6-3.8-26.9L86 148.2l8.2-25.9-27.2 2.2 18.6-19.8L60.3 95l25.4-9.7L67 65.5l27.1 2.3-8.2-25.9 23.4 13.8 3.9-26.9 15.1 22.6 15.1-22.6 3.8 26.9 23.4-13.8-8.2 25.9 27.1-2.2-18.6 19.8 25.4 9.7-25.4 9.7 18.6 19.8-27.1-2.2 8.2 25.9-23.4-13.8-3.9 26.9-15-22.7zm0-.5c23.9.9 44-17.6 44.9-41.5.9-23.9-17.6-44-41.5-44.9h-3.4c-23.9.8-42.6 20.8-41.8 44.6.6 22.8 19 41.1 41.8 41.8zm0-10.6c-18.8 0-34-15.2-34-34s15.2-34 34-34 34 15.2 34 34-15.3 34-34 34z"
    />
  </svg>
)

export var UZ = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#3081f7" d="M0 0h513v108H0z" />
    <path fill="#ee162e" d="M0 108h513v9H0z" />
    <path fill="#FFF" d="M0 117h513v108H0z" />
    <path fill="#ee162e" d="M0 225h513v9H0z" />
    <path fill="#308738" d="M0 233h513v108H0z" />
    <path
      d="M53.5 54c0-23.1 16.4-35 34.3-38.9-2.7-.6-5.6-.9-8.5-.9-22 0-39.8 17.8-39.8 39.8s17.8 39.8 39.8 39.8c2.9 0 5.8-.3 8.5-.9C69.9 89 53.5 77.1 53.5 54zm57.9 21.3 1.8 5.9h6.2l-5 3.6 1.9 5.8-4.9-3.6-5 3.6 1.9-5.8-4.9-3.6h6.1zm27.8 0 1.9 5.9h6.1l-5 3.6 1.9 5.8-4.9-3.6-5 3.6 1.9-5.8-4.9-3.6h6.1zm27.8 0 1.9 5.9h6.1l-4.9 3.6 1.9 5.8-5-3.6-4.9 3.6 1.9-5.8-5-3.6h6.1zm27.9 0 1.9 5.9h6.1l-5 3.6 1.9 5.8-4.9-3.6-5 3.6 1.9-5.8-4.9-3.6h6.1zm27.8 0 1.9 5.9h6.1l-4.9 3.6 1.9 5.8-5-3.6-4.9 3.6 1.9-5.8-5-3.6h6.1zm-83.5-28.9 1.9 5.8h6.1l-5 3.6 1.9 5.8-4.9-3.6-5 3.6 1.9-5.8-4.9-3.6h6.1zm27.8 0 1.9 5.8h6.1l-4.9 3.6 1.9 5.8-5-3.6-4.9 3.6 1.9-5.8-5-3.6h6.1zm27.9 0 1.9 5.8h6.1l-5 3.6 1.9 5.8-4.9-3.6-5 3.6 1.9-5.8-4.9-3.6h6.1zm27.8 0 1.9 5.8h6.1l-4.9 3.6 1.9 5.8-5-3.6-4.9 3.6 1.9-5.8-5-3.6h6.1zm-55.7-29 1.9 5.8h6.1l-4.9 3.6 1.9 5.9-5-3.6-4.9 3.6 1.9-5.9-5-3.6h6.1zm27.9 0 1.9 5.8h6.1l-5 3.6 1.9 5.9-4.9-3.6-5 3.6 1.9-5.9-4.9-3.6h6.1zm27.8 0 1.9 5.8h6.1l-4.9 3.6 1.9 5.9-5-3.6-4.9 3.6 1.9-5.9-5-3.6h6.1z"
      fill="#FFF"
    />
  </svg>
)

export var VA = ({ title, ...rest }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 85.333 512 341.333"
    {...rest}
  >
    {title && <title>{title}</title>}
<path fill="#FFDA44" d="M0 85.331h512v341.326H0z" />
    <path fill="#FFF" d="M256 85.331h256v341.337H256z" />
    <path
      fill="#ACABB1"
      d="m321.353 233.837 32.073 42.43c-5.053 7.651-5.026 17.961.817 25.692 7.414 9.807 21.374 11.748 31.182 4.335 9.807-7.414 11.748-21.374 4.334-31.182-5.843-7.731-15.756-10.568-24.495-7.795l-49.988-66.129-11.838 8.949-17.759 13.424 17.899 23.677 17.775-13.401zm46.175 48.78a7.421 7.421 0 1 1 8.95 11.84 7.421 7.421 0 0 1-8.95-11.84z"
    />
    <path
      fill="#FFDA44"
      d="m376.367 247.24 17.899-23.677-17.759-13.424-11.838-8.949-49.988 66.129c-8.74-2.775-18.651.063-24.495 7.795-7.414 9.808-5.473 23.768 4.334 31.182 9.808 7.414 23.768 5.473 31.182-4.335 5.845-7.731 5.871-18.041.817-25.692l32.073-42.43 17.775 13.401zm-62.504 45.771a7.42 7.42 0 1 1-11.84-8.95 7.42 7.42 0 0 1 11.84 8.95z"
    />
  </svg>
)

export var VC = ({ title, ...rest }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 85.333 512 341.333"
    {...rest}
  >
    {title && <title>{title}</title>}
<path fill="#FFDA44" d="M0 85.331h512v341.337H0z" />
    <path fill="#338AF3" d="M0 85.331h170.663v341.337H0z" />
    <path
      d="M341.337 85.331H512v341.337H341.337zM214.261 283.82l-33.393-50.086 33.392-50.087 33.392 50.087zm83.478 0-33.391-50.086 33.391-50.087 33.393 50.087zM256 350.603l-33.391-50.087L256 250.429l33.391 50.087z"
      fill="#6DA544"
    />
  </svg>
)

export var VE = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22.5 15" {...rest}>
    {title && <title>{title}</title>}
<path fill="#FFCE00" d="M0 0h22.5v5H0z" />
    <path fill="#203899" d="M0 5h22.5v5H0z" />
    <path fill="#D82B2B" d="M0 10h22.5v5H0z" />
    <path
      fill="#FFF"
      d="m12.13 5.38.14.46.45.14-.39.27.01.48-.38-.29-.45.15.15-.44-.28-.38h.47zm-1.77 0 .27.39h.47l-.28.38.15.45-.45-.16-.38.28.01-.47-.39-.28.45-.13zm3.44.56-.01.48.39.27-.46.14-.14.45-.27-.38h-.48l.29-.38-.15-.45.45.16zm-5.11.02.4.27.44-.18-.13.46.3.36-.47.02-.26.4-.16-.44-.46-.12.37-.3zm6.55 1.17-.2.44.25.4-.47-.05-.31.36-.1-.46-.43-.18.41-.24.03-.47.35.31zm.19 1.12.21.43.47.07-.34.33.08.46-.42-.22-.42.22.08-.46-.34-.33.47-.07zM7 8.2l.21.43.47.06-.34.33.08.47L7 9.27l-.42.22.08-.47-.34-.33.47-.06zm.31-1.15.45.14.38-.29v.48l.39.26-.45.15-.13.46-.28-.38-.47.01.27-.38z"
    />
  </svg>
)

export var VG = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#012169" d="M0 0h513v342H0z" />
    <path
      fill="#ffc72c"
      d="m384.8 174.7-46.2 46.2c8.7 16.7 26.1 28.1 46.2 28.1s37.6-11.4 46.2-28.1l-46.2-46.2z"
    />
    <path
      fill="#006129"
      stroke="#fff"
      strokeWidth={3}
      d="M332.7 93v81.8c0 39.8 52 52 52 52s52-12.2 52-52V93h-104z"
    />
    <path fill="#FFF" d="M373.6 130.1h22.3v59.5h-22.3z" />
    <circle fill="#9c4c00" cx={384.8} cy={130.1} r={11.2} />
    <path
      d="M347.6 107.8h14.9v14.9h-14.9zm0 33.5h14.9v14.9h-14.9zm0 33.4h14.9v14.9h-14.9zm59.5-66.9H422v14.9h-14.9zm0 33.5H422v14.9h-14.9zm0 33.4H422v14.9h-14.9z"
      fill="#ffc72c"
    />
    <path fill="#012169" d="M0 0h256.5v171H0z" />
    <g fill="#FFF">
      <path d="M256.5 0v30.6l-45.3 25.2h45.3v59.4h-59.2l59.2 32.9V171h-26.7l-73.7-40.9V171h-55.7v-48.7L12.8 171H0v-30.6l45.3-25.2H0V55.8h59.2L0 22.9V0h26.7l73.7 40.9V0h55.7v48.7L243.7 0z" />
      <path d="M156.1 115.2 256.5 171v-15.8l-72-40zm-55.7-59.4L0 0v15.8l72 40z" />
    </g>
    <g fill="#D80027">
      <path d="M144.3 0h-32.1v69.5H0v32h112.2V171h32.1v-69.5h112.2v-32H144.3z" />
      <path d="M156.1 115.2 256.5 171v-15.8l-72-40zm-84.1 0-72 40V171l100.4-55.8zm28.4-59.4L0 0v15.8l72 40zm84.1 0 72-40V0L156.1 55.8z" />
    </g>
  </svg>
)

export var VI = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 341.3" {...rest}>
    {title && <title>{title}</title>}
<path fill="#FFF" d="M0 0h512v341.3H0z" />
    <path
      fill="#1583C4"
      d="m397.7 166.3-51 97.7c-1.1 2-.3 4.5 1.8 5.6 2 1.1 4.5.3 5.6-1.8l51-97.7c1-2.1.1-4.6-2-5.5-2-.9-4.3-.2-5.4 1.7z"
    />
    <path
      fill="#1583C4"
      d="m404.9 188-57.8 75.4c-1.3 1.9-.8 4.5 1.1 5.8 1.7 1.2 4.1.9 5.5-.7l57.8-75.4c1.4-1.8 1.1-4.4-.8-5.8-1.8-1.5-4.4-1.1-5.8.7z"
    />
    <path
      fill="#1583C4"
      d="m379 181.3-32.5 83.1c-.8 2.1.2 4.6 2.4 5.4 2.1.8 4.6-.2 5.4-2.4l32.5-83.1c.7-2.2-.4-4.5-2.6-5.3-2.1-.6-4.3.4-5.2 2.3z"
    />
    <path
      fill="#409347"
      d="M122.1 171.9c.4 1.7 1.2 4.7 2.2 8.5 1.7 6.4 3.6 12.8 5.6 18.7 2.3 6.9 14.7 31.4 20.2 39.1 6.9 9.7 14.1 19.3 21.5 28.6 1.6 1.9 4.5 2.1 6.4.5 1.8-1.6 2.1-4.3.7-6.2-7.3-9.2-14.4-18.6-21.2-28.2-4.2-5.8-17.2-31.1-19-36.7-2.9-8.7-5.4-17.6-7.6-26.5-.5-2.4-2.9-4-5.3-3.5s-4 2.9-3.5 5.3c-.1.2 0 .3 0 .4z"
    />
    <g fill="#FFD836" stroke="#231F20" strokeMiterlimit={10}>
      <path d="M297.1 114.9S279.5 42.8 261 42.8c-6.9 0-11.9-.6-15.4 6.4-.9 1.7-20.7-1.6-19.1 20.8.5 6.9 1.1-9.8 14.9-3.4 6.3 3-16.4 48.2-16.4 48.2h72.1z" />
      <path d="m466.1 48.4-90.9 22c-75.3 18.3-42.1 44.4-42.1 44.4l-72.1 12-72.1-12s33.2-26.1-42.1-44.4l-90.9-22C43.1 45.3 38.1 51.8 45.3 63c0 0 106.6 104 126.8 112 20.2 8.1 40.8 0 40.8 0s-14.9 8.7-24 24c-9.2 15.3-4.6 34.7-38.9 40.2-5.5 6.6-5 14 2.9 19.9 7.9 5.8 72.1-48.1 72.1-48.1s-24 24.4-24 36.1c0 5.1 44.1 53.8 60.1 53.8s60.1-48.7 60.1-53.8c0-11.7-24-36.1-24-36.1s64.2 53.9 72.1 48.1 11.4-19.3 2.8-19.9c-28-1.8-29.7-24.9-38.9-40.2-9.2-15.3-24-24-24-24s20.6 8.1 40.8 0S476.7 63 476.7 63c7.2-11.2 2.3-17.7-10.6-14.6z" />
    </g>
    <path
      fill="#FFF"
      stroke="#231F20"
      strokeMiterlimit={10}
      d="M201.3 111.8v80.3c0 45.7 59.7 59.7 59.7 59.7s59.7-14 59.7-59.7v-80.3H201.3z"
    />
    <path
      d="M225.2 137.7V235c8.2 6 17 10.2 23.9 12.9V137.7h-23.9zm71.6 0V235c-8.2 6-17 10.2-23.9 12.9V137.7h23.9z"
      fill="#D80027"
    />
    <path fill="#0052B4" d="M201.3 111.8h119.4v37.9H201.3z" />
    <path
      fill="#1583C4"
      d="m60.1 210.5-21.9-58.1H15.7l31.8 80.8h25.2l31.5-80.8H81.7zm391.4-58.6h18.9v81.7h-18.9z"
    />
  </svg>
)

export var VN = ({ title, ...rest }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 85.333 512 341.333"
    {...rest}
  >
    {title && <title>{title}</title>}
<path fill="#D80027" d="M196.641 85.337H0v341.326h512V85.337z" />
    <path
      fill="#FFDA44"
      d="m256 157.279 22.663 69.747H352l-59.332 43.106 22.664 69.749L256 296.774l-59.332 43.107 22.664-69.749L160 227.026h73.337z"
    />
  </svg>
)

export var VU = ({ title, ...rest }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 85.333 512 341.333"
    {...rest}
  >
    {title && <title>{title}</title>}
<path d="M0 85.337h512v341.326H0z" />
    <path fill="#6DA544" d="M512 256v170.663H0L215.185 256z" />
    <path fill="#D80027" d="M512 85.337V256H215.185L0 85.337z" />
    <path d="M221.001 239.304 26.868 85.337H8.956l208.168 165.098H512v-11.131zM8.956 426.663h17.912l194.133-153.967H512v-11.131H217.124zM0 92.44v14.206L188.317 256 0 405.354v14.205L206.229 256z" />
    <g fill="#FFDA44">
      <path d="M8.956 85.337H0v7.103L206.229 256 0 419.559v7.104h8.956l208.168-165.098H512v-11.13H217.124z" />
      <path d="M63.718 292.382v-14.295c14.265 0 25.87-11.606 25.87-25.869 0-10.092-8.211-18.303-18.304-18.303-6.875 0-12.469 5.593-12.469 12.469 0 4.397 3.577 7.974 7.974 7.974a4.514 4.514 0 0 0 4.508-4.508h14.295c0 10.368-8.435 18.804-18.802 18.804-12.279-.002-22.269-9.993-22.269-22.271 0-14.758 12.006-26.764 26.764-26.764 17.975 0 32.599 14.623 32.599 32.599 0 22.145-18.018 40.164-40.166 40.164z" />
    </g>
  </svg>
)

export var WF = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 150 100" {...rest}>
    {title && <title>{title}</title>}
<path fill="#D80B30" d="M0 0h150v100H0z" />
    <path fill="#00318A" d="M0 0h20v44.33H0z" />
    <path fill="#FFF" d="M20 0h20v44.33H20z" />
    <path fill="none" stroke="#FFF" strokeWidth={3} d="M0 44.33h62.75V0" />
    <path
      fill="#FFF"
      d="M108.08 43.29 87.96 23.17h40.25l-20.13 20.12zm-6.7 6.71L81.25 29.88v40.25L101.38 50zm6.7 6.71L87.96 76.83h40.25l-20.13-20.12zm6.71-6.71 20.13-20.13v40.25L114.79 50z"
    />
  </svg>
)

export var WS = ({ title, ...rest }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 85.333 512 341.333"
    {...rest}
  >
    {title && <title>{title}</title>}
<path fill="#D80027" d="M0 85.331h512v341.337H0z" />
    <path fill="#0052B4" d="M0 85.331h256v170.663H0z" />
    <path
      d="m165.483 181.79 2.764 8.504h8.939l-7.232 5.254 2.763 8.503-7.234-5.255-7.233 5.255 2.763-8.503-7.233-5.254h8.94zm-44.904-66.783 4.606 14.173h14.9l-12.055 8.757 4.605 14.171-12.056-8.758-12.054 8.758 4.605-14.171-12.056-8.757h14.901zm44.522 14.841 4.606 14.172h14.9l-12.055 8.757 4.604 14.173-12.055-8.76-12.054 8.76 4.604-14.173-12.055-8.757h14.9zm-35.192 59.363 4.606 14.172h14.9l-12.055 8.758 4.604 14.171-12.055-8.759-12.054 8.759 4.604-14.171-12.055-8.758h14.9zm-39.01-37.103 4.605 14.173h14.9l-12.055 8.757 4.604 14.173-12.054-8.76-12.055 8.76 4.604-14.173-12.055-8.757h14.9z"
      fill="#FFF"
    />
  </svg>
)

export var XA = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" {...rest}>
    {title && <title>{title}</title>}
<path fill="#FFF" d="M0 0h513v342H0z" />
    <path
      d="M0 0h513v48.8H0zm0 97.5h513v48.8H0zM0 195h513v48.8H0zm0 97.6h513v48.8H0z"
      fill="#6DA544"
    />
    <path fill="#D80027" d="M0 0h256.5v146.3H0z" />
    <path
      fill="#FFF"
      d="m116.9 114.4-7.5-14.8V69.9L128 59l18.6 10.9v22.3l7.4-7.4 4.2 3-4.2 11.8-14.9 14.8z"
    />
    <circle fill="#FFF" cx={82} cy={82.8} r={5.4} />
    <circle fill="#FFF" cx={90.8} cy={61.7} r={5.4} />
    <circle fill="#FFF" cx={106.6} cy={46.2} r={5.4} />
    <circle fill="#FFF" cx={128} cy={40.8} r={5.4} />
    <circle fill="#FFF" cx={149.4} cy={46.2} r={5.4} />
    <circle fill="#FFF" cx={165.2} cy={61.7} r={5.4} />
    <circle fill="#FFF" cx={174} cy={82.8} r={5.4} />
  </svg>
)

export var XC = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 900 600" {...rest}>
    {title && <title>{title}</title>}
<path d="M0 0h900v600H0z" fill="#fff" />
    <circle fill="#e30a17" cx={300} cy={300} r={150} />
    <circle cx={337.5} cy={300} r={120} fill="#fff" />
    <path
      fill="#e30a17"
      d="M0 60h900v60H0zm0 420h900v60H0zm417.5-180 135.676-44.084-83.852 115.413V228.671l83.852 115.413z"
    />
  </svg>
)

export var XK = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 341.33" {...rest}>
    {title && <title>{title}</title>}
<path fill="#0052B4" d="M0 0h512v341.34H0z" />
    <path
      d="m220.72 42.63 7.95 16.11 17.77 2.58-12.86 12.54 3.04 17.7-15.9-8.36-15.9 8.36 3.03-17.7-12.86-12.54 17.78-2.58zm70.56-.06 7.95 16.1 17.78 2.59-12.86 12.53 3.03 17.71-15.9-8.36-15.9 8.36 3.04-17.71-12.86-12.53 17.77-2.59zm62.08 11.36 7.95 16.11 17.77 2.58-12.86 12.54 3.04 17.7-15.9-8.35-15.9 8.35 3.04-17.7-12.87-12.54 17.78-2.58zm63.01 18.3 7.95 16.11 17.77 2.59-12.86 12.53 3.04 17.71-15.9-8.36-15.9 8.36 3.03-17.71-12.86-12.53 17.78-2.59zm-257.73-18.3 7.95 16.11 17.78 2.58-12.87 12.54 3.04 17.7-15.9-8.35-15.9 8.35 3.04-17.7-12.86-12.54 17.77-2.58zm-63.01 18.3 7.95 16.11 17.78 2.59-12.86 12.53 3.03 17.71-15.9-8.36-15.9 8.36 3.04-17.71-12.86-12.53 17.77-2.59z"
      fill="#FFF"
    />
    <path
      fill="#FFDA44"
      d="m217.53 259.33-27.22-13.61-27.22-54.43h27.22l27.22-27.22 13.61-27.22 27.22-13.61 13.61 13.61 27.22 13.61v13.61l13.61 13.61 40.83 27.22L340 245.73l-40.83 40.83-13.61-27.22-40.83 27.22v27.22l-13.61-13.61-13.59-40.84z"
    />
  </svg>
)

export var XO = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 450 300" {...rest}>
    {title && <title>{title}</title>}
<path fill="#FFF" d="M0 0h450v300H0z" />
    <path fill="red" d="M0 100h450v200H0z" />
    <path fill="#FFDF00" d="M0 200h450v100H0z" />
  </svg>
)

export var YE = ({ title, ...rest }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 85.333 512 341.333"
    {...rest}
  >
    {title && <title>{title}</title>}
<path fill="#FFF" d="M0 85.337h512v341.326H0z" />
    <path fill="#D80027" d="M0 85.337h512v113.775H0z" />
    <path d="M0 312.888h512v113.775H0z" />
  </svg>
)

export var YT = ({ title, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90 60" {...rest}>
    {title && <title>{title}</title>}
<path fill="#FFF" d="M0 0h90v60H0z" />
    <path
      stroke="#7f7f7f"
      strokeWidth={0.25}
      fill="#ABABAB"
      d="M75.6 39.6c-1.1.7 0 1.8-.6 1.9-.6.1-1.5-1.4-.2-2.5 1.6-1.5 5.8 0 5.9 4.3 0 2.2-.9 6.8-7.2 6.8-7.6 0-11.4-5.7-11.4-11.4 0-4.8 3.7-13.5 6.5-14.6 3.1-1.2 6.7-3.5 6.8-5 0-.5-1.4-.1-3.3.9-3.1 1.7-6.6 2.5-6.6 1.4s2.9-3.1 4-4.6c1.2-1.6.9-5.5 3-5.5 7.6 0 9.9 7.7 7 11.7-1.9 2.6 4.3 1 4.3 1s0 5.3-3.2 7.3c-3 1.8-4.8 3.9-4.8 3.9s.2-4.6-.5-3.9c-.6.7-11.1 4.5-10.3 12 .3 3 4.5 5.4 8.5 5.2s5.7-2.4 5.8-4.9c.1-3.9-3-4.4-3.7-4zm-64.9 4c.1 2.5 1.8 4.7 5.8 4.9s8.2-2.2 8.5-5.2c.8-7.5-9.7-11.3-10.3-12-.7-.7-.5 3.9-.5 3.9s-1.8-2.1-4.8-3.9c-3.2-2-3.2-7.3-3.2-7.3s6.2 1.6 4.3-1c-2.9-4-.6-11.7 7-11.7 2.1 0 1.8 3.9 3 5.5 1.1 1.5 4 3.5 4 4.6s-3.5.3-6.6-1.4c-1.9-1-3.3-1.4-3.3-.9.1 1.5 3.7 3.8 6.8 5 2.8 1.1 6.5 9.8 6.5 14.6 0 5.7-3.8 11.4-11.4 11.4-6.3 0-7.2-4.6-7.2-6.8.1-4.3 4.3-5.8 5.9-4.3 1.2 1.1.4 2.7-.2 2.5-.6-.1.6-1.2-.6-1.9-.6-.4-3.7.1-3.7 4z"
    />
    <path
      fill="#DE393A"
      d="M31 28.8v14c0 1.9 2.1 1.6 2.1 1.6h9.3c1.2 0 2.6 2.3 2.6 2.3s1.4-2.3 2.5-2.3h9.6s2 .2 2-1.8V28.7H31z"
    />
    <path fill="#3951A3" d="M31 13.1h28v15.7H31z" />
    <path
      fill="#FFF"
      d="M50.1 16.5c-.4 2.4-2.5 4.2-5.1 4.2-2.5 0-4.6-1.8-5.1-4.2-.5.9-.8 1.9-.8 3 0 3.3 2.6 5.9 5.9 5.9 3.3 0 5.9-2.6 5.9-5.9 0-1.1-.3-2.1-.8-3z"
    />
    <circle fill="#FEE05F" cx={39.1} cy={36.5} r={3} />
    <circle fill="#FEE05F" cx={50.9} cy={36.5} r={3} />
  </svg>
)

export var ZA = ({ title, ...rest }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 85.333 512 341.333"
    {...rest}
  >
    {title && <title>{title}</title>}
<path fill="#FFF" d="M0 85.337h512v341.326H0z" />
    <path d="M114.024 256.001 0 141.926v228.17z" />
    <path
      fill="#ffb915"
      d="M161.192 256 0 94.7v47.226l114.024 114.075L0 370.096v47.138z"
    />
    <path
      fill="#007847"
      d="M509.833 289.391c.058-.44.804-.878 2.167-1.318v-65.464H222.602L85.33 85.337H0V94.7L161.192 256 0 417.234v9.429h85.33l137.272-137.272h287.231z"
    />
    <path
      fill="#000c8a"
      d="M503.181 322.783H236.433l-103.881 103.88H512v-103.88z"
    />
    <path
      fill="#e1392d"
      d="M503.181 189.217H512V85.337H132.552l103.881 103.88z"
    />
  </svg>
)

export var ZM = ({ title, ...rest }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 85.333 512 341.333"
    {...rest}
  >
    {title && <title>{title}</title>}
<path fill="#496E2D" d="M0 85.331h512v341.337H0z" />
    <path
      fill="#FF9811"
      d="M490.668 195.476h-48c0-8.836-7.164-16-16-16s-16 7.164-16 16h-48c0 8.836 7.697 16 16.533 16h-.533c0 8.836 7.162 16 16 16 0 8.836 7.162 16 16 16h32c8.836 0 16-7.164 16-16 8.836 0 16-7.164 16-16h-.533c8.837 0 16.533-7.164 16.533-16z"
    />
    <path fill="#D80027" d="M341.337 255.994h56.888v170.663h-56.888z" />
    <path fill="#FF9811" d="M455.112 255.994H512v170.663h-56.888z" />
    <path d="M398.225 255.994h56.888v170.663h-56.888z" />
  </svg>
)

export var ZW = ({ title, ...rest }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 85.333 512 341.333"
    {...rest}
  >
    {title && <title>{title}</title>}
<path d="M0 85.333h512V426.67H0z" />
    <path d="M0 134.196h512v48.868H0zm0 195.472h512v48.868H0z" fill="#FFDA44" />
    <path fill="#057f44" d="M0 85.333h512v48.868H0z" />
    <path d="M0 183.069h512v48.868H0zm0 97.737h512v48.868H0z" fill="#D80027" />
    <path fill="#057f44" d="M0 378.542h512v48.128H0z" />
    <path fill="#FFF" d="M276.992 255.996 106.329 426.659H0V85.333h106.329z" />
    <path d="M256 255.996 85.334 426.662h20.987l170.667-170.666L106.321 85.33H85.334z" />
    <path
      fill="#D80027"
      d="m102.465 202.57 13.259 40.812h42.917l-34.718 25.226 13.26 40.814-34.718-25.224-34.72 25.224 13.262-40.814-34.718-25.226h42.915z"
    />
    <path
      fill="#FFDA44"
      d="m138.94 259.335-34.559-12.243s-2.553-23.955-2.708-24.766c-1.173-6.18-6.603-10.851-13.123-10.851-7.376 0-13.357 5.98-13.357 13.357 0 1.223.178 2.402.486 3.528l-9.689 9.755h17.229c0 17.882-13.344 17.882-13.344 35.691l7.402 17.809h44.522l7.422-17.809h-.004a17.782 17.782 0 0 0 1.381-5.231c6.397-2.589 8.342-9.24 8.342-9.24z"
    />
  </svg>
)

export default {
	AC: AC,
	AD: AD,
	AE: AE,
	AF: AF,
	AG: AG,
	AI: AI,
	AL: AL,
	AM: AM,
	AO: AO,
	AQ: AQ,
	AR: AR,
	AS: AS,
	AT: AT,
	AU: AU,
	AW: AW,
	AX: AX,
	AZ: AZ,
	BA: BA,
	BB: BB,
	BD: BD,
	BE: BE,
	BF: BF,
	BG: BG,
	BH: BH,
	BI: BI,
	BJ: BJ,
	BL: BL,
	BM: BM,
	BN: BN,
	BO: BO,
	BQ_BO: BQ_BO,
	BQ_SA: BQ_SA,
	BQ_SE: BQ_SE,
	BQ: BQ,
	BR: BR,
	BS: BS,
	BT: BT,
	BV: BV,
	BW: BW,
	BY: BY,
	BZ: BZ,
	CA: CA,
	CC: CC,
	CD: CD,
	CF: CF,
	CG: CG,
	CH: CH,
	CI: CI,
	CK: CK,
	CL: CL,
	CM: CM,
	CN: CN,
	CO: CO,
	CR: CR,
	CU: CU,
	CV: CV,
	CW: CW,
	CX: CX,
	CY: CY,
	CZ: CZ,
	DE: DE,
	DJ: DJ,
	DK: DK,
	DM: DM,
	DO: DO,
	DZ: DZ,
	EC: EC,
	EE: EE,
	EG: EG,
	EH: EH,
	ER: ER,
	ES_CT: ES_CT,
	ES: ES,
	ET: ET,
	EU: EU,
	FI: FI,
	FJ: FJ,
	FK: FK,
	FM: FM,
	FO: FO,
	FR: FR,
	GA: GA,
	GB_ENG: GB_ENG,
	GB_NIR: GB_NIR,
	GB_SCT: GB_SCT,
	GB_WLS: GB_WLS,
	GB: GB,
	GD: GD,
	GE: GE,
	GF: GF,
	GG: GG,
	GH: GH,
	GI: GI,
	GL: GL,
	GM: GM,
	GN: GN,
	GP: GP,
	GQ: GQ,
	GR: GR,
	GS: GS,
	GT: GT,
	GU: GU,
	GW: GW,
	GY: GY,
	HK: HK,
	HM: HM,
	HN: HN,
	HR: HR,
	HT: HT,
	HU: HU,
	IC: IC,
	ID: ID,
	IE: IE,
	IL: IL,
	IM: IM,
	IN: IN,
	IO: IO,
	IQ: IQ,
	IR: IR,
	IS: IS,
	IT: IT,
	JE: JE,
	JM: JM,
	JO: JO,
	JP: JP,
	KE: KE,
	KG: KG,
	KH: KH,
	KI: KI,
	KM: KM,
	KN: KN,
	KP: KP,
	KR: KR,
	KW: KW,
	KY: KY,
	KZ: KZ,
	LA: LA,
	LB: LB,
	LC: LC,
	LI: LI,
	LK: LK,
	LR: LR,
	LS: LS,
	LT: LT,
	LU: LU,
	LV: LV,
	LY: LY,
	MA: MA,
	MC: MC,
	MD: MD,
	ME: ME,
	MF: MF,
	MG: MG,
	MH: MH,
	MK: MK,
	ML: ML,
	MM: MM,
	MN: MN,
	MO: MO,
	MP: MP,
	MQ: MQ,
	MR: MR,
	MS: MS,
	MT: MT,
	MU: MU,
	MV: MV,
	MW: MW,
	MX: MX,
	MY: MY,
	MZ: MZ,
	NA: NA,
	NC: NC,
	NE: NE,
	NF: NF,
	NG: NG,
	NI: NI,
	NL: NL,
	NO: NO,
	NP: NP,
	NR: NR,
	NU: NU,
	NZ: NZ,
	OM: OM,
	PA: PA,
	PE: PE,
	PF: PF,
	PG: PG,
	PH: PH,
	PK: PK,
	PL: PL,
	PM: PM,
	PN: PN,
	PR: PR,
	PS: PS,
	PT: PT,
	PW: PW,
	PY: PY,
	QA: QA,
	RE: RE,
	RO: RO,
	RS: RS,
	RU: RU,
	RW: RW,
	SA: SA,
	SB: SB,
	SC: SC,
	SD: SD,
	SE: SE,
	SG: SG,
	SH: SH,
	SI: SI,
	SJ: SJ,
	SK: SK,
	SL: SL,
	SM: SM,
	SN: SN,
	SO: SO,
	SR: SR,
	SS: SS,
	ST: ST,
	SV: SV,
	SX: SX,
	SY: SY,
	SZ: SZ,
	TA: TA,
	TC: TC,
	TD: TD,
	TF: TF,
	TG: TG,
	TH: TH,
	TJ: TJ,
	TK: TK,
	TL: TL,
	TM: TM,
	TN: TN,
	TO: TO,
	TR: TR,
	TT: TT,
	TV: TV,
	TW: TW,
	TZ: TZ,
	UA: UA,
	UG: UG,
	UM: UM,
	US: US,
	UY: UY,
	UZ: UZ,
	VA: VA,
	VC: VC,
	VE: VE,
	VG: VG,
	VI: VI,
	VN: VN,
	VU: VU,
	WF: WF,
	WS: WS,
	XA: XA,
	XC: XC,
	XK: XK,
	XO: XO,
	YE: YE,
	YT: YT,
	ZA: ZA,
	ZM: ZM,
	ZW: ZW
}